<template>
    <div style="margin-top:-25px">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 text-left">
                <h2 style="font-size: 40px; font-weight: 700; line-height: 48px; " class="mb-0 mt-2">Campaign Management</h2>
            </div>
         
        </div>
        <div class="pt-3 pb-3">&nbsp;</div>

        <div class="row" id="processingArea">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <!-- <card> -->

                    <div class="d-flex flex-wrap" style="justify-content: space-between; gap:8px;">
                        <div class="d-flex align-items-center flex-wrap small-width-full" style="column-gap:8px;row-gap:20px">

                            <div class='campaign-filter-item-wrapper'>
                                        <span style="opacity:0.3">Showing</span>
                                        <span v-for="(filter, index) in optionCampaignStatus" @click="applyFilter(filter)" :class="['--filter-item',{'--active':filterCampaignStatus === filter.value,'--disabled': fetchingCampaignData}]" :key='index'>{{filter.label}}</span>
                                        <!-- <span class="--filter-item">Running</span>
                                        <span class="--filter-item">Paused</span>
                                        <span class="--filter-item">Stopped</span> -->
                                        <!-- <span class="--filter-item">Archived</span> -->
                            </div>
                            <div class="container__input__campaign__management">
                                <base-input class="mb-0">
                                    <el-input type="text" class="search-input input__campaign__management" clearable prefix-icon="el-icon-search"
                                        placeholder="Search" v-model="searchQuery" aria-controls="datatables" @keyup.native.enter="searchKeyWord" @clear="searchKeyWord">
                                    </el-input>
                                </base-input>
                            </div>
                            <SelectClientDropdown class="client-filter-anchor"></SelectClientDropdown>
                        
                          
                        </div>
                        <div class="container__filter__campaign__management">
                            <div>
                               
                                <base-button size="sm" style="height:40px" class="button__filter__campaign__management create-campaign-anchor" @click="AddEditClient('')"
                                    v-if="this.$global.menuLeadsPeek_create || (userType == 'client' && disabledaddcampaign && (this.$store.getters.userData.manual_bill == 'F' || this.$store.getters.userData.company_parent == '1251'))">
                                    <i class="fas fa-plus-circle"></i> Add Campaign
                                </base-button>
                                <base-button   size="sm" style="height:40px" class="button_filtercampaign_management" @click="startTour"
                                   >
                                    <i class="fas fa-question-circle"></i> Help
                                </base-button>
                            </div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div v-if="fetchingCampaignData" >
                            <div style="min-height: 40vh; display: flex; justify-content: center; align-items: center;">
                                <i class="fas fa-spinner fa-spin" style="font-size: 40px;"></i>
                            </div>
                        </div>
                        <div v-else class='mt-3 mt-md-5 d-flex flex-column campaigns__item-wrapper' style='gap: 16px' >
                            <card   class="mb-0" v-for="(campaign,index) in queriedData" :key="campaign.leadspeek_api_id">
                                <div class='d-flex justify-content-between align-items-center flex-wrap cursor-pointer '>
                                    <div class='campaign-card-title-info-wrapper' @click.stop>
                                        <!-- <span class="card-icon-styling" :style='{backgroundColor:colorOptions[(index * 7) % 4 + 1].background}'>
                                            <i class="fa-solid fa-bullhorn" :style="{color:colorOptions[(index * 7) % 4 + 1].color}"></i>
                                        </span> -->
                                        <div class='align-items-center d-flex flex-wrap' style='gap:16px'>
                                            <div class='campaign-card-title-info'>
                                                <span class='campaign-card-client-name'>{{campaign.company_name}}</span>
                                                <span class="campain-card-name d-flex justify-content-between"><span class='campaign-name-ellips'>{{campaign.campaign_name}} </span> <span class='arrows'><i class="fa-solid fa-arrow-up" :style="{opacity: currOrderBy == 'ascending' ? 0.3 : 0.6}" @click.stop="sortdynamic('campaign_name','ascending')"></i><i :style="{opacity: currOrderBy == 'descending' ? 0.3 : 0.6}" class="fa-solid fa-arrow-down" @click.stop="sortdynamic('campaign_name','descending')"></i></span></span>
                                                <span v-if="campaign.last_lead_added" class='campaign-card-update-date'>Last updated on {{campaign.last_lead_added}}</span>
                                            </div>
                                            <div v-if="campaign.disabled == 'F' && campaign.active_user == 'T'" class='campaign-card-status-badge' style="background:rgb(0, 81, 97);color:white"><span >Running</span></div>
                                            <div v-if="campaign.disabled == 'T' && campaign.active_user == 'T'" class='campaign-card-status-badge' style="background:#fdae61"><span>Paused</span></div>
                                            <div v-if="campaign.active_user == 'F'" class='campaign-card-status-badge' style="background:rgb(147, 2, 30);color:white"><span >Stopped</span></div>
                                            <div v-if="campaign.campaign_never_started == 'T' && campaign.active_user == 'F' && campaign.total_leads == '0'" class='campaign-card-status-badge' style="background:rgb(88, 92, 102);color:white"><span >Never Started</span></div>
                                        
                                        </div>

                                    </div>
                                    <div class='d-flex justify-content-between align-items-center flex-wrap campaign-card-right-wrapper'>

                                        <div class='campaign-card-stat-wrapper'>
                                            <div data-v-step="6" class='campaign-card-stat-block stat-block-id-anchor'>
                                                <span class='--stat-block-title'>ID</span>
                                                <span class='--stat-block-value'>{{campaign.leadspeek_api_id}}
                                                    <span v-if="$global.globalviewmode && userTypeOri != 'sales' && $global.rootcomp && ($global.user_permissions == null || $global.user_permissions.report_analytics)">
                                                    <span v-if="campaign.leadspeek_api_id != ''" class="pl-2"><a
                                                                :href="'/configuration/report-analytics/?campaignid=' + campaign.leadspeek_api_id + ''"
                                                                target="_blank"><i class="fas fa-file-chart-line"
                                                                    style="color:gray"></i></a></span>
                                                    </span>
                                                </span>
                                            </div>
                                            <div class='campaign-card-stat-block stat-block-total-anchor'>
                                                <span class='--stat-block-title'>Total</span>
                                                <span class='--stat-block-value'>{{campaign.total_leads}}</span>
                                            </div>
                                            <div class='campaign-card-stat-block stat-block-yesterday-anchor'>
                                                <span class='--stat-block-title'>Yesterday's</span>
                                                <span class='--stat-block-value'> <span :style="{ color: campaign.yerterday_leads > 1.1 * campaign.yerterday_previous_leads ? 'green' : campaign.yerterday_leads < 0.9 * campaign.yerterday_previous_leads ? 'red' : '' }">{{campaign.yerterday_leads}}</span></span>
                                            </div>
                                        </div>
                                        <div class='campaign-card-actions-block --site-id flex-column'>
                                            <div class='campaign-card-actions-block --site-id'>
                                                <el-popover
                                                        content="Edit This Campaign"
                                                        effect="light"
                                                        placement="top"
                                                        trigger="hover"
                                                    >
                                                         <span slot="reference" @click='rowClicked(index, campaign)' class="card-action-icon-wrapper edit-btn-anchor">
                                                             <i class="fa-solid fa-pen"></i>
                                                         </span>
                                                </el-popover>

                                                <el-popover content="View Embed Code" effect="light" placement="top" trigger="hover">
                                                    <span slot="reference" @click.stop="handleEmbededCode(index, campaign)" class="card-action-icon-wrapper embed-code-button">
                                                        <i class="fas fa-code"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover content="Campaign Financials" trigger="hover" placement="top">
                                                    <span slot="reference" @click.stop="handlePriceSet(index, campaign)" class="card-action-icon-wrapper campaign-financials-btn">
                                                        <i class="fa-solid fa-dollar-sign"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover 
                                                    v-if="$global.hasVisibleIntegrations"
                                                    trigger="hover" 
                                                    placement="top" 
                                                    content="Configure integrations">
                                                    <span slot="reference" @click.stop="handleIntegrationClick(index, campaign)" class="card-action-icon-wrapper campaign-integration-btn">
                                                        <i class="fas fa-plug"></i>
                                                    </span>
                                                </el-popover>
                                                   <el-popover
                                                            v-if="!$global.globalviewmode"
                                                            :content="GoogleConnectTrue && campaign.spreadsheet_id != '' ? 'Go to Google Sheet' : 'Download Excel'"
                                                            placement="top"
                                                            trigger="hover"
                                                        >
                                                        <span slot="reference" class="card-action-icon-wrapper google-sheet-anchor">
                                                            <a v-if="GoogleConnectTrue && campaign.spreadsheet_id != ''" :href="'https://docs.google.com/spreadsheets/d/' + campaign.spreadsheet_id + '/edit#gid=0'" target="_blank"><i class="fab fa-google-drive"></i></a>
                                                            <i v-else class="fas fa-file-excel pl-2 pr-2" @click.stop="ExportLeadsData(index, campaign)"></i>
                                                        </span>    
                                                </el-popover>
                                                <el-popover
                                                    v-if="$global.globalviewmode"
                                                    :content="GoogleConnectTrue && campaign.spreadsheet_id != '' ? 'Go to Google Sheet' : 'Download Excel'"
                                                    effect="light"
                                                    placement="top"
                                                    trigger="hover"
                                                >
                                                    <span slot="reference" class="card-action-icon-wrapper google-sheet-anchor">
                                                        <a v-if="GoogleConnectTrue && campaign.spreadsheet_id != ''" :href="'https://docs.google.com/spreadsheets/d/' + campaign.spreadsheet_id + '/edit#gid=0'" target="_blank"><i class="fab fa-google-drive"></i></a>
                                                        <i v-else class="fas fa-file-excel pl-2 pr-2" @click.stop="ExportLeadsData(index, campaign)"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover trigger="hover" v-show="(campaign.payment_status != 'failed' || $store.getters.userData.manual_bill == 'T' ) &&  ( campaign.active_user == 'F' || (campaign.disabled == 'T' && campaign.active_user == 'T'))" :content="tooltip_campaign(index, campaign, 'play')" placement="top">
                                                    <span slot="reference" @click.stop="activepauseclient(index, campaign, 'play')" class="card-action-icon-wrapper play-pause-stop-anchor">
                                                        <i class="fas fa-play"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover trigger="hover" v-show="(campaign.disabled == 'F' && campaign.active_user == 'T')" :content="tooltip_campaign(index, campaign, 'pause')" effect="light" :open-delay="300" placement="top">
                                                    <span slot="reference" :class="{'cursornodrop': campaign.active_user == 'F' && (campaign.customer_card_id == '' && $store.getters.userData.manual_bill == 'F')}"  @click.stop="activepauseclient(index, campaign, 'pause')" class="card-action-icon-wrapper play-pause-stop-anchor" placement="top">
                                                        <i class="fas fa-pause"></i>
                                                    </span>
                                                </el-popover>
                                                <el-popover trigger="hover" v-show="(campaign.disabled == 'F' && campaign.active_user == 'T') || (campaign.disabled == 'T' && campaign.active_user == 'T')" :content="tooltip_campaign(index, campaign, 'stop')" placement="top">
                                                    <span slot="reference" @click.stop="handleDelete(index, campaign)" class="card-action-icon-wrapper play-pause-stop-anchor">
                                                        <i class="fas fa-stop"></i>
                                                    </span>
                                                </el-popover>
                                            </div>
                                            <!-- <div class='campaign-card-actions-block'>
                                                <el-tooltip content="View Embed Code" effect="light" :open-delay="300" placement="top">
                                                    <span @click="handleEmbededCode(index, campaign)" class="card-action-icon-wrapper">
                                                        <i class="fas fa-pencil"></i>
                                                    </span>
                                                </el-tooltip>
                                                <el-tooltip content="View Embed Code" effect="light" :open-delay="300" placement="top">
                                                    <span @click="handleEmbededCode(index, campaign)" class="card-action-icon-wrapper">
                                                        <i class="fas fa-pause"></i>
                                                    </span>
                                                </el-tooltip>
                                                <el-tooltip content="View Embed Code" effect="light" :open-delay="300" placement="top">
                                                    <span @click="handleEmbededCode(index, campaign)" class="card-action-icon-wrapper">
                                                        <i class="fas fa-play"></i>
                                                    </span>
                                                </el-tooltip>
                                                <el-tooltip content="View Embed Code" effect="light" :open-delay="300" placement="top">
                                                    <span @click="handleEmbededCode(index, campaign)" class="card-action-icon-wrapper">
                                                        <i class="fas fa-stop"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div> -->
                                            
                                        </div>
                                        <div @click.stop>
                                            <el-dropdown trigger="click">
                                                <span >
                                                    <i class="fa-solid fa-ellipsis-vertical menu-drop-anchor"></i>
                                                </span>
                                                <el-dropdown-menu slot="dropdown" >
                                                    <!-- <div @click.stop='rowClicked(index, campaign)'>
                                                        <el-dropdown-item >Edit</el-dropdown-item>
                                                    </div> -->
                                                    <!-- <div v-if="campaign.disabled == 'T' && campaign.active_user == 'T'" @click.stop="activepauseclient(index, campaign, 'play')">
                                                        <el-dropdown-item>Play</el-dropdown-item>
                                                    </div>
                                                    <div v-if="campaign.disabled == 'F' && campaign.active_user == 'T'" @click.stop="activepauseclient(index, campaign, 'pause')">
                                                        <el-dropdown-item >Pause</el-dropdown-item>
                                                    </div>
                                                    <div v-if="campaign.active_user != 'F'" @click.stop="handleDelete(index, campaign)">
                                                        <el-dropdown-item>Stop</el-dropdown-item>
                                                    </div> -->
                                                    <div @click.stop="archiveCampaign(index, campaign)">
                                                        <el-dropdown-item>Archive</el-dropdown-item>
                                                    </div>
                                                    <div @click.stop="showWhitelist(index, campaign)">
                                                        <el-dropdown-item>Exclusion</el-dropdown-item>
                                                    </div>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </card> 
                            <div class="align-items-center d-flex justify-content-center text-center" style="height: 200px;" v-if='queriedData.length <= 0'>
                                No campaigns found 
                            </div>  
                        </div>
                    </transition>

                 

                    <template >
                        <div class="tab-footer pull-right">
                            <div class="pt-3">
                                <p class="card-category">
                                    Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
                                </p>
                            </div>
                            <base-pagination class="pagination-no-border pt-4"
                            v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total="pagination.total"
                                        @input="changePage"
                                 >
                            </base-pagination>
                        </div>
                    </template>

                <!-- </card> -->
            </div>
        </div>

        <!-- Modal LeadSpeek Embedded Code -->
        <modal :show.sync="modals.embededcode" headerClasses="justify-content-center" >
            <h4 slot="header" class="title title-up">Client Embed Code</h4>
            <p class="text-center">
                This embed code is to be placed in the Header of your client's site.
                <!--The short code is a universal container that will not need manually updating as we will handle any needed code updates dynamically.-->
            </p>
            <div class="text-center" v-if="false">
                <textarea rows="1" cols="70"
                    id="universalembededcode"><script async src='https://tag.exactmatchmarketing.com/'></script></textarea>
                <div>
                    <a href="javascript:void(0);" id="universalembededcodeLink" class="far fa-clipboard"
                        @click="copytoclipboard('universalembededcode')"> Copy</a>
                </div>
            </div>
            <p class="text-center">
                The full code below for custom placements of the {{ leadlocalname }}.
            </p>
            <div class="text-center">
                <textarea rows="10" cols="70" id="leadspeekembededcode" class='w-100 w-md-auto'>

                                  </textarea>
                <div>
                    <a href="javascript:void(0);" id="leadspeekembededcodeLink" class="far fa-clipboard"
                        @click="copytoclipboard('leadspeekembededcode')"> {{ copyText }}</a>
                </div>
            </div>
            <div id="suppressioncode">
                <p class="text-center">
                    The below code is your client's Suppression code. This code is usually placed on a page where a contact can
                    already be identified as part of the customer journey, such as a check out page, or an email signup
                    confirmation page.
                </p>
                <div class="text-center">
                    <textarea rows="2" cols="90" id="leadspeekembededcodesupression">

                                        </textarea>
                    <div>
                        <a href="javascript:void(0);" id="leadspeekembededcodesupressionLink" class="far fa-clipboard"
                            @click="copytoclipboard('leadspeekembededcodesupression')"> Copy</a>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <div class="container text-center pb-4">
                  
                    <base-button class="pull-right"  @click.native="modals.embededcode = false">Close</base-button>
                    <base-button v-if="this.$global.settingMenuShow && !this.$global.systemUser" simple size="sm" class="mr-4 pull-right" style="height:40px"
                     @click="openHelpModal(1)">
                     <i class="fas fa-question"></i>
                    </base-button>
                </div>
            </template>
            <div class="mt-3">
                <div style="display: flex;">
                        <el-popover
                            placement="right"
                            trigger="click"
                            v-model="isPopOverCheckEmbedCode"
                            :disabled="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isLoadingSendTestEmbedCode"
                        >
                        <div style="min-width: 300px;">
                            <div style="display: flex; justify-content: center; margin-bottom: 16px;">
                                <p style="color: #000000; margin-bottom: 0px; font-weight: 600; font-size: 16px;">Please select a URL to test.</p>
                            </div>
                            <div style="display: flex; flex-direction: column; gap: 8px;">
                               <el-card v-for="(url, index) in parsedUrls" :key="index" style="width: 100%; cursor: pointer; position: relative;" :class="urlActive == url ? 'two__fa__active' : ''" :shadow="urlActive == url ? 'always' : 'hover'" @click.native="onActiveUrl(url)">
                                    <p 
                                        :style="{ 
                                            color: urlActive === url ? '#409EFF' : '#000000', 
                                            marginBottom: '8px', 
                                            marginTop: '8px' 
                                        }"
                                        >
                                        {{ url }}
                                    </p>
                                    <span v-if="urlActive == url" style="top: 0; right: 0; position: absolute; background-color: #409EFF; color: white; padding: 0px 8px; font-size: 12px;">
                                        Selected
                                    </span>
                               </el-card>
                            </div>
                            <div style="margin-top: 16px;">
                                <el-button type="primary" style="width: 100%;" @click="onTestEmbedCode">Submit</el-button>
                            </div>
                        </div>

                        <div slot="reference" style="display: flex; gap: 8px; align-items: center; ">
                            <el-button
                            size="medium"
                            :icon="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isLoadingSendTestEmbedCode ? 'el-icon-loading' : 'el-icon-s-promotion'"
                            circle
                            :disabled="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isLoadingSendTestEmbedCode"
                            ></el-button>
                            <el-button type="text" :disabled="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isLoadingSendTestEmbedCode" style="margin-left: 0px;">Check Embed Code</el-button>
                        </div>
                        <div slot="reference" style="display: flex; gap: 8px; align-items: center; margin-top: 5px;">
                            <el-button
                            size="medium"
                            icon="el-icon-download"
                            circle
                            @click="downloadEmbedCode(`embeded_code_${selectedRowData.leadspeek_api_id}.txt`)"
                            ></el-button>
                            <el-button type="text" style="margin-left: 0px;" @click="downloadEmbedCode(`embeded_code_${selectedRowData.leadspeek_api_id}.txt`)">Download Embed Code</el-button>
                        </div>
                    </el-popover>
                </div>
            </div>

            <div v-if="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isErrorEmbededCode" class="error-banner">
                <p>{{ embedCodeStatus[selectedRowData.id].isErrorEmbededCodeMessage }}</p>
            </div>

            <div v-if="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isSuccessEmbededCode" class="success-banner">
                <p>{{ embedCodeStatus[selectedRowData.id].isSuccessEmbededCodeMessage }}</p>
            </div>

            <div v-if="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isErrorRunEmbededCode" class="error-banner">
                <p>{{ embedCodeStatus[selectedRowData.id].isErrorRunEmbededCodeMessage }}</p>
                <p style="font-size: small; padding-top: 2px; font-weight: bold; font-style: italic;">
                    * The target website has blocked our checking bot due to CORS security policy. CORS (Cross-Origin Resource Sharing) restrictions are security measures that prevent web pages from making requests to a different domain than the one that served the web page, unless the server explicitly allows it. CORS only stops our checking bot, but does not stop the identification code from working. Please manually check your code with this process here if you think their might be a problem with the code installation. 
                    <span @click="openHelpModal(1)" style="color: #409EFF; text-decoration: underline; cursor: pointer;">(Open question help video here)</span> 
                </p>
            </div>

            <div v-if="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isSuccessRunEmbededCode" class="success-banner">
                <p>{{ embedCodeStatus[selectedRowData.id].isSuccessRunEmbededCodeMessage }}</p>
            </div>
            <div v-if="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isLoadingSendTestEmbedCode" class="info-banner">
                <p><i class="el-icon-loading" style="margin-right: 8px; font-size: 18px;"></i>
                Please wait about a few minutes and do not refresh this page while the check is running. The results will display below.</p>
            </div>

            <div v-if="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isWarningEmbededCode" class="warning-banner">
                <p>{{ embedCodeStatus[selectedRowData.id].isWarningEmbededCodeMessage }}</p>
            </div>

            <div v-if="selectedRowData && embedCodeStatus[selectedRowData.id] && embedCodeStatus[selectedRowData.id].isIframeActive" class="iframe-container">
                <iframe
                    :src="iframeSrc"
                    width="0"
                    height="0"
                    frameborder="0"
                    @load="onLoadIframe"
                    ref="myIframe"
                ></iframe>
                <!-- <iframe
                    v-for="(url, index) in parsedUrls"
                    :key="index"
                    :src="`${url}?test=true`"
                    width="100"
                    height="10"
                    frameborder="0"
                ></iframe> -->
            </div>
        </modal>
        <!-- Modal LeadSpeek Embedded Code -->

        <!-- Modal General Information -->
        <modal :show.sync="modals.helpguide" headerClasses="justify-content-center" >
            <h4 slot="header" class="title title-up" v-html="modals.helpguideTitle"></h4>
            <p class="text-center" v-html="modals.helpguideTxt">
            </p>

            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="modals.helpguide = false">Close</base-button>
                </div>
            </template>
        </modal>
        <!-- Modal General Information -->

        <!-- QUESTIONNAIRE RESULT MODAL -->
        <modal id="modalQuestionnaire" :show.sync="modals.questionnaire" headerClasses="justify-content-center"
            >
            <h4 slot="header" class="title title-up">Questionnaire result for : <span style="color:#d42e66">{{
                LeadspeekCompany }}</span></h4>

            <div class="col-sm-12 col-md-12 col-lg-12">
                <p class="text-center"><strong>{{ leadlocalname }} Questionnaire</strong></p>
            </div>
            <div style="height:10px">&nbsp;</div>
            <p>- What is your campaign name?</p>
            <p class="qanswer pl-2">{{ questionnaire.campaign_name }}</p>

            <p>- What is your website address where you want to identify visitors and generate contacts?</p>
            <p class="qanswer pl-2" v-html="questionnaire.url_code">&nbsp;</p>

            <p>- The Privacy Policy on your website needs to have the proper disclosure verbiage in it to make it legal. We
                recommend you check your policy and speak with your legal council to insure something like the following:
                &quot;We collect information about our users via cookies and use the information primarily to provide you
                with a personalized Internet experience that delivers the information, resources, and services that are most
                relevant and helpful to you. To opt out, click here.&quot; Include a link to opt-out or an email address for
                them to do so.</p>
            <p class="qanswer pl-2" v-html="questionnaire.asec3_2">&nbsp;</p>
            <p v-if="false">- I agree that it is up to me to understand the law regarding collecting third party information
                via my website and will not hold Exact Match Marketing/Uncommon Reach accountable for any issues that may
                arise.</p>
            <p v-if="false" class="qanswer pl-2" v-html="questionnaire.asec3_3">&nbsp;</p>


            <div style="height:10px">&nbsp;</div>
            <div v-if="questionnaire.asec6_3 != '' || questionnaire.asec6_4 != '' || questionnaire.asec6_6 != ''">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <p class="text-center"><strong>Information for all campaign options</strong></p>
                    <p class="text-center"><small style="font-size:12px">All questions must be answered below.</small></p>
                </div>
                <div style="height:40px">&nbsp;</div>

                <p>- Besides yourself, please provide any additional email addresses (separated by a comma) of those you
                    wish to also have access to the contacts information sheet.</p>
                <p class="qanswer pl-2" v-html="questionnaire.asec6_3">&nbsp;</p>
                <p>- You can link the Google Sheet(s) to your CRM. If you want this to happen, do you know how to do it or
                    will you need our help to set it up?</p>
                <p class="qanswer pl-2" v-html="questionnaire.asec6_4">&nbsp;</p>

                <p>- Note: The contacts captured will have been filled out by the customer via an opt-in form. We have no
                    control over what they entered or if their personal information has changed from the time they completed
                    the form to now. (For example, they may have moved, gotten married and changed their last name, etc.) By
                    law, you are required to be CAN-SPAM compliant if you reach out via e-mail.</p>
                <p class="qanswer pl-2" v-html="questionnaire.asec6_6">&nbsp;</p>
            </div>


            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="modals.questionnaire = false">Close</base-button>
                </div>
            </template>
        </modal>
        <!-- QUESTIONNAIRE RESULT MODAL -->

        <!-- Modal Setting Markup -->
        <modal id="modalSetPrice" :show.sync="modals.pricesetup" headerClasses="justify-content-center" bodyClasses='create-campaign-modal-body'
    >
            <h4 slot="header" class="title title-up">Campaign Financials For: <span style="color:#000000">{{
                LeadspeekCompany }}</span></h4>
            <div style="display:none">
                <!--<iframe width="970" height="415" src="https://www.youtube.com/embed/SCSDyqRP7cY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
            </div>
            <div class="row" v-if="userType != 'client'">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="d-inline-block pr-4" v-if="false">
                        <label>Select Modules:</label>
                        <el-select class="select-primary" size="large" placeholder="Select Modules"
                            v-model="selectsAppModule.AppModuleSelect" style="padding-left:10px">
                            <el-option v-for="option in selectsAppModule.AppModule" class="select-primary"
                                :value="option.value" :label="option.label" :key="option.label">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="d-flex flex-column" style="margin-bottom:16px;">
                        <span class="client-payment-modal-form-label" style="color:#222a42">Billing Frequency</span>
                        <el-select class="select-primary" size="large" placeholder="Select Modules"
                            v-model="selectsPaymentTerm.PaymentTermSelect"
                            @change="paymentTermChange()" :disabled="LeadspeekInputReadOnly || OnlyPrepaidDisabled">
                            <el-option v-for="option in selectsPaymentTerm.PaymentTerm" class="select-primary"
                                :value="option.value" :label="option.label" :key="option.label">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
     
            <div v-if="selectsPaymentTerm.PaymentTermSelect == 'Prepaid'" class="mb-4 p-0">
                <div class="col-12 p-0 mt-2 mb-2">
                    <el-card shadow="never">
                        <div style="display: flex; justify-content: space-between; flex-wrap: wrap; align-items: center;">
                            <p class="mt-1">Your remaining balance is: <b>{{ remainingBalanceLeads }}</b> contacts</p>
                            <base-button v-if="this.$global.globalviewmode && this.$global.masteridsys == this.$global.idsys" type="button" @click.native="refundTopupPrepaid" :disabled="isProcessRefundPrepaid">
                                <span style="font-size: 18px; margin-right: 4px;">
                                    <i class="el-icon-refresh" :class="{ spinRefund: isProcessRefundPrepaid }"></i>
                                </span>
                                Refund
                            </base-button>
                        </div>
                    </el-card>
                </div>
                <div class="col-12 p-0 mt-3">
                    <p class="client-payment-modal-form-label" style="color:#222a42; font-size: 22px; font-weight: 700; text-align: center;">Top Up Options</p>
                </div>
                <div class="col-12 p-0 mt-3">
                    <el-tabs type="border-card" v-model="prepaidType">
                        <el-tab-pane name="continual" :disabled="prepaidType !== 'continual' && OnlyPrepaidDisabled" :style="prepaidType !== 'continual' && OnlyPrepaidDisabled ?  'cursor: not-allowed' : ''">
                            <span slot="label">
                                        Continual Top Up
                                        <el-badge v-if="prepaidType == 'continual'" value="Active" type="info" class="item ml-3 badge__active__topup__options">
                                            <span></span>
                                        </el-badge>
                            </span>
                            <div class="row">
                                <div class="col-12 mb-4">
                                    <p style="font-size: 14px; color: #6b7280;"> <span style="font-weight: 600;">Continual top up</span> will automatically top up your pool of pre-purchased contacts when it gets low. This will keep your campaign running until stopped. </p>
                                    
                                </div>
                                <div class="col-12 col-md-6">
                                    <el-switch
                                        v-if="selectsAppModule.LeadsLimitSelect == 'day'"
                                        v-model="contiDurationSelection"
                                        active-text="Monthly"
                                        inactive-text="Weekly"
                                        style="margin-bottom: 8px;"
                                        @change='updateWeeklyMonthlyToggle'
                                        >
                                    </el-switch>
                                    <!-- <p>{{contiDurationSelection ? 'Monthly' : 'Weekly'}} leads count will be: {{ contiDurationSelection ? (LeadspeekLimitLead * 7 ) * 4 : (LeadspeekLimitLead * 7)  }}</p> -->
                                    <p v-if="prepaidType == 'continual'">
                                        <template>
                                            Number of contacts to buy: 
                                            <b v-if="selectsAppModule.LeadsLimitSelect == 'day'">{{totalLeads.continualTopUp  }}</b>
                                            <b v-else>{{ LeadspeekLimitLead }}</b> 
                                            contact(S)
                                        </template>
                                    </p>     
                                </div>
                                <div class="col-12 col-md-6" v-if="prepaidType == 'continual'">
                                    <span class="client-payment-modal-form-label" style="color:#222a42">
                                        Automatic top up will occur when your pre-purchased contact amount
                                        <span v-if="selectsAppModule.LeadsLimitSelect == 'day'">drops below {{ LeadspeekLimitLead }}</span>
                                        <span v-else>has reached 0 and occurs on {{ LeadspeekInvoiceDateNextMonth }} </span>
                                    </span>
                                </div>
                                <div class="col-12 mt-2" v-if="selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && prepaidType == 'continual'">
                                    <base-button 
                                        class="bg-danger text-white" 
                                        @click="stopContinualTopUp" 
                                        :disabled="isContainulTopUpStop" 
                                        :class="{'bg-light': isContainulTopUpStop}">
                                        Stop Continual Top Up
                                    </base-button>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="onetime" :disabled="prepaidType !== 'onetime' && OnlyPrepaidDisabled" :style="prepaidType !== 'onetime' && OnlyPrepaidDisabled ? 'cursor: not-allowed' : ''">
                            <span slot="label">
                                One Time
                                        <el-badge v-if="prepaidType == 'onetime'" value="Active" type="info" class="item ml-3 badge__active__topup__options">
                                            <span></span>
                                        </el-badge>
                            </span>
                            <div class="row">
                                <div class="col-12 mb-4">
                                    <p style="font-size: 14px; color: #6b7280;"> <span style="font-weight: 600;">One time</span> campaigns will run until the number of purchased contacts have been used. You may manually add additional contacts to these campaigns as desired.</p>
                                </div>
                                <div class="col-12" v-if="prepaidType == 'onetime'">     
                                    <div class="d-flex justify-content-start align-items-center">
                                        <p>Number of contacts to buy:</p>
                                        <base-input 
                                            type="text" 
                                            placeholder="Minimum 50 contacts" 
                                            class="campaign-cost-input mx-1"
                                            v-model="totalLeads.oneTime"
                                            @input="validationLeadToBuy"
                                            @blur="validationMinLeadPrepaidOneTime"
                                            @keydown="event => restrictInput(event,'integer')"  @copy.prevent @cut.prevent @paste.prevent>
                                        </base-input>
                                        <p>contact(s)</p>
                                    </div>
                                    <span v-if="err_totalleads" style="font-size: 13px; color: #942434;">* Minimum 50 contact</span>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <div v-if="selectsAppModule.AppModuleSelect == 'LeadsPeek'">
                <div class="client-payment-setup-form-wrapper" style="gap: 0px;">
            <!-- <div class="col-12"> -->
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6 py-2">
                                <div v-if="userType != 'client'">
                                    <div class="client-payment-modal-form-label">
                                        Setup Fee
                                    </div>
                                    <div>
                                        <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                            class="campaign-cost-input" v-model="LeadspeekPlatformFee"
                                            :readonly="LeadspeekInputReadOnly" @keyup="profitcalculation();" @keydown="restrictInput" @blur="validationInput('LeadspeekPlatformFee')"  @copy.prevent @cut.prevent @paste.prevent>
                                        </base-input>
                                    </div>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time
                                            Creative/Set Up Fee is ${{ m_LeadspeekPlatformFee }}</span></div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6 py-2">
                                <div v-if="userType != 'client'">
                                    <div class="client-payment-modal-form-label">
                                        Campaign Fee <span v-html="txtLeadService">per month</span>
                                    </div>
                                    <div>
                                        <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                            class="campaign-cost-input" v-model="LeadspeekMinCostMonth"
                                            :readonly="LeadspeekInputReadOnly" @keyup="profitcalculation();" @keydown="restrictInput" @blur="validationInput('LeadspeekMinCostMonth')" @copy.prevent @cut.prevent @paste.prevent>
                                        </base-input>
                                    </div>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for charging
                                            your client for Platform Fee is $<span>{{ m_LeadspeekMinCostMonth }}</span></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-12"  
                        v-if="selectsPaymentTerm.PaymentTermSelect == 'One Time' && userType != 'client'">
                        <div class="client-payment-modal-form-label">
                            How many contacts are included <span v-html="txtLeadIncluded">in that weekly charge</span>?
                        </div>
                        <div>
                            <base-input label="" type="text" placeholder="0" class="frmSetCost black-center"
                                v-model="LeadspeekMaxLead" style="width:100px" :readonly="LeadspeekInputReadOnly"
                                @keyup="profitcalculation();" @keydown="restrictInput"  @copy.prevent @cut.prevent @paste.prevent>
                            </base-input>
                        </div>
                        <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per
                            contact is $<span>{{ m_LeadspeekCostperlead }}</span></span></div>
                    </div>
                    <div class="col-12">
                        <div class="row">
                            <div v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time' && userType != 'client'" class="col-sm-12 col-md-6 col-lg-6 py-2" style="padding-top: 0px !important;">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12 py-2">
                                        <div>
                                            <div class="client-payment-modal-form-label">
                                                Cost per contact
                                                <span v-html="txtLeadOver" v-if="false">from the monthly charge</span>? 
                                                ({{ this.campaign_information_type_local_includes_advanced ? 'Advanced' : 'Basic' }})
                                                <sup>
                                                    <el-tooltip
                                                    :content="helpContentMap[campaign_information_type_local_includes_advanced ? 4 : 3].desc"
                                                    effect="light"
                                                    :open-delay="300"
                                                    placement="top"
                                                    popper-class="tooltip-content"
                                                    >
                                                        <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                                    </el-tooltip>
                                                </sup>
                                                <!-- <sup>
                                                    <span style="cursor: pointer; font-size: 12px;"><i @click="openHelpModal(campaign_information_type_local_includes_advanced ? 4 : 3)" class="fa fa-question-circle"></i></span>
                                                </sup> -->
                                            </div>
                                            <div>
                                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                                    class="campaign-cost-input" v-model="LeadspeekCostperlead"
                                                    :readonly="LeadspeekInputReadOnly" @keyup="profitcalculation();" @keydown="restrictInput" @blur="validationInput('LeadspeekCostperlead')"  @copy.prevent @cut.prevent @paste.prevent>
                                                </base-input>
                                            </div>
                                            <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per
                                                contact is $<span>{{ m_LeadspeekCostperlead }}</span></span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class="userType != 'client' ? 'col-sm-12 col-md-6 col-lg-6 py-2' : 'col-12'">
                                <div class="row">
                                    <div 
                                        class="col-12 containerMinimumLeadsPerDay" 
                                        hidden>
                                        <el-checkbox
                                            v-model="LeadspeekEnableMinimumLeadsPerDay" 
                                            @change="validateMinLeadsPerDayBlur('price_campaign')">
                                            Enable Minimum Contacts Per Day
                                        </el-checkbox>
                                        <div 
                                            v-if="showInputLeadspeekPerDay"
                                            style="margin-bottom: 16px; margin-top: 5px;">
                                            <base-input
                                                label=""
                                                type="text"
                                                style="text-align: left;"
                                                class="campaign-cost-input"
                                                v-model="LeadspeekMinimumLeadsPerDay"
                                                placeholder="Input should be numeric and greater than zero"
                                                @input="event => onInput(event, 'LeadspeekMinimumLeadsPerDay')"
                                                @keyup="validateMinContactPerDayKeyup('price_campaign')"
                                                @keydown="event => restrictInput(event, 'integer')"
                                                @blur="validateMinContactPerDayBlur('price_campaign')"
                                                @copy.prevent @cut.prevent @paste.prevent>
                                            </base-input>
                                            <span class="client-payment-modal-form-helper-text">Your Minimum Contacts Per Day Is {{ LeadspeekMinimumLeadsPerDay }}, Contacts Per Day Cannot Be Below That</span>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="client-payment-modal-form-label">
                                            <!-- How many contacts per day does the client want to receive? -->
                                            How many contacts per 
                                            <span v-if="prepaidType == 'continual'">{{ selectsAppModule.LeadsLimitSelect }}</span>
                                            <span v-else>day</span>
                                            does the client want to receive?
                                        </div>
                                        <div class="input-contact-per-day" :class="{'d-flex flex-row justify-content-center align-items-start': prepaidType == 'continual'}">
                                            <base-input style="text-align: left; width: 100%; border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;" label="" type="text" placeholder="Input should be numeric and greater than zero" class="campaign-cost-input"
                                                v-model="LeadspeekLimitLead" :readonly="LeadspeekCostperlead == 0 && LeadspeekMinCostMonth > 0 && userType == 'client'" @input="event => onInput(event, 'LeadspeekLimitLead')" @keyup="profitcalculation();" @keydown="event => restrictInput(event,'integer')" @blur="validationMinLeadPrepaidLimitMonth" @copy.prevent @cut.prevent @paste.prevent>
                                            </base-input>
                                            <!-- <el-select v-if="prepaidType == 'continual' && ActiveLeadspeekID == '19917189'" v-model="selectsAppModule.LeadsLimitSelect" placeholder="Select" @change="event => prepaidLimitType(event, 'continual')" :disabled="OnlyPrepaidDisabled"> -->
                                            <el-select class="input-append-contact-per-month" v-if="prepaidType == 'continual'" v-model="selectsAppModule.LeadsLimitSelect" placeholder="Select" @change="event => prepaidLimitType(event, 'continual')" :disabled="OnlyPrepaidDisabled">
                                                <el-option
                                                v-for="item in listLimitFreq"
                                                :key="item.id"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div hidden>
                                            <base-input style="text-align: left;" label="" type="text" class="campaign-cost-input"
                                                v-model="LeadspeekLimitLeadDB">
                                            </base-input>
                                        </div>
                                        <span :class="{'client-payment-modal-form-helper-text-error': (errMinimumLeadPrepaidContinualLimitDay || errMinClientLeadDay), 'client-payment-modal-form-helper-text': (!errMinimumLeadPrepaidContinualLimitDay && !errMinClientLeadDay)}" :style="{ marginTop: (prepaidType == 'continual') ? '-1px' : '0px' }">
                                            <template v-if="errMinimumLeadPrepaidContinualLimitDay">*Minimum {{ minimumLeadPrepaidContinualLimitDay }} Contacts</template>
                                            <template v-else-if="errMinClientLeadDay">*Contacts Per Day Minimum {{ LeadspeekMinimumLeadsPerDay }}</template>
                                            <template v-else>*Input should be numeric, greater than zero and can not be empty</template>
                                        </span>
                                        <div v-if="LeadspeekMaxDateVisible" class="campaign-cost-input">
                                            <label class="client-payment-modal-form-label">Start From : </label>
                                            <el-date-picker type="date" placeholder="Date Start" v-model="LeadspeekMaxDateStart"
                                                class="frmSetCost leadlimitdate" id="leaddatestart">
                                            </el-date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <!-- </div> -->
                <div 
                    v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time' && selectsPaymentTerm.PaymentTermSelect != 'Prepaid' && userType != 'client'">
                    <div class="client-payment-modal-form-label">
                        Do you want to set an end date?
                    </div>
                    <div>
                        <el-date-picker type="date" placeholder="Date End" v-model="LeadspeekDateEnd" :picker-options="pickerOptions"
                            class="campaign-cost-input" style="width:100% !important;" id="leaddateend" :readonly="LeadspeekInputReadOnly">
                        </el-date-picker>
                    </div>
                    <div class="client-payment-modal-form-helper-text" v-if="userType != 'client'">
                        <span>Leave blank to manually stop in the future</span>
                    </div>
                </div>
            </div>
                <div style="border:solid 1px;opacity:0.5;margin-top:16px; width:100%">&nbsp;</div>
                <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6 d-flex flex-column justify-content-between">
                        <div>
                            <small> Client Calculations</small>
                            <div>
                                <small>1. Your Set Up fee is $<span><strong>{{ LeadspeekPlatformFee }}</strong></span></small>
                            </div>
                            <!-- <div>
                                <small>2. Your profit Platform fee profit
                                    $<span><strong>{{ t_LeadspeekMinCostMonth }}</strong></span></small>
                            </div> -->
                            <div>
                                <small>2. Your {{ txtLeadService }} campaign fee is
                                    $<span><strong>{{ LeadspeekMinCostMonth }}</strong></span></small>
                            </div>
                            <div v-if="selectsPaymentTerm.PaymentTermSelect != 'onetime' && t_estleadspermonth != '0.000' && LeadspeekLimitLead > 0" >
                                <small v-if="(prepaidType != 'onetime')">
                                    3. Your cost per contact is $<strong>{{ LeadspeekCostperlead }}</strong> <br>
                                    
                                    <div class='d-inline' v-if="selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && prepaidType == 'continual'">
                                        <span>
                                            4. Estimate cost per
                                            <template v-if="selectsAppModule.LeadsLimitSelect == 'day'">{{ contiDurationSelection ? 'Month' : 'Week' }}</template>
                                            <template v-else-if="selectsAppModule.LeadsLimitSelect == 'month'">Month</template>
                                            :
                                        </span>
                                        <br>
                                        <span v-if="selectsAppModule.LeadsLimitSelect == 'day'">
                                            ({{ LeadspeekLimitLead }} per day x 7 days) <span v-if='contiDurationSelection'>x {{ t_freq }} weeks</span> : $
                                            <span>
                                                <strong>{{contiDurationSelection ? formatPrice( ((LeadspeekCostperlead * LeadspeekLimitLead) * 7 ) * t_freq ) : formatPrice( ((LeadspeekCostperlead * LeadspeekLimitLead) * 7 ) )}}</strong>
                                            </span>
                                        </span>
                                        <span v-else>
                                            <span>
                                                ({{ LeadspeekCostperlead }} per contact x {{ LeadspeekLimitLead }} contact) : $
                                                <strong>{{ formatPrice(LeadspeekCostperlead * LeadspeekLimitLead) }}</strong>
                                            </span>
                                        </span>
                                    </div>
                                   
                                    <div class='d-inline' v-else>
                                        <span>
                                            4. Estimate cost per {{ t_freqshow }}:
                                        </span>
                                        <template>
                                            <br/>({{ LeadspeekLimitLead }} per day x 7 days) x {{ t_freq }} weeks :
                                            $<span><strong>{{formatPrice( ((LeadspeekCostperlead * LeadspeekLimitLead)*7 ) *t_freq )}}</strong></span>
                                        </template>
                                    </div>
                                </small>
                                <small v-if="prepaidType == 'onetime'">
                                    3. Your cost per contact is $<strong>{{ LeadspeekCostperlead }}</strong> <br>

                                    <div class="d-inline">
                                        ({{ LeadspeekCostperlead }} per contact x {{ totalLeads.oneTime }} contact) :
                                        $<span><strong>{{formatPrice(LeadspeekCostperlead * totalLeads.oneTime)}}</strong></span>
                                    </div>
                                </small>
                            </div>
                            <div v-if="selectsPaymentTerm.PaymentTermSelect == 'onetime'">
                                <small>3. Your total cost from contacts included is
                                    $<span><strong>-{{ t_LeadspeekCostperlead }}</strong></span></small>
                            </div>
                        </div>

                        <div v-if="selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && LeadspeekLimitLead > 0">
                            <small v-if="prepaidType == 'continual'">
                                Your estimate cost per 
                                <template v-if="selectsAppModule.LeadsLimitSelect == 'day'">{{ contiDurationSelection ? 'Month' : 'Week' }}</template>
                                <template v-else-if="selectsAppModule.LeadsLimitSelect == 'month'">Month</template>
                                is $
                                <template v-if="selectsAppModule.LeadsLimitSelect == 'day'">
                                    <strong>{{contiDurationSelection ?  formatPrice( (((LeadspeekCostperlead * LeadspeekLimitLead)* 7) * t_freq) + parseFloat(LeadspeekPlatformFee)) : formatPrice( (((LeadspeekCostperlead * LeadspeekLimitLead)* 7)) + parseFloat(LeadspeekPlatformFee))}}</strong>
                                </template>
                                <template v-else>
                                    <strong>{{ formatPrice( (LeadspeekCostperlead * LeadspeekLimitLead) + parseFloat(LeadspeekPlatformFee) ) }}</strong>
                                </template>
                            </small>
                            <small v-else>
                                Your cost is $
                                <strong>{{ formatPrice((LeadspeekCostperlead * totalLeads.oneTime) + Number(LeadspeekPlatformFee)) }}</strong>
                            </small>
                        </div>

                        <div v-else>
                            <small v-if="LeadspeekLimitLead > 0">
                                Your estimate cost per {{ t_freqshow }} is $
                                <strong>{{ formatPrice( (((LeadspeekCostperlead * LeadspeekLimitLead)* 7) * t_freq) + parseFloat(LeadspeekMinCostMonth)) }}</strong>
                            </small>
                            <!-- <div  v-if="prepaidType != 'onetime'">
                                <small v-if="false">Your estimate cost {{ t_freqshow }} is <strong>unlimited</strong></small>
                            </div>   -->
                            <!-- <div style="margin-top: auto" v-if="selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && prepaidType == 'onetime'">
                                <small v-if="LeadspeekLimitLead > 0">Your cost is $<strong>{{ formatPrice(LeadspeekCostperlead * totalLeads.oneTime) }}</strong></small>
                                <small v-if="false">Your estimate cost {{ t_freqshow }} is <strong>unlimited</strong></small>
                            </div> -->
                        </div>
                    </div>



                    <div class="col-sm-6 col-md-6 col-lg-6 d-flex flex-column justify-content-between" v-if="userType != 'client'">
                        <div>
                            <small>Agency Calculations</small>
                            <div>

                                <small>1. Your Set Up fee profit $<span><strong>{{ formatPrice(t_LeadspeekPlatformFee) }}</strong></span></small>
                            </div>
                            <div>
                                <small>2. Your profit Platform fee profit
                                    $<span><strong>{{ formatPrice(t_LeadspeekMinCostMonth) }}</strong></span></small>
                            </div>
                            <div v-if="selectsPaymentTerm.PaymentTermSelect != 'onetime' && t_estleadspermonth != '0.000' && LeadspeekLimitLead > 0">
                                <small v-if="(prepaidType != 'onetime')">
                                    3. Your profit per contact is $<strong>{{ t_LeadspeekCostperlead }}</strong> <br>
                                    
                                    <span class='d-inline' v-if="selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && prepaidType == 'continual'">
                                         <span>
                                            4. Estimate profit per
                                            <template v-if="selectsAppModule.LeadsLimitSelect == 'day'">{{ contiDurationSelection ? 'Month' : 'Week' }}</template>
                                            <template v-else-if="selectsAppModule.LeadsLimitSelect == 'month'">Month</template>
                                            :
                                        </span>
                                        <br>
                                        <span v-if="selectsAppModule.LeadsLimitSelect == 'day'">
                                            ({{ LeadspeekLimitLead }} per day x 7 days) <span v-if='contiDurationSelection'>x {{ t_freq }} weeks</span> :
                                            $<span><strong>{{contiDurationSelection ? t_estleadspermonth : (parseFloat(t_estleadspermonth.replace(/,/g, ''))) /4}}</strong></span>
                                        </span>
                                        <span v-else>
                                            ({{ t_LeadspeekCostperlead }} per contact x {{ LeadspeekLimitLead }} contact) :
                                            $<span><strong>{{ formatPrice(t_LeadspeekCostperlead * LeadspeekLimitLead) }}</strong></span>
                                        </span>
                                    </span>
                                    <div class='d-inline' v-else>
                                        <span>
                                            4. Estimate profit per {{ t_freqshow }}:
                                        </span>
                                        <br/>({{ LeadspeekLimitLead }} per day x 7 days) x {{ t_freq }} weeks :
                                        $<span><strong>{{ t_estleadspermonth }}</strong></span>
                                    </div>
                                </small>
                                <small v-if="prepaidType == 'onetime'">
                                   3. Your profit per contact is $<strong>{{ t_LeadspeekCostperlead }}</strong> <br>
                                    
                                    <span>
                                        ({{ t_LeadspeekCostperlead }} per contact x {{ totalLeads.oneTime }} contact) :
                                        $<span><strong>{{formatPrice(t_LeadspeekCostperlead * totalLeads.oneTime)}}</strong></span>
                                    </span>
                                </small>
                            </div>
                            <div v-if="selectsPaymentTerm.PaymentTermSelect == 'onetime'">
                                <small>3. Your total cost from contacts included is
                                    $<span><strong>-{{ t_LeadspeekCostperlead }}</strong></span></small>
                            </div>
                        </div>

                        <div style="margin-top: auto" v-if="selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && LeadspeekLimitLead > 0">
                            <small v-if="prepaidType == 'continual'">
                                Your estimate profit per 
                                <template v-if="selectsAppModule.LeadsLimitSelect == 'day'">{{ contiDurationSelection ? 'Month' : 'Week' }}</template>
                                <template v-else-if="selectsAppModule.LeadsLimitSelect == 'month'">Month</template>
                                is $
                                <template v-if="selectsAppModule.LeadsLimitSelect == 'day'">
                                    <strong>{{ t_profit }}</strong>
                                </template>
                                <template v-else>
                                    <strong>{{ formatPrice((t_LeadspeekCostperlead * LeadspeekLimitLead) + t_LeadspeekPlatformFee) }}</strong>
                                </template>
                            </small>
                            <small v-else>
                                Your profit is $
                                <strong>{{ formatPrice((t_LeadspeekCostperlead * totalLeads.oneTime) + t_LeadspeekPlatformFee) }}</strong>
                            </small>
                        </div>
                        
                        <div v-else>
                            <small v-if="LeadspeekLimitLead > 0">Your estimate profit per {{ t_freqshow }} is $<strong>{{ t_profit }}</strong></small>
                            <!-- <div style="margin-top: auto" v-if="(prepaidType != 'onetime')">
                                <small v-if="false">Your estimate prozfit {{ t_freqshow }} is <strong>unlimited</strong></small>
                            </div>
                            <div style="margin-top: auto" v-if="prepaidType == 'onetime'">
                                <small v-if="LeadspeekLimitLead > 0">Your profit is $<strong>{{ formatPrice(t_LeadspeekCostperlead * totalLeads.oneTime) }}</strong></small>
                                <small v-if="false">Your estimate profit {{ t_freqshow }} is <strong>unlimited</strong></small>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button :disabled="isLoadingModuleCost" v-if="LeadspeekLimitLead > 0" @click.native="setModuleCost()">
                      Ok, Set It Up! <i v-if="isLoadingModuleCost" class="fas fa-spinner fa-spin ml-1" style="font-size: 16px;"></i> 
                   </base-button>
                </div>
            </template>
        </modal>
        <!-- Modal Setting Markup -->

        <!-- WhiteList DB upload -->
        <modal :show.sync="modals.whitelist" id="locatorWhitelist" headerClasses="justify-content-center"
         >
            <h4 slot="header" class="title title-up">Exclusion List for this campaign</h4>
            <div>
                <!--UPLOAD-->
                <form enctype="multipart/form-data">
                    <!--<h5>Drag & Drop your suppression List (file type should be .csv). Download <a href="#">example file</a></h5>-->
                    <div class="dropbox">
                        <input type="file" :name="uploadFieldName" :disabled="isSaving"
                            @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                            accept=".csv" class="input-file">
                        <p v-if="isInitial">
                            Drag your file here to upload<br />or click to browse<br />
                            <!--<base-button type="info" round icon  @click="show_helpguide('suppression')">
                                                <i class="fas fa-question"></i>
                                            </base-button>-->
                        </p>
                        <p v-if="isSaving">
                            Please Wait, your file being upload ...
                        </p>
                        <p v-if="isSuccess">
                            Your Suppression file has been Submitted, Thank you!
                        </p>
                        <p v-if="isFailed">
                            Whoops that did not work, please check your file for errors and try again
                        </p>
                    </div>
                </form>
            </div>
            <div v-if="supressionProgress.length > 0">
                <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                    <div v-for="(value) in supressionProgress" :key="value.id">
                        <div style="display: flex; width: 100%; gap: 8px;">
                            <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                            <div style="width: 100%;">
                                <p style="color: #000000; font-weight: 600; margin-bottom: 0px;">{{ value.filename }}</p>
                                <el-progress :percentage="value.percentage == null ? 0 : value.percentage"></el-progress>
                                <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                            </div>
                        </div>
                        <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                    </div>
            </div>
            <div class="pt-2 mt-3">
                You have the ability to restrict your current database from being identified as a new contact. 
                You can Exclude them by uploading a list of MD5 encrypted email addresses, 
                or by uploading a list of email addresses and we will encrypt them for you. 
                Do not include any other information in the file aside from the email address. 
                You may upload lists of up to 10,000 records at a time. <a
                    href='https://app.exactmatchmarketing.com/samplefile/suppressionlist.csv' target='_blank'>Click here</a> to download a Sample File
            </div>
            <div v-if="supressionDone.length > 0">
                <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                <div v-for="(value) in supressionDone" :key="value.id">
                    <div style="display: flex; width: 100%; gap: 8px;">
                        <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                        <div style="width: 100%;">
                            <p style="color: #000000; font-weight: 600; margin-bottom: 0px;">{{ value.filename }}</p>
                            <el-progress :percentage="value.percentage" status="success"></el-progress>
                            <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                        </div>
                    </div>
                    <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                </div>
            </div>
            <a class="mt-2 d-inline-block" @click="purgeSuppressionList('campaign')" style="cursor: pointer;"><i class="fas fa-trash" ></i> Purge Existing Records</a>
            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="modals.whitelist = false">Cancel</base-button>
                </div>
            </template>
        </modal>
        <!-- WhiteList DB upload -->


        
        <!-- Integrations modal -->
        <modal :show.sync="modals.integrations" id="addIntegrations"
            footerClasses="border-top">
            <h3 slot="header" class="title title-up">Add integrations to campaign #{{selectedRowData.leadspeek_api_id}}</h3>
            
            <div>
                <div v-if="$global.hasVisibleIntegrations" class="integratios-list-wrapper d-flex align-items-center gap-4 flex-wrap">
                    <div v-for="item in integrations" :key="item.slug"
                        class="integrations__modal-item-wrapper d-flex align-items-center justify-content-center shadow-sm border"
                        :class="{ '--active bg-blue text-secondary': item.slug === selectedIntegration }"
                        @click="integrationItemClick(item)">
                        <div class="integrations__modal-item">
                            <span v-if="item.slug === 'googlesheet' && GoogleConnectTrue"class="check-icon">✔</span>
                            <span v-if="item.slug === 'gohighlevel' && selectedRowData.ghl_is_active"class="check-icon">✔</span>
                            <span v-if="item.slug === 'sendgrid' && selectedRowData.sendgrid_is_active"class="check-icon">✔</span>
                            <span v-if="item.slug === 'mailboxpower' && selectedRowData.mbp_is_active"class="check-icon">✔</span>
                            <span v-if="item.slug === 'zapier' && selectedRowData.zap_is_active" class="check-icon">✔</span>
                            <span v-if="item.slug === 'kartra' && selectedRowData.kartra_is_active"class="check-icon">✔</span>
                            <span v-if="item.slug === 'sendjim' && selectedRowData.sendjim_is_active"class="check-icon">✔</span>
                            <span v-if="item.slug === 'agencyzoom' && selectedRowData.agencyzoom_is_active"class="check-icon">✔</span>
                            <span v-if="item.slug === 'clickfunnels' && selectedRowData.clickfunnels_is_active"class="check-icon">✔</span>
                            <img
                                v-if="item.custom_img"
                                class="logo-wrap-campaign"
                                :src="item.custom_img"
                                alt="brand-logo"
                            />
                            <i v-else :class="item.custom_icon || item.logo" style="font-size: 36px;"></i>
                            <span class="integrarion-brand-name" style="text-align: center;">{{ item.custom_name || item.name }}</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center shadow-sm add-new-integration-wrapper"
                        @click="$redirectToAddIntegration()">
                        <i class="fa-solid fa-plus" style="font-size: 36px;"></i>
                        <span class="integrarion-brand-name">Add integration</span>
                    </div>
                </div>
              
                <div class="mt-4">
                    <div v-if="selectedIntegration === 'googlesheet'" class="">
                        <div v-if="isGoogleInfoFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-if="isLoadingResetSpreadsheet" class="row" v-loading="true" id="loading"></div>
                        <div v-if="!isGoogleInfoFetching && !isLoadingResetSpreadsheet">
                            <div>
                                <base-input label="Client Emails Approved to View the Google Sheet:">
                                    <textarea class="w-100" v-model="selectedRowData.report_sent_to" @keydown="handleGsheetKeydown" @paste="handleGSheetPaste"
                                        placeholder="Enter email, separate by new line" rows="4">
                                        </textarea>
                                        <span>Seperate the emails by space or comma</span>
                                    </base-input>
                            </div>
                            <div class="has-label form-group" :style="{display : userType === 'client' ? 'none' : 'block'}">
                                <label>Admins Approved for Google Sheet Administration</label>
                                <el-select multiple class="select-info select-fullwidth" size="large"
                                    v-model="selectedRowData.admin_notify_to" placeholder="You can select multiple Admin">
                                    <el-option v-for="option in selectsAdministrator.administratorList" class="select-info"
                                        :value="option.id" :label="option.name" :key="option.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="mt-3">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="isLoadingSpreedSheetConnection ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                    @click="onSendTestSpreadsheet"
                                    circle
                                    :disabled="isLoadingSpreedSheetConnection"
                                    ></el-button>
                                    <el-button :disabled="isLoadingSpreedSheetConnection" type="text" @click="onSendTestSpreadsheet" style="margin-left: 0px;">Check Spreadsheet Connection</el-button>
                                </div>
                            </div>
                            <div class="mt-3">
                                <!-- MAIN SHEET -->
                                <div v-if="selectedRowData.spreadsheet_id" class="gsheet-grid mt-1">
                                    <a
                                    class="gsheet-item"
                                    :href="'https://docs.google.com/spreadsheets/d/' + selectedRowData.spreadsheet_id + '/edit#gid=0'"
                                    target="_blank"
                                    style="text-decoration: none; color: #222a42 !important;"
                                    >
                                        <span>Open google sheet</span>
                                        <el-popover content="Go to Google Sheet" placement="top" trigger="hover" effect="light" :open-delay="300">
                                        <i slot="reference" class="fab fa-google-drive  ml-2" style="color:#6699CC"></i>
                                        </el-popover>
                                    </a>
                                </div>

                                <label v-if="filteredHistory.length" class="mt-3">History Spreadsheet</label>
                                <!-- HISTORY SHEET -->
                                <div v-if="filteredHistory.length" class="mt-2">
                                    <div class="history-grid">
                                        <a v-for="(item, index) in filteredHistory" :key="index" class="history-item"
                                        :href="'https://docs.google.com/spreadsheets/d/' + item.spreadsheet_id + '/edit#gid=0'" target="_blank"
                                        style="text-decoration: none; color: #222a42 !important;">
                                            <span class="history-label">
                                                History {{ index + 1 }} ({{ item.created_at }})
                                            </span>
                                            <el-popover content="View this spreadsheet" placement="top" trigger="hover">
                                            <i class="fab fa-google-drive ml-2" style="color:#CCCC66"></i>
                                            </el-popover>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedIntegration === 'sendgrid'" class="''">
                      <div v-if="isSendgridInfoFetching" class="row" v-loading="true" id="loading"></div>
                      <div v-else-if="errors.sendgrid">
                            <el-alert
                                title="Connection Issue"
                                type="warning"
                                description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                :closable="false"
                                show-icon>
                            </el-alert>
                        </div>
                        <div v-else>
                        <el-checkbox v-model="selectedRowData.sendgrid_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                        <div class="d-flex mt-2" style="gap: 4px;">

                            <div class="has-label flex-grow-1">
                                <label class="mb-0">Choose Action</label>
                                <el-select multiple class="select-info select-fullwidth" size="large"
                                    v-model="selectedRowData.sendgrid_action" placeholder="You can select multiple actions">
                                    <el-option v-for="option in sendGridActionsOptions" class="select-info" :value="option.id"
                                        :label="option.name" :key="option.id">
                                    </el-option>
                                </el-select>
                            </div>
                             
                            <div v-if="selectedRowData.sendgrid_action && selectedRowData.sendgrid_action.includes('add-to-list')" class="flex-grow-1">
                                <div class="warning-banner" v-if="sendGridListOptions.length < 1"><p>You don't have any active {{ nameIntegration }} list please create one</p></div>
    
                                <div v-else class="has-label">
                                    <label class="mb-0">Choose {{ nameIntegration }} list</label>
                                    <el-select multiple class="select-info select-fullwidth" size="large"
                                        v-model="selectedRowData.sendgrid_list" placeholder="You can select multiple actions">
                                        <el-option v-for="option in sendGridListOptions" class="select-info" :value="option.id"
                                            :label="option.name" :key="option.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="has-label mt-2" v-if="userType != 'client' && selectedSendgridAction.includes('campaign')">
                            <label class="mb-0">Campaign Id</label>
                            <el-input label="Campaign Id" class="select-info select-fullwidth" size="large"
                                v-model="sendGridcampaignId" placeholder="Enter Campaign Id">

                            </el-input>
                        </div> -->

                        <base-input v-if="userType != 'client' && selectedRowData.sendgrid_list && selectedRowData.sendgrid_list.includes('send-mail')"
                            label="Email format">
                            <textarea class="w-100" v-model="ClientReportSentTo" placeholder="Enter email format" rows="4">
                            </textarea>
                        </base-input>
                        <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                @click="onSendTestLead"
                                circle
                                :disabled="isLoadingSendTestLead"
                                ></el-button>
                                <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="'el-icon-view'"
                                @click="onViewExampleData"
                                circle
                                ></el-button>
                                <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div v-if="selectedIntegration === 'gohighlevel'" class="">
                        <div v-if="isGoHighInfoFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-else-if="errors.goHighLevel">
                            <el-alert
                                title="Connection Issue"
                                type="warning"
                                description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                :closable="false"
                                show-icon>
                            </el-alert>
                        </div>
                        <div v-else>
                        <el-checkbox v-model="selectedRowData.ghl_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                    

                        <div class="has-label mt-2" v-if="selectedIntegration === 'gohighlevel'">
                        <label class="mb-0">Choose Tags</label>
                        <el-select 
                            ref="selectGhlTags"
                            multiple 
                            allow-create
                            filterable
                            default-first-option
                            :reserve-keyword="false"
                            class="select-info select-fullwidth select-integration-ghl" 
                            size="large"
                            v-model="ghl_tags" 
                            placeholder="You can select multiple tags"
                            @change="changeGhlTags"
                            @focus="changeGhlTags"
                            @blur="changeGhlTags"
                            @visible-change="changeGhlTags"
                            @remove-tag="changeGhlTags"
                            @clear="changeGhlTags">
                            <el-option v-for="option in goHighLevelTagsOptions" class="select-info" :value="option.id"
                                :label="option.name" :key="option.id">
                                <span class="ellipsis-text">{{ option.name }}</span>
                            </el-option>
                        </el-select>

                        <div v-if="ghl_tags_remove.length > 0" class="mt-2 mb-2">
                            <p class="m-0 p-0">*This tag has an error in {{ nameIntegration }}.</p>
                        </div>
                        <!-- <div v-if="ghl_tags_remove.length > 0" class="tags-container" style="padding-left: 6px;">
                            <div
                                v-for="(item, index) in ghl_tags_remove"
                                :key="index"
                                :style="{ backgroundColor: 'red', color: 'white', padding: '1px 8px', borderRadius: '99px' }"
                                class="tag-item"
                            >
                                <span class="tag-text">{{ item }}</span>
                            </div>
                        </div> -->

                        </div>
                        <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                @click="onSendTestLead"
                                circle
                                :disabled="isLoadingSendTestLead"
                                ></el-button>
                                <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="'el-icon-view'"
                                @click="onViewExampleData"
                                circle
                                ></el-button>
                                <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div v-if="selectedIntegration === 'kartra'" class="''">
                      <div v-if="isKartraInfoFetching" class="row" v-loading="true" id="loading"></div>
                      <div v-else-if="errors.kartra">
                        <el-alert
                            title="Connection Issue"
                            type="warning"
                            description="There seems to be a problem with your integration. Please check your connection settings and try again."
                            :closable="false"
                            show-icon>
                        </el-alert>
                      </div>
                      <div v-else>
                          <el-checkbox v-model="selectedRowData.kartra_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                          <div class="d-flex mt-2" style="gap: 4px;">

                              <div class="flex-grow-1">
                                  <div class="warning-banner" v-if="kartraListOptions.length < 1"><p>You don't have any active {{ nameIntegration }} list please create one</p></div>
        
                                  <div v-else class="has-label">
                                      <label class="mb-0">Choose {{ nameIntegration }} list</label>
                                      <el-select multiple class="select-info select-fullwidth" size="large"
                                          v-model="selectedKartraList" placeholder="You can select multiple lists">
                                          <el-option v-for="option in kartraListOptions" class="select-info" :value="option"
                                              :label="option" :key="option">
                                          </el-option>
                                      </el-select>
                                  </div>
                              </div>    
                              <div class="flex-grow-1">
                                  <div class="warning-banner" v-if="kartraTagsOptions.length < 1"><p>You don't have any active {{ nameIntegration }} Tags please create one</p></div>
        
                                  <div v-else class="has-label">
                                      <label class="mb-0">Choose {{ nameIntegration }} Tags</label>
                                      <el-select multiple class="select-info select-fullwidth" size="large"
                                          v-model="selectedKartraTags" placeholder="You can select multiple tags">
                                          <el-option v-for="option in kartraTagsOptions" class="select-info" :value="option"
                                              :label="option" :key="option">
                                          </el-option>
                                      </el-select>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <el-button
                            size="medium"
                            :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                            @click="onSendTestLead"
                            circle
                            :disabled="isLoadingSendTestLead"
                            ></el-button>
                            <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                        </div>
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <el-button
                            size="medium"
                            :icon="'el-icon-view'"
                            @click="onViewExampleData"
                            circle
                            ></el-button>
                            <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                        </div>
                    </div>
                    </div>
                    <div v-if="selectedIntegration === 'zapier'" class="''">
                        <div v-if="isZapierFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-else>
                            <el-checkbox v-model="selectedRowData.zap_is_active">Enable {{ nameIntegration }}</el-checkbox>
                            <div class="has-label mt-2">
                                <label class="mb-0">Enter your Webhook URL</label>
                                <div style="display: flex; flex-direction: column; gap: 8px;">
                                    <div v-for="(url, index) in zapierWebhook" :key="index" class="webhook-url-wrapper">
                                        <el-input 
                                            type="text" 
                                            clearable 
                                            label="Enter your Webhook URL"
                                            placeholder="https://hooks.app.com/hooks/catch/....." 
                                            class="flex-grow-1 mb-0"  
                                            v-model="zapierWebhook[index]"  
                                            aria-controls="datatables">
                                        </el-input>
                                        <span 
                                            v-if="index == 0" 
                                            class="add-webhook-url" 
                                            @click="addWebhookUrl('zapier')">
                                            <i class="fa-solid fa-plus"></i>
                                        </span>
                                        <span 
                                            v-if="index != 0 && zapierWebhook.length > 1" 
                                            class="add-webhook-url" 
                                            @click="removeWebhookUrl(index,'zapier')">
                                            <i class="fa-solid fa-minus"></i>
                                        </span>
                                    </div>
                                </div>
                                <p v-if="defaultWebhook" class="mt-2">you are using <b>default</b> client webhook, replace URL if you want to use custom webhook for this campaign  </p>
                                <p v-if="!defaultWebhook" class="mt-2">you are using <b>custom</b> webhook, just delete this URL and save. if you want to use default webhook for this campaign </p>
                                <label class="mb-0">Enter Tags</label>
                                <el-select 
                                    multiple 
                                    allow-create
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                    class="select-info select-fullwidth" 
                                    size="large"
                                    v-model="zapierTags" 
                                    placeholder="You can select multiple tags">
                                    <el-option v-for="option in zapierTagsOptions" class="select-info" :value="option.name"
                                        :label="option.name" :key="option.name">
                                    </el-option>
                                </el-select>
                                <!-- <label class="mt-2">Test Your Webhook ?</label>
                                <el-checkbox v-model="zapierTestEnable" class="d-block">Send Test Data</el-checkbox>
                                <p>* Please check the 'Send Test Data' checkbox and click 'Save' to send the test data to your Webhook.</p> -->
                            </div>
                        </div>
                        <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                @click="onSendTestLead"
                                circle
                                :disabled="isLoadingSendTestLead"
                                ></el-button>
                                <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="'el-icon-view'"
                                @click="onViewExampleData"
                                circle
                                ></el-button>
                                <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedIntegration === 'mailboxpower'" class="">
                        <div v-if="isMailBoxPowerFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-else-if="errors.mailboxPower">
                            <el-alert
                                title="Connection Issue"
                                type="warning"
                                description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                :closable="false"
                                show-icon>
                            </el-alert>
                        </div>
                        <div v-else>
                            <el-checkbox v-model="selectedRowData.mbp_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                        
                            <div class="has-label mt-2" v-if="selectedIntegration === 'mailboxpower'">
                                <label class="mb-0">Choose Groups</label>
                                <el-select 
                                    multiple 
                                    allow-create
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                    class="select-info select-fullwidth" 
                                    size="large"
                                    v-model="mbp_groups"
                                    placeholder="You can select multiple groups">
                                    <el-option v-for="option in mailBoxPowerOptions" class="select-info" :value="option.id"
                                        :label="option.name" :key="option.id">
                                    </el-option>
                                </el-select>

                                <div class="row" style="padding-left: 16px; margin-bottom: 10px; margin-top: 10px;">
                                    <el-radio v-model="mbp_options" label="state">State</el-radio>
                                    <el-radio v-model="mbp_options" label="zip">Zip Code</el-radio>
                                </div>

                                <div v-if="mbp_options == 'state'">
                                    <label class="mb-0">Choose States</label>
                                    <el-select 
                                        multiple 
                                        :allow-create="false"
                                        filterable
                                        default-first-option
                                        :reserve-keyword="false"
                                        class="select-info select-fullwidth" 
                                        size="large"
                                        v-model="mbp_states" 
                                        placeholder="You can select states">
                                        <el-option v-for="option in mailBoxPowerStates" class="select-info" :value="option.state_code"
                                            :label="option.state" :key="option.sifi_state_id">
                                        </el-option>
                                    </el-select>
                                </div>

                                <div v-if="mbp_options == 'zip'">
                                    <label class="mb-0">Upload Zip Code</label>
                                    <div style="margin-top: 5px;">
                                        <form enctype="multipart/form-data" style="display: flex; justify-content: start; align-items: center; gap: 16px;">
                                            <!-- <input type="file" :name="mailBoxpowerUploadZipName" :disabled="isMailBoxPowerSavingZip" accept=".csv" @change="mailBoxPowerFilesChange($event.target.name, $event.target.files)"> -->
                                            <el-upload
                                                ref="mailBoxPowerZip"
                                                class="upload-demo"
                                                :show-file-list="false"
                                                :auto-upload="false"
                                                action="#"
                                                :name="mailBoxpowerUploadZipName"
                                                :on-change="mailBoxPowerFilesChange">
                                                <el-button slot="trigger" size="small" type="primary">select file</el-button>
                                            </el-upload>
                                            <span>
                                                <i v-if="isMailBoxPowerSavingZip" class="fas fa-spinner fa-spin" style="font-size: 16px; margin-top: 8px;"></i>
                                            </span>
                                        </form>
                                    </div>
                                    <div class="row" style="margin-top: 3px;">
                                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                            <div class="form-group has-label">
                                                <el-input
                                                    class="mailboxzipcode"
                                                    type="textarea"
                                                    :rows="6"
                                                    :resize="'none'"
                                                    placeholder=""
                                                    v-model="mbp_zip"
                                                    @blur="removeEmptyLines">
                                                </el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <p v-if="mbp_groups_remove.length > 0">Attention: The following tags have been removed from {{ nameIntegration }}:</p>
                                    <p v-for="(item, index) in mbp_groups_remove" :key="index">
                                    - {{item}}
                                </p>
                            </div>
                            <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                    @click="onSendTestLead"
                                    circle
                                    :disabled="isLoadingSendTestLead"
                                    ></el-button>
                                    <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                                </div>
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <el-button
                                    size="medium"
                                    :icon="'el-icon-view'"
                                    @click="onViewExampleData"
                                    circle
                                    ></el-button>
                                    <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedIntegration === 'clickfunnels'">
                        <div style="display: flex; gap: 16px;">
                            <el-menu :default-active="menuClickFunnels" class="el-menu-vertical-demo" :collapse="isCollapseMenuClickFunnels">
                                <el-menu-item index="choose-tag" @click="handleClickMenuClickFunnels('choose-tag')">
                                    <i class="el-icon-menu"></i>
                                    <span slot="title">Tag Selection</span>
                                </el-menu-item>
                                <el-menu-item index="create-tag" @click="handleClickMenuClickFunnels('create-tag')">
                                    <i class="el-icon-circle-plus"></i>
                                    <span slot="title">Create Tag</span>
                                </el-menu-item>
                            </el-menu>
                            
                            <div v-if="menuClickFunnels === 'choose-tag'" style="flex: 1; display: flex; flex-direction: column;">
                                <div v-if="isLoadingGetTagsClickFunnels" class="row" v-loading="true" id="loading"></div>
                                <div v-else-if="errors.clickfunnels">
                                    <el-alert
                                        title="Connection Issue"
                                        type="warning"
                                        description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                        :closable="false"
                                        show-icon>
                                    </el-alert>
                                </div>
                                <div v-else>
                                    <p style="font-weight: 600; margin-bottom: 0px;">Tag Selection</p>

                                    <div style="margin-top: 16px;">
                                        <el-checkbox v-model="selectedRowData.clickfunnels_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                                        <p style="margin-bottom: 8px; margin-top: 16px;">Choose tags :</p>
                                        <el-select style="width: 100%;" v-model="listTagsClickFunnelsSelected" multiple placeholder="Select tags" value-key="id" class="click-funnels-tag-select">
                                            <el-option
                                                v-for="item in listTagsClickFunnels"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item"
                                                :collapse-tags="false"
                                                >
                                            </el-option>
                                        </el-select>
                                        <div style="margin-top: 16px;">
                                            <div v-if="isLoadingGetCampaignTagsClickFunnels" style="display: flex;">
                                                <div v-for="n in 3" :key="n" class="skeleton-tag"></div>
                                            </div>
                                            <div v-else class="tags-container">
                                                <div
                                                v-for="tag in listTagsClickFunnelsSelected"
                                                :key="tag.id"
                                                :style="{ backgroundColor: tag.color, color: getTextColor(tag.color), borderColor: tag.color }"
                                                class="tag-item"
                                                >
                                                    <span class="tag-text">{{ tag.name }}</span>
                                                    <i class="el-icon-close close-icon" @click="removeTagClickFunnels(tag)"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                                        <div style="display: flex; align-items: center; gap: 8px;">
                                            <el-button
                                            size="medium"
                                            :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                            @click="onSendTestLead"
                                            circle
                                            :disabled="isLoadingSendTestLead"
                                            ></el-button>
                                            <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                                        </div>
                                        <div style="display: flex; align-items: center; gap: 8px;">
                                            <el-button
                                            size="medium"
                                            :icon="'el-icon-view'"
                                            @click="onViewExampleData"
                                            circle
                                            ></el-button>
                                            <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="menuClickFunnels === 'create-tag'" style="flex: 1; display: flex; flex-direction: column;">
                                <!-- <div v-if="isLoadingGetTagsClickFunnels" class="row" v-loading="true" id="loading"></div>
                                <div v-else-if="errors.clickfunnels">
                                    <el-alert
                                        title="Connection Issue"
                                        type="warning"
                                        description="There seems to be a problem with your integration. Please check your connection settings and try again."
                                        :closable="false"
                                        show-icon>
                                    </el-alert>
                                </div> -->
                                <div>
                                    <p style="font-weight: 600; margin-bottom: 0px;">New Contact Tag</p>

                                    <el-form label-position="top" :model="formNewTagClickFunnels" ref="formNewTagClickFunnels">
                                        <el-form-item
                                            label="Name :"
                                            prop="name"
                                            :rules="[
                                                { required: true, message: 'Name is required'},
                                            ]"
                                        >
                                            <el-input v-model="formNewTagClickFunnels.name" autocomplete="off"></el-input>
                                        </el-form-item>

                                        <el-form-item
                                            label="Color :"
                                            prop="color"
                                            :rules="[
                                                { required: true, message: 'Color is required'},
                                            ]"
                                        >
                                            <p style="font-weight: 600; font-size: 12px;">{{ formNewTagClickFunnels.color }}</p>
                                            <div style="display: flex; gap: 16px; flex-wrap: wrap;">
                                                <span v-for="(color) in colorsNewTagClickFunnels" :key="color.value" @click="onColorClickFunnels(color.value)" :style="{backgroundColor: color.value, height: '40px', width: '40px', borderRadius: '4px', border: color.value === formNewTagClickFunnels.color ? '4px solid white' : '', boxShadow: color.value === formNewTagClickFunnels.color ? `0 0 0 4px ${color.value}` : '', cursor: 'pointer'}"></span>
                                                <el-color-picker v-model="formNewTagClickFunnels.color"></el-color-picker>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                    <base-button :disabled="isLoadingCreateTagsClickFunnels" @click="onCreateTagsClickFunnels" style="margin-top: 24px;" :style="{width: isLoadingCreateTagsClickFunnels ? '120px' : '100px'}">
                                        <i v-if="isLoadingCreateTagsClickFunnels" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i> Submit
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedIntegration === 'agencyzoom'" class="''">
                        <div v-if="isAgencyZoomFetching" class="row" v-loading="true" id="loading"></div>
                        <div v-else>
                            <el-checkbox v-model="selectedRowData.agencyzoom_is_active">Enable {{ nameIntegration }}</el-checkbox>
                            <div class="has-label mt-2">
                                <label class="mb-0">Enter your Webhook URL</label>
                                <div style="display: flex; flex-direction: column; gap: 8px;">
                                    <div v-for="(url, index) in agencyZoomWebhook" :key="index" class="webhook-url-wrapper">
                                        <el-input 
                                            type="text" 
                                            clearable 
                                            label="Enter your Webhook URL"
                                            placeholder="https://app.agencyzoom.com/v1/api/lead/webhook/....."
                                            class="flex-grow-1 mb-0"
                                            v-model="agencyZoomWebhook[index]"  
                                            aria-controls="datatables">
                                        </el-input>
                                        <span 
                                            v-if="index == 0" 
                                            class="add-webhook-url" 
                                            @click="addWebhookUrl('agencyzoom')">
                                            <i class="fa-solid fa-plus"></i>
                                        </span>
                                        <span 
                                            v-if="index != 0 && agencyZoomWebhook.length > 1" 
                                            class="add-webhook-url" 
                                            @click="removeWebhookUrl(index,'agencyzoom')">
                                            <i class="fa-solid fa-minus"></i>
                                        </span>
                                    </div>
                                </div>

                                <p v-if="defaultAgencyZoomWebhook" class="mt-2">you are using <b>default</b> client webhook, replace URL if you want to use custom webhook for this campaign  </p>
                                <p v-else class="mt-2">you are using <b>custom</b> webhook, just delete this URL and save. if you want to use default webhook for this campaign </p>
                                
                                <!-- <label  class="mb-0">Enter Tags</label>
                                <el-select 
                                    multiple 
                                    allow-create
                                    filterable
                                    default-first-option
                                    :reserve-keyword="false"
                                    class="select-info select-fullwidth" 
                                    size="large"
                                    v-model="zapierTags" 
                                    placeholder="You can select multiple tags">
                                    <el-option v-for="option in zapierTagsOptions" class="select-info" :value="option.name"
                                        :label="option.name" :key="option.name">
                                    </el-option>
                                </el-select> -->
                                <!-- <label class="mt-2">Test Your Webhook ?</label>
                                <el-checkbox v-model="zapierTestEnable" class="d-block">Send Test Data</el-checkbox>
                                <p>* Please check the 'Send Test Data' checkbox and click 'Save' to send the test data to your Webhook.</p> -->
                            </div>
                        </div>
                        <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                @click="onSendTestLead"
                                circle
                                :disabled="isLoadingSendTestLead"
                                ></el-button>
                                <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                size="medium"
                                :icon="'el-icon-view'"
                                @click="onViewExampleData"
                                circle
                                ></el-button>
                                <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                            </div>
                        </div>
                    </div>

                    <div v-if="selectedIntegration === 'sendjim'" class="''">
                        <div class="has-label" v-if="selectedIntegration === 'sendjim'">
                            <el-checkbox v-model="selectedRowData.sendjim_is_active">Enable {{ nameIntegration }}</el-checkbox>
                        </div>
                        <div class="has-label mt-2">
                            <label class="mb-0">Enter Tags</label>
                            <el-select
                                style="width: 100%;"
                                v-model="sendjimTags"
                                multiple
                                filterable
                                allow-create
                                default-first-option
                                :reserve-keyword="false"
                                class="select-info select-fullwidth" 
                                size="large"
                                placeholder="Type and press enter to add tags">
                                <el-option
                                    v-for="option in sendjimTagsOptions"
                                    :key="option.name"
                                    class="select-info"
                                    :value="option.name"
                                    :label="option.name">
                                </el-option>
                            </el-select>
                        </div>
                        <el-divider content-position="left">Quick Send</el-divider>
                        <div class="has-label">
                            <el-checkbox v-model="sendjimQuickSendEnabled">Enable Quick Send</el-checkbox>
                        </div>
                        <div class="has-label" v-if="sendjimQuickSendEnabled">
                            <label class="mb-2">Select Templates</label>
                            <div class="sj-quicksend-grid">
                                <div
                                    v-for="tpl in sendjimQuickSendOptions"
                                    :key="tpl.id"
                                    class="sj-quicksend-item"
                                    :class="{ selected: sendjimQuickSendTemplates.includes(tpl.id) }"
                                    @click="toggleSendjimQuickSendTemplate(tpl.id)"
                                >
                                    <div class="sj-quicksend-name">{{ tpl.name || ('Template ' + tpl.id) }}</div>
                                </div>
                                <div v-if="!sendjimQuickSendOptions.length" class="sj-quicksend-empty">No templates found.</div>
                            </div>
                        </div>
                        <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <el-button
                                    size="medium"
                                    :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
                                    @click="onSendTestLead"
                                    circle
                                    :disabled="isLoadingSendTestLead"
                                ></el-button>
                                <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template slot="footer">
                <div class="integrations-modal-footer-wrapper">
                    <div class="d-flex align-items-center justify-content-end">
                        <base-button v-if="this.$global.settingMenuShow && !this.$global.systemUser" simple size="sm"  style="height:40px"
                            @click="openHelpModal(2)">
                            <i class="fas fa-question"></i>
                        </base-button>
                        <base-button simple @click.native="modals.integrations = false">Cancel</base-button>
                        <base-button @click.native="saveIntegrationConfiguration" :disabled="isLoadingSaveIntegration">{{ isLoadingSaveIntegration ? "Saving..." : 'Save' }}</base-button>
                    </div>
                </div>
            </template>
        </modal>
        <!-- Integrations modal -->



        <!-- Create campaign modal -->
        <modal :show.sync="modals.campaign" id="addCampaign"  bodyClasses='create-campaign-modal-body'
            footerClasses="border-top p-2">
            <h3 slot="header" class="title title-up">Create Campaign</h3>
            <div class="row">
                        
                       
                            <div v-if="this.$global.menuUserType != 'client'" class="col-sm-12 col-md-12 col-lg-12 has-label pull-left">
                                <div style="display: flex; flex-direction: column; margin-bottom: 15px;">
                                <label>{{CompanyNamedisabled ? 'Client Name' : 'Select Client Name'}}</label>
                                <el-select class="select__form__client" size="large" placeholder="Select Client Name"
                                v-model="selectsCompany.companySelected"
                                @change="onCompanyChange(selectsCompany.companySelected);" :disabled="CompanyNamedisabled">
                                
                                <el-option v-for="option in selectsCompany.companyList"
                                :value="option.id" :label="option.company_name" :key="option.id">
                                        </el-option>
                                    </el-select>
                                    <small style="color:#942434 !important;" v-if="err_companyselect">* Client Company is required</small>
                                </div>
                            </div>
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-12 col-md-12 col-lg-12" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Contact Name" type="text" placeholder="Input Client Contact Name"
                                v-model="ClientFullName">
                            </base-input>
                        </div>
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-6 col-md-6 col-lg-6" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Email" type="email" placeholder="Input Client Email"
                                 v-model="ClientEmail">
                            </base-input>
                        </div>
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-6 col-md-6 col-lg-6" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Phone Number" type="text" placeholder="Input Client Phone"
                               v-model="ClientPhone">
                            </base-input>
                        </div>
                        <span v-if="this.$global.menuUserType != 'client'" class="selerator-campaign-create"></span>
                        <div class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left">
                            <base-input label="Campaign Name" type="text" placeholder="Input Campaign Name"
                                v-model="ClientCampaignName" maxlength="190" max="190" class='mb-0 pb-0'>
                            </base-input>
                            <small id="err_campaignname" style="display:none;color:#942434 !important;">
                                * Campaign Name is required
                            </small>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <!-- <base-input label="The URL where you will place the code" type="text"
                                placeholder="https://yourdomain.com/url-code-place" 
                                v-model="ClientUrlCode" :maxlength="255"
                                @input="limitUrlCodeLength"
                                >
                                <template #helperText>
                                    <small>URL must not exceed 255 characters.</small>
                                    <p><small style="color:#942434 !important"><sup>**</sup>Ensure the URL matches the site where the embed code is placed.</small></p>
                                </template>
                            </base-input> -->
                            <div style="margin-block: 8px;">
                                <el-card shadow="never" style="margin-bottom: 0px;">
                                    <p style="color: #000000 !important;">The URL where you will place the code</p>
                                    <div style="display: flex; flex-direction: column; gap: 8px;">
                                        <div v-for="(url, index) in formUrlCodes" :key="index" style="display: flex; gap: 8px; width: 100%;">
                                            <base-input
                                                :maxlength="254"
                                                @input="validateURL(index)" 
                                                @keyup.enter="addUrl()"
                                                placeholder="https://yourdomain.com/url-code-place"
                                                v-model="formUrlCodes[index]" style="width: 100%; margin-bottom: 0px !important;">
                                            </base-input>
                                            <el-button
                                                v-if="formUrlCodes.length > 1"
                                                type="danger"
                                                icon="el-icon-delete"
                                                style="border-radius: 0.4285rem; padding: 10px 18px; height: calc(2.33571rem + 2px);"
                                                @click="removeUrl(index)"
                                                >
                                            </el-button>
                                        </div>
                                    </div>
                                    <small>URL must not exceed 255 characters.</small>
                                    <p><small style="color:#942434 !important"><sup>**</sup>Ensure the URL matches the site where the embed code is placed, and each URL must be unique.</small></p>
                                    <base-button v-if="formUrlCodes.length < 5" @click="addUrl()" :disabled="!canAddUrl" style="height: 35px; width: 100%;"><i class="fas fa-plus-circle" style="margin-right: 4px;"></i> Add URL</base-button>
                                </el-card>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12" v-if="GoogleConnectTrue">
                            <base-input label="Client Emails Approved to View the Google Sheet:" >
                                <textarea class="form-control input-border" v-model="ClientReportSentTo"
                                    placeholder="Put client emails here, separate by new line" rows="50" @keydown="handleGsheetKeydowncreate" @paste="handleGSheetPasteCreate">
                                </textarea>
                            </base-input>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 has-label form-group" v-if="userType != 'client'">
                            <label>Admins Approved for Google Sheet Administration</label>
                            <el-select multiple class="select-info select-fullwidth" size="large"
                                v-model="selectsAdministrator.administratorSelected"
                                placeholder="You can select multiple Admin">
                                <el-option v-for="option in selectsAdministrator.administratorList" class="select-info"
                                    :value="option.id" :label="option.name" :key="option.id">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="col-12 pt-2">
                            <div class="grid-container-campaign-information-local">
                                <el-card class="disabled" :shadow="campaignInformationData.includes('basic') ? 'always' : 'hover'" style="position: relative;" :class="{ 'campaign-information-active-local': campaignInformationData.includes('basic') }" @click.native="onChangeCampaignInformationData('basic')">
                                    <span v-if="campaignInformationData.includes('basic')" class="label__active">active</span>
                                    
                                    <i class="fas fa-user" style="font-size: 20px;"></i>
                                    <p style="font-size: 16px; font-weight: 600; margin: 0px;">Basic Information</p>
                                    <p style="font-size: 12px; opacity: 0.8; margin: 0px;">
                                        General data used for identification and standard purposes.
                                    </p>
                                </el-card>
                                <el-card :shadow="campaignInformationData.includes('advanced') ? 'always' : 'hover'" style="cursor: pointer; position: relative;" :class="{ 'campaign-information-active-local': campaignInformationData.includes('advanced') }" @click.native="onChangeCampaignInformationData('advanced')">
                                    <span v-if="campaignInformationData.includes('advanced')" class="label__active">active</span>
                                    
                                    <!-- <div style="display: flex; justify-content: space-between; align-items: center;">
                                        <span style="font-weight: 600; color: green; font-size: 18px; line-height: normal;">+ $1</span>
                                    </div> -->
                                    
                                    <i class="fa-solid fa-angles-up" style="font-size: 20px;"></i>
                                    <p style="font-size: 16px; font-weight: 600; margin: 0px;">Advanced Information</p>
                                    <p style="font-size: 12px; opacity: 0.8; margin: 0px;">
                                        Additional data for advanced features and specific needs.
                                    </p>
                                </el-card>
                                <!-- <div style="position: relative;">
                                    <div class="overlay-card">
                                        <span class="text-overlay">Coming Soon</span>
                                    </div>

                                    <el-card :shadow="campaignInformationData.includes('b2b') ? 'always' : 'hover'" style="cursor: pointer; position: relative;" :class="{ 'campaign-information-active-local': campaignInformationData.includes('b2b') }" @click.native="onChangeCampaignInformationData('b2b')">
                                        <span v-if="campaignInformationData.includes('b2b')" class="label__active">active</span>
                                        
                                        <div style="display: flex; justify-content: space-between; align-items: center;">
                                            <i class="fa-solid fa-building" style="font-size: 20px;"></i>
                                            <span style="font-weight: 600; color: green; font-size: 18px; line-height: normal;">+ $1</span>
                                        </div>
                                        <p style="font-size: 16px; font-weight: 600; margin: 0px;">Business to Business Information</p>
                                        <p style="font-size: 12px; opacity: 0.8; margin: 0px;">
                                            Information tailored for company-to-company transactions.
                                        </p>
                                    </el-card>
                                </div> -->
                            </div>
                        </div>
                      
                        <div class="col-12 pt-2">
                            <el-divider content-position="left" v-if="campaignInformationData.includes('basic')">Basic Information</el-divider>
                            <div class="row" v-if="campaignInformationData.includes('basic')">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <el-checkbox class="checkbox-advanced-information" v-model="checkAllBasic" @change="onCheckAllBasicInformation($event, 'add')">Check all</el-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="container-checkbox-item-advanced-information">
                                        <el-checkbox @input="openPhoneConfirmationModal('checkboxes', 'checkboxes')" class="checkbox-advanced-information" :value="checkboxes.phoneenabled">Enable
                                            Phone Number
                                        </el-checkbox>
                                        <el-checkbox class="checkbox-advanced-information" v-model="checkboxes.homeaddressenabled" @change="onCheckItemBasicInformation('add')">
                                            Enable Home Address
                                        </el-checkbox>
                                        <el-checkbox class="checkbox-advanced-information" v-model="checkboxes.requireemailaddress" @change="onCheckItemBasicInformation('add')">
                                            Require Email Address
                                        </el-checkbox>
                                        <el-checkbox class="checkbox-advanced-information" v-model="checkboxes.gtm" @change="onCheckItemBasicInformation('add')">
                                            This code is installed in a Tag Manager
                                        </el-checkbox>
                                    </div>
                                </div>
                            </div>
                            <el-divider content-position="left" v-if="campaignInformationData.includes('advanced')">Advanced Information</el-divider>
                            <div class="row" v-if="campaignInformationData.includes('advanced')">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div v-if="isLoadingAdvancedInformation">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                    <div v-else-if="isErrorAdvancedInformation" class="error-banner">Oops! Something went wrong. Please refresh the page and try again.</div>
                                    <div v-else>
                                        <div>
                                            <el-checkbox class="checkbox-advanced-information" v-model="checkAllAdvanced" @change="onCheckAllAdvancedInformation">Check all</el-checkbox>
                                        </div>
                                        <div class="container-checkbox-item-advanced-information">
                                            <div v-for="(value) in listAdvancedInformation" :key="value.type">
                                                <el-checkbox class="checkbox-advanced-information" :label="value.id" v-model="idAdvancedInformation" @change="onCheckItemAdvancedInformation">{{value.name}}</el-checkbox>
                                                <el-popover
                                                    :title="value.name"
                                                    width="220"
                                                    trigger="hover"
                                                    placement="right"
                                                >
                                                    <ul style="list-style-type: disc;">
                                                        <li style="color: #222a42 !important;" v-for="(item, index) in value.description" :key="index">{{ item }}</li>
                                                    </ul>
                                                    <i slot="reference" class="fa fa-question-circle" style="cursor: pointer; margin-left: 8px;"></i>
                                                </el-popover>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <el-divider content-position="left" v-if="campaignInformationData.includes('b2b')">Business to Business Information</el-divider>
                            <div class="row" v-if="campaignInformationData.includes('b2b')">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div v-if="isLoadingAdvancedInformationB2b">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                    <div v-else-if="isErrorAdvancedInformationB2b" class="error-banner">Oops! Something went wrong. Please refresh the page and try again.</div>
                                    <div v-else>
                                        <div>
                                            <el-checkbox class="checkbox-advanced-information" v-model="checkAllAdvancedB2b" @change="onCheckAllAdvancedInformationB2b">Check all</el-checkbox>
                                        </div>
                                        <div class="container-checkbox-item-advanced-information">
                                            <div v-for="(value) in listAdvancedInformationB2b" :key="value.type">
                                                <el-checkbox class="checkbox-advanced-information" :label="value.id" v-model="idAdvancedInformationB2b" @change="onCheckItemAdvancedInformationB2b">{{value.name}}</el-checkbox>
                                                <!-- <el-popover
                                                    :title="value.name"
                                                    width="220"
                                                    trigger="hover"
                                                    placement="right"
                                                >
                                                    <ul style="list-style-type: disc;">
                                                        <li style="color: #222a42 !important;" v-for="(item, index) in value.description" :key="index">{{ item }}</li>
                                                    </ul>
                                                    <i slot="reference" class="fa fa-question-circle" style="cursor: pointer; margin-left: 8px;"></i>
                                                </el-popover> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <el-divider v-if="campaignInformationData.length > 0"></el-divider>
                        </div>
                        <!-- </div> -->

                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                            <label>Contact Re-identification Time Limit:</label>
                            <div class="leads-re-identification-selector-wrapper">
                                <div v-for='item in ReidentificationTimeOptions.slice().reverse()' :key='item.value' :class="['leads-re-identification-selector',{'--active': Reidentificationtime == item.value}]" @click='Reidentificationtime = item.value'>
                                    {{item.label}}
                                </div>
                            </div>
                            <base-checkbox class="pt-2" name="ApplyReidentificationToAll" v-model="checkboxes.ApplyReidentificationToAll" inline>Do not identify contacts already identified on other campaigns.</base-checkbox>
                            <br /><small>* Your contact could be Re-identified after the time limit you select.</small>
                        </div>
                       
                        <div hidden v-if="this.$global.globalviewmode" class="col-sm-12 col-md-12 col-lg-12 pt-4">
                            <div class="pb-2">
                                <el-radio @change="stateSelected" v-model="includeExclude" label="0">Exclude selected states</el-radio>
                                <el-radio @change="stateSelected" v-model="includeExclude" label="1">Get contacts from selected states only</el-radio>
                            </div>
                              <div class="row">
                                  <div class="col-sm-12 col-md-12 col-lg-12" id="state-selector-wrapper">
                                          <base-input style='border:none !important;'>
                                              <el-select
                                                  id="statelist"
                                                  v-model="selects.state"
                                                  class="select-primary "
                                                  name="statelist"
                                                  inline
                                                  size="large"
                                                  :placeholder="includeExclude === '0' ? 'select states to exclude' : 'select states to get contact from'"
                                                  filterable
                                                  default-first-option
                                                  multiple
                                                  
                                                  >
                                                  <el-option
                                                  v-for="option in selects.statelist"
                                                  class="select-primary"
                                                  :label="option.state_name"
                                                  :value="option.state_code"
                                                  :key="option.state_code"
                                                  ></el-option>
                                              </el-select>
                                          </base-input>
                                  </div>
                              </div>
                              <div style="background-color: #ffd7a3;color: white;border-color: #ab6100;margin-top: 8px" class="warning-banner"><p>By default system will deliver contacts from all states of USA.</p></div>
                        </div>
                    </div>
                    <template slot="footer">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                       
                            <base-button size="sm" class="pull-right" id="btnSave" style="height:40px"
                                @click="ProcessAddEditClient('')">
                                Save
                            </base-button>
                            <base-button simple size="sm" class="pull-right mr-4" style="height:40px"
                                @click="CancelAddEditClient('')">
                                Cancel
                            </base-button>
                            <base-button v-if="this.$global.settingMenuShow && !this.$global.systemUser" simple size="sm" class="mr-4 pull-right" style="height:40px"
                                @click="openHelpModal(0)">
                                <i class="fas fa-question"></i>
                            </base-button>
                        </div>
                    </template>
        </modal>
          <!-- create campaign modal end -->
          <!-- edit campaign modal start -->
            <modal :show.sync="modals.campaignEdit" id="editCampaign"  bodyClasses='create-campaign-modal-body'
            footerClasses="border-top p-2">
                <h3 slot="header" class="title title-up">Edit Campaign #{{selectedRowData.leadspeek_api_id}}</h3>
                <div class="row">
                  
                    <div v-if="this.$global.menuUserType != 'client'" class="col-sm-12 col-md-12 col-lg-12" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Client Name" type="text" placeholder="Input Client Name"
                                v-model="selectedRowData.company_name">
                            </base-input>
                    </div>
                    <div v-if="this.$global.menuUserType != 'client'" class="col-sm-12 col-md-12 col-lg-12" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Contact Name" type="text" placeholder="Input Client Contact Name"
                                v-model="selectedRowData.name">
                            </base-input>
                    </div>
                    <div v-if="this.$global.menuUserType != 'client'" class="col-sm-6 col-md-6 col-lg-6" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Email" type="email" placeholder="Input Client Email"
                                 v-model="selectedRowData.email">
                            </base-input>
                        </div>
                        <div v-if="this.$global.menuUserType != 'client'" class="col-sm-6 col-md-6 col-lg-6" style="cursor: not-allowed;">
                            <base-input class="disabled" label="Phone Number" type="text" placeholder="Input Client Phone"
                               v-model="selectedRowData.phonenum">
                            </base-input>
                        </div>
                        <span v-if="this.$global.menuUserType != 'client'" class="selerator-campaign-create"></span>
                        <div class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left">
                            <base-input label="Campaign Name" type="text" placeholder="Input Campaign Name"
                                v-model="selectedRowData.campaign_name" :maxlength="255" class='mb-0 pb-0'>
                            </base-input>
                            <small id="err_campaignname" style="display:none;color:#942434 !important;">
                                * Campaign Name is required
                            </small>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <!-- <base-input label="The URL where you will place the code" type="text"
                                placeholder="https://yourdomain.com/url-code-place" 
                                v-model="selectedRowData.url_code" :maxlength="255"   @input="limitUrlCodeLengthEdit(scope.row)">
                                <template #helperText>
                                    <small>URL must not exceed 255 characters.</small>
                                    <p><small style="color:#942434 !important"><sup>**</sup>Ensure the URL matches the site where the embed code is placed.</small></p>
                                </template>
                            </base-input> -->
                            <div style="margin-block: 8px;">
                                <el-card shadow="never" style="margin-bottom: 0px;">
                                    <p style="color: #000000 !important;">The URL where you will place the code</p>
                                    <div style="display: flex; flex-direction: column; gap: 8px;">
                                        <div v-for="(url, index) in formUrlCodes" :key="index" style="display: flex; gap: 8px; width: 100%;">
                                            <base-input
                                                :maxlength="254"
                                                @input="validateURL(index)" 
                                                @keyup.enter="addUrl()"
                                                placeholder="https://yourdomain.com/url-code-place"
                                                v-model="formUrlCodes[index]" style="width: 100%; margin-bottom: 0px !important;">
                                            </base-input>
                                            <el-button
                                                v-if="formUrlCodes.length > 1"
                                                type="danger"
                                                icon="el-icon-delete"
                                                style="border-radius: 0.4285rem; padding: 10px 18px; height: calc(2.33571rem + 2px);"
                                                @click="removeUrl(index)"
                                                >
                                            </el-button>
                                        </div>
                                    </div>
                                    <small>URL must not exceed 255 characters.</small>
                                    <p><small style="color:#942434 !important"><sup>**</sup>Ensure the URL matches the site where the embed code is placed, and each URL must be unique.</small></p>
                                    <base-button v-if="formUrlCodes.length < 5" @click="addUrl()" :disabled="!canAddUrl" style="height: 35px; width: 100%;"><i class="fas fa-plus-circle" style="margin-right: 4px;"></i> Add URL</base-button>
                                </el-card>
                            </div>
                        </div>
                        <div class="col-12 pt-2" v-if="checkCampaignInformationTypeLocal">
                            <div class="grid-container-campaign-information-local">
                                <el-card 
                                    class="disabled" 
                                    :class="{ 'campaign-information-active-local': selectedRowData.campaign_information_type_local.includes('basic') }" 
                                    :shadow="selectedRowData.campaign_information_type_local.includes('basic') ? 'always' : 'hover'" 
                                    style="position: relative;" 
                                    @click.native="onChangeRowCampaignInformationData('basic')">
                                    <span v-if="selectedRowData.campaign_information_type_local.includes('basic')" class="label__active">active</span>

                                    <i class="fas fa-user" style="font-size: 20px;"></i>
                                    <p style="font-size: 16px; font-weight: 600; margin: 0px;">Basic Information</p>
                                    <p style="font-size: 12px; opacity: 0.8; margin: 0px;">
                                        General data used for identification and standard purposes.
                                    </p>
                                </el-card>
                                <el-card 
                                    :class="{ 
                                        'campaign-information-active-local': selectedRowData.campaign_information_type_local.includes('advanced'),
                                        'disabled': cardAdvanceInformationReadOnly
                                    }" 
                                    :shadow="selectedRowData.campaign_information_type_local.includes('advanced') ? 'always' : 'hover'" 
                                    style="cursor: pointer; position: relative;" 
                                    @click.native="onChangeRowCampaignInformationData('advanced')">
                                    <span v-if="selectedRowData.campaign_information_type_local.includes('advanced')" class="label__active">active</span>

                                    <i class="fa-solid fa-angles-up" style="font-size: 20px;"></i>
                                    <p style="font-size: 16px; font-weight: 600; margin: 0px;">Advanced Information</p>
                                    <p style="font-size: 12px; opacity: 0.8; margin: 0px;">
                                        Additional data for advanced features and specific needs.
                                    </p>
                                </el-card>
                                <!-- <div style="position: relative;">
                                    <div class="overlay-card">
                                        <span class="text-overlay">Coming Soon</span>
                                    </div>

                                    <el-card :shadow="selectedRowData.campaign_information_type_local.includes('b2b') ? 'always' : 'hover'" style="cursor: pointer; position: relative;" :class="{ 'campaign-information-active-local': selectedRowData.campaign_information_type_local.includes('b2b') }" @click.native="onChangeRowCampaignInformationData('b2b')">
                                        <span v-if="selectedRowData.campaign_information_type_local.includes('b2b')" class="label__active">active</span>
                                        
                                        <i class="fa-solid fa-building" style="font-size: 20px;"></i>
                                        <p style="font-size: 16px; font-weight: 600; margin: 0px;">Business to Business Information</p>
                                        <p style="font-size: 12px; opacity: 0.8; margin: 0px;">
                                            Information tailored for company-to-company transactions.
                                        </p>
                                    </el-card>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-12 pt-2" v-if="checkCampaignInformationTypeLocal">
                            <el-divider content-position="left" v-if="selectedRowData.campaign_information_type_local.includes('basic')">Basic Information</el-divider>
                            <div class="row" v-if="selectedRowData.campaign_information_type_local.includes('basic')">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <el-checkbox class="checkbox-advanced-information" v-model="rowCheckAllBasic" @change="onCheckAllBasicInformation($event, 'edit')">Check all</el-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="container-checkbox-item-advanced-information">
                                        <el-checkbox @input="openPhoneConfirmationModal('rowCheckboxes', 'selectedRowData')" class="checkbox-advanced-information" :value="rowCheckboxes.phoneenabled">Enable
                                            Phone Number
                                        </el-checkbox>
                                        <el-checkbox class="checkbox-advanced-information" v-model="rowCheckboxes.homeaddressenabled" @change="onCheckItemBasicInformation('edit')">
                                            Enable Home Address
                                        </el-checkbox>
                                        <el-checkbox class="checkbox-advanced-information" v-model="rowCheckboxes.require_email" @change="onCheckItemBasicInformation('edit')">
                                            Require Email Address
                                        </el-checkbox>
                                        <el-checkbox class="checkbox-advanced-information" v-model="rowCheckboxes.gtm" @change="onCheckItemBasicInformation('edit')">
                                            This code is installed in a Tag Manager
                                        </el-checkbox>
                                    </div>
                                    <!-- <div  class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                        <el-checkbox   @input="openPhoneConfirmationModal('rowCheckboxes', 'selectedRowData')" class="brand-checkbox" name="enabledphonenumber"  :value="rowCheckboxes.phoneenabled" inline>Enable
                                            Phone Number</el-checkbox>
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <base-checkbox name="enabledhomeaddress" v-model="rowCheckboxes.homeaddressenabled"
                                            inline>Enable Home Address</base-checkbox>
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <base-checkbox name="requireemailaddress" v-model="rowCheckboxes.require_email"
                                            inline>Require Email Address</base-checkbox>
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                    <base-checkbox @change="chkHideShowGTM(selectedRowData)" value="T"
                                    :checked="selectedRowData.gtminstalled == 'T' ? true : false" inline>
                                        This code is installed in a Tag Manager
                                    </base-checkbox>
                                </div> -->
                                </div>
                            </div>
                            <el-divider content-position="left" v-if="selectedRowData.campaign_information_type_local.includes('advanced')">Advanced Information</el-divider>
                            <div class="row" v-if="selectedRowData.campaign_information_type_local.includes('advanced')">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div v-if="isLoadingAdvancedInformation">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                    <div v-else-if="isErrorAdvancedInformation" class="error-banner">Oops! Something went wrong. Please refresh the page and try again.</div>
                                    <div v-else>
                                        <div>
                                            <el-checkbox class="checkbox-advanced-information" v-model="rowCheckAllAdvanced" @change="onRowCheckAllAdvancedInformation">Check all</el-checkbox>
                                        </div>
                                        <div class="container-checkbox-item-advanced-information">
                                            <div v-for="(value) in listAdvancedInformation" :key="value.type">
                                                <el-checkbox class="checkbox-advanced-information" :label="value.id" v-model="rowIdAdvancedInformation" @change="onRowCheckItemAdvancedInformation">{{value.name}}</el-checkbox>
                                                <el-popover
                                                    :title="value.name"
                                                    width="220"
                                                    trigger="hover"
                                                    placement="right"
                                                >
                                                    <ul style="list-style-type: disc;">
                                                        <li style="color: #222a42 !important;" v-for="(item, index) in value.description" :key="index">{{ item }}</li>
                                                    </ul>
                                                    <i slot="reference" class="fa fa-question-circle" style="cursor: pointer; margin-left: 8px;"></i>
                                                </el-popover>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <el-divider content-position="left" v-if="selectedRowData.campaign_information_type_local.includes('b2b')">Business to Business Information</el-divider>
                            <div class="row" v-if="selectedRowData.campaign_information_type_local.includes('b2b')">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div v-if="isLoadingAdvancedInformationB2b">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                    <div v-else-if="isErrorAdvancedInformationB2b" class="error-banner">Oops! Something went wrong. Please refresh the page and try again.</div>
                                    <div v-else>
                                        <div>
                                            <el-checkbox class="checkbox-advanced-information" v-model="rowCheckAllAdvancedB2b" @change="onRowCheckAllAdvancedInformationB2b">Check all</el-checkbox>
                                        </div>
                                        <div class="container-checkbox-item-advanced-information">
                                            <div v-for="(value) in listAdvancedInformationB2b" :key="value.type">
                                                <el-checkbox class="checkbox-advanced-information" :label="value.id" v-model="rowIdAdvancedInformationB2b" @change="onRowCheckItemAdvancedInformationB2b">{{value.name}}</el-checkbox>
                                                <!-- <el-popover
                                                    :title="value.name"
                                                    width="220"
                                                    trigger="hover"
                                                    placement="right"
                                                >
                                                    <ul style="list-style-type: disc;">
                                                        <li style="color: #222a42 !important;" v-for="(item, index) in value.description" :key="index">{{ item }}</li>
                                                    </ul>
                                                    <i slot="reference" class="fa fa-question-circle" style="cursor: pointer; margin-left: 8px;"></i>
                                                </el-popover> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <el-divider v-if="selectedRowData.campaign_information_type_local.length > 0"></el-divider>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                            <label>Contact Re-identification Time Limit:</label>
                            <div class="leads-re-identification-selector-wrapper">
                                <div v-for='item in ReidentificationTimeOptions.slice().reverse()' :key='item.value' :class="['leads-re-identification-selector',{'--active': selectedRowData.reidentification_type == item.value}]" @click='selectedRowData.reidentification_type = item.value'>
                                    {{item.label}}
                                </div>
                            </div>
                            <base-checkbox class="pt-2" name="ApplyReidentificationToAll" v-model="rowCheckboxes.applyreidentificationall" inline>Do not identify contacts already identified on other campaigns.</base-checkbox>
                            <br /><small>* Your contact could be Re-identified after the time limit you select.</small>
                        </div>
                        <div hidden v-if="this.$global.globalviewmode" class="col-sm-12 col-md-12 col-lg-12 pt-4">
                            <div class="pb-2">
                                <el-radio @change="stateSelected" v-model="includeExclude" label="0">Exclude selected states</el-radio>
                                <el-radio @change="stateSelected" v-model="includeExclude" label="1">Get contacts from selected states only</el-radio>
                            </div>
                              <div class="row">
                                  <div class="col-sm-12 col-md-12 col-lg-12" id="state-selector-wrapper">
                                          <base-input style='border:none !important;'>
                                              <el-select
                                                  id="statelist"
                                                  v-model="selects.state"
                                                  class="select-primary "
                                                  name="statelist"
                                                  inline
                                                  size="large"
                                                  :placeholder="includeExclude === '0' ? 'select states to exclude' : 'select states to get contact from'"
                                                  filterable
                                                  default-first-option
                                                  multiple
                                                  
                                                  >
                                                  <el-option
                                                  v-for="option in selects.statelist"
                                                  class="select-primary"
                                                  :label="option.state_name"
                                                  :value="option.state_code"
                                                  :key="option.state_code"
                                                  ></el-option>
                                              </el-select>
                                          </base-input>
                                  </div>
                              </div>
                              <div style="background-color: #ffd7a3;color: white;border-color: #ab6100;margin-top: 8px" class="warning-banner"><p>By default system will deliver contacts from all states of USA.</p></div>
                        </div>
                 </div>
                 <template slot="footer">
                        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex flex-row-reverse flex-wrap" style="gap:8px">
                            <base-button v-if="$global.menuLeadsPeek_update" size="sm"
                                                   :id="'btnSave' + selectedRowData.id" style="height:40px"
                                                    @click="ProcessAddEditClient(selectedRowData)">
                                                    Save
                                                </base-button>
                                                <base-button size="sm"  style="height:40px"
                                                    @click="CancelAddEditClient(selectedRowData)">
                                                    Cancel
                                                </base-button>
                                                <base-button v-if="selectedRowData.report_type == 'GoogleSheet' && GoogleConnectTrue" size="sm"
                                                    :id="'btnResend' + selectedRowData.id"
                                                    style="height:40px" @click="ResendLink(selectedRowData)">
                                                    Resend Google Sheet Link
                                                </base-button>
                                                <base-button v-if="this.$global.settingMenuShow && !this.$global.systemUser" simple size="sm" class="mr-4 pull-right" style="height:40px"
                                                    @click="openHelpModal(0)">
                                                    <i class="fas fa-question"></i>
                                                 </base-button>
                        </div>
                </template>
            </modal>
          <!-- edit campaign modal end -->
          <modal :show.sync="modals.helpVideos" headerClasses="">
            <div slot="header" class="d-flex flex-column gap-4"><h4  class="title title-up">{{activeHelpItem.title}}</h4> 
              
             </div>
            <div v-if="modals.helpVideos" v-html="activeHelpItem.embedVideoCode"></div>
            <p class="text-dark mt-4" style="font-size: 14px;" v-html="activeHelpItem.desc"></p>
        </modal>

        <div id="popProcessing" class="popProcessing" style="display:none" v-html="popProcessingTxt">Please wait, updating
            campaign ....</div>
            <VTour name="myTour" :steps="steps" :callbacks="tourCallbacks" :options="{ highlight: true }"></VTour>
    </div>
</template>
<script>
import { DatePicker, Table, TableColumn, Select, Option, Checkbox, Tabs, TabPane, Badge, Switch, Dropdown, DropdownMenu, DropdownItem, CollapseItem, Collapse, RadioGroup, Radio, Button, Alert, Upload, Menu, MenuItem, MenuItemGroup, Input, Form, FormItem, ColorPicker, Tag, Progress, Card, Popover, Divider, Timeline, TimelineItem, MessageBox } from 'element-ui';
import { BasePagination, Modal } from 'src/components';
import SelectClientDropdown from '@/components/SelectClientDropdown.vue'
import Fuse from 'fuse.js';
import swal from 'sweetalert2';
import { dispatch, json } from 'd3';
import axios from 'axios';
import moment from 'moment';
import BaseInput from '../../../../components/Inputs/BaseInput.vue';
const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
var CHECK_GROUPCOMPANY;
import { mapActions } from "vuex";
import VTour from '../../../../components/Tour/VTour.vue';
import { decryptData } from '../../../../helpers/crypto'

export default {
    components: {
        Modal,
        //Collapse,
        VTour,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Checkbox.name]: Checkbox,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Badge.name]: Badge,
        [Switch.name]: Switch,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Divider.name]: Divider,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Button.name]: Button,
        [Alert.name]: Alert,
        [Upload.name]: Upload,
        [Menu.name]: Menu,
        [MenuItemGroup.name]: MenuItemGroup,
        [MenuItem.name]: MenuItem,
        [Input.name]: Input,
        [Form.name]: Form,
        [FormItem.name]: FormItem,
        [ColorPicker.name]: ColorPicker,
        [Tag.name]: Tag,
        [Progress.name]: Progress,
        [Popover.name]: Popover,
        [Timeline.name]: Timeline,
        [TimelineItem.name]: TimelineItem,
        'el-card': Card,
        BasePagination,
        BaseInput,
        SelectClientDropdown,
    },
    data() {
        return {
            helpContentMap: [
                {   
                    title:'Agency Site Campaign Creation',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/14KMM2Wbb5vmc-TSiWFNqLrBOzz-p4mwd/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:'Lets create a Site campaign, In the upper right corner of your screen you will click Add Campaign<br>If you have already selected the client on the main dashboard, their name will appear at the top for a reference to make sure you are creating a campaign for the correct client. If you were viewing all your clients then you will select your client at this point.<br>In the campaign name, You will want to give the campaign a very clear name, such as homepage for ABC landscaping. This field is searchable so be descriptive.<br>In the URL section, you want to put the main URL where you are actually placing the code. One campaign code is good for an entire website as long as it is placed in the global head. You do not need a campaign per page. When the contact is identified we will display the complete URL of the landing page including any Facebook or Google ID or any UTM information in the URL.<br>Your clients email address is preloaded to be a viewer in the Google sheet, if you are using the Google sheet integration. You may also put additional email addresses to add them as viewers. One per line.<br>You may add additional administrators here in the box and select them. They will receive notifications about the campaign as well as be added as an editor to the Google sheet.<br>Next you will select the data options that will correspond with your campaign goals.<br>Next to you will check this box if you are putting the embed code in a tag manager. Our servers check to make sure the code is installed properly and when it is installed in a tag manager we will modify this process.<br>Finally you will select your Re-identification options. This setting depends on the industry of your client. Some industries will gladly pay to receive a notification when someone comes back to their website after a certain amount of time.<br>The final option is to block cross campaign identification. This is not typically used.<br>After ensuring that everything looks good. Press the Save button and the campaign will be created. The next steps are to install the identification code on the clients website, verify the financial settings, verify the Integrations and then press Play to begin identifying website traffic..<br>Editing a campaign is a similar process. You may edit a campaign while it is running, paused or stopped. There is no need to stop a campaign to edit it.'
                },
                {   
                    title:'Agency Site Embed Code',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/1_X9mia303zidQ1S7Fh41mYKEY7SGsuhq/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:'This is where you will find the embed code that corresponds to this specific campaign. Make sure to copy and paste the entire code and do not format the text if you are sharing it to a team member.<br>A common mistake occurs if this code is shared as a simple text paste in slack.<br>To avoid this issue you can press the back tick button three times in slack ``` and it will change the slack text box into a code text box.<br>A great way to share it is by using Notepad to ensure the code integrity and to save it in a plain text .txt document and then attach that .txt document to the email or message. Do not share it in a word mac document.'
                },
                {   
                    title:'Agency Campaign Integrations and Plugins',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/1qpxWlUPJzXY8lRdLKchWOcR25PvyXvPG/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:"Here you can control the integrations and plugins on the campaign level on behalf of your client. As long as the API key is connected to the client's account, then the integration will appear here to be managed.<br>If you give your clients campaign edit access, they also have the ability to add Integration API keys under their profile in the lower left corner, and to adjust the integrations on a per-campaign basis.<br>As you add integrations to this campaign, make sure to check the box to connect to the particular integration and then also select the tags, or options, or lists that are appropriate for that client's needs. We do pull the lists and tags from the integration partner and display them as options to be selected. We also allow you to type in a tag and it will be created in the clients highlevel account.<br>If you are working with the webhooks, make sure that the webhook is set up as a POST web hook and that there are no firewalls or other security measures keeping our servers from sending the data. You can also add additional tags to the webhook. You can also send test data multiple times by checking the box to send test data and clicking the save button. This will allow you to troubleshoot and configure your web hook to your client's needs.<br>Make sure that the checkbox to enable the particular integration or web hook is checked and make sure to click the save button when you are done editing.<br>Clicking the add integration button will simply take you to your client management screen where you can then add their API keys as needed"
                },
                { 
                    title: 'Site ID Basic Information',
                    desc: "Site ID campaigns can use either Basic information or Advanced information, similar to Enhance ID. You must set the retail price for each of these data options independently of each other.",
                    embedVideoCode: '<iframe src="https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/basicdata.jpeg" width="100%" height=180></iframe>'
                },
                {
                    title: 'Site ID Advanced Information',
                    desc: "Site ID campaigns can use either Basic information or Advanced information, similar to Enhance ID. You must set the retail price for each of these data options independently of each other.",
                    embedVideoCode: '<iframe src="https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/advancedata.jpeg" width="100%" height=230></iframe>'
                }
            ],
            activeHelpItem: {   
                title:'Agency Site Campaign Creation',
                embedVideoCode:'<iframe src="https://drive.google.com/file/d/14KMM2Wbb5vmc-TSiWFNqLrBOzz-p4mwd/preview" width="100%" height="480" allow="autoplay"></iframe>',
                desc:'Lets create a Site campaign, In the upper right corner of your screen you will click Add Campaign<br>If you have already selected the client on the main dashboard, their name will appear at the top for a reference to make sure you are creating a campaign for the correct client. If you were viewing all your clients then you will select your client at this point.<br>In the campaign name, You will want to give the campaign a very clear name, such as homepage for ABC landscaping. This field is searchable so be descriptive.<br>In the URL section, you want to put the main URL where you are actually placing the code. One campaign code is good for an entire website as long as it is placed in the global head. You do not need a campaign per page. When the contact is identified we will display the complete URL of the landing page including any Facebook or Google ID or any UTM information in the URL.<br>Your clients email address is preloaded to be a viewer in the Google sheet, if you are using the Google sheet integration. You may also put additional email addresses to add them as viewers. One per line.<br>You may add additional administrators here in the box and select them. They will receive notifications about the campaign as well as be added as an editor to the Google sheet.<br>Next you will select the data options that will correspond with your campaign goals.<br>Next to you will check this box if you are putting the embed code in a tag manager. Our servers check to make sure the code is installed properly and when it is installed in a tag manager we will modify this process.<br>Finally you will select your Re-identification options. This setting depends on the industry of your client. Some industries will gladly pay to receive a notification when someone comes back to their website after a certain amount of time.<br>The final option is to block cross campaign identification. This is not typically used.<br>After ensuring that everything looks good. Press the Save button and the campaign will be created. The next steps are to install the identification code on the clients website, verify the financial settings, verify the Integrations and then press Play to begin identifying website traffic..<br>Editing a campaign is a similar process. You may edit a campaign while it is running, paused or stopped. There is no need to stop a campaign to edit it.'
            },
            dummyCampaignData:{
    "id": 'dummy-campaign-item',
    "report_type": "GoogleSheet",
    "leadspeek_type": "local",
    "leadspeek_locator_zip": "",
    "leadspeek_locator_desc": null,
    "leadspeek_locator_keyword": "",
    "leadspeek_locator_keyword_contextual": "",
    "leadspeek_locator_state": "",
    "leadspeek_locator_state_external": "",
    "gtminstalled": "T",
    "leadspeek_locator_city": "",
    "leadspeek_locator_city_external": "",
    "leadspeek_locator_require": "FirstName,LastName,MailingAddress,Phone",
    "hide_phone": "T",
    "national_targeting": "F",
    "location_target": "Focus",
    "start_billing_date": "2024-06-24 02:58:33",
    "phoneenabled": "T",
    "homeaddressenabled": "T",
    "reidentification_type": "never",
    "require_email": "T",
    "file_url": "",
    "report_sent_to": "harrison+clientailead@exactmatchmarketing.com\nharrison.budiman@gmail.com\nharrison@uncommonreach.com\ndaniel@exactmatchmarketing.com",
    "admin_notify_to": [
        143,
        165
    ],
    "leadspeek_api_id": "123456",
    "active": "F",
    "disabled": "T",
    "active_user": "T",
    "clientorganizationid": "123456",
    "clientcampaignsid": "",
    "leads_amount_notification": 500,
    "total_leads": 6,
    "last_lead_added": "03-22-2024",
    "spreadsheet_id": "absced_dummy",
    "filename": "",
    "customer_payment_id": "absced_dummy",
    "customer_card_id": "absced_dummy",
    "company_parent": 'abs',
    "company_root_id": 'abs',
    "ongoing_leads": 0,
    "last_lead_check": "22-03-2024",
    "lifetime_cost": 30,
    "cost_perlead": 3,
    "lp_max_lead_month": 0,
    "lp_min_cost_month": 2,
    "paymentterm": "Prepaid",
    "continual_buy_options": false,
    "topupoptions": "onetime",
    "leadsbuy": 50,
    "stopcontinual": "F",
    "platformfee": 1,
    "lp_limit_startdate": "2024-06-21 00:00:00",
    "lp_enddate": "",
    "report_frequency_id": "5_minutes",
    "lp_limit_leads": 9,
    "lp_limit_freq": "day",
    "user_id": 151,
    "name": "Client Name",
    "email": "harrison+clientailead@exactmatchmarketing.com",
    "phonenum": "(989) 898-9898",
    "company_name": "Client Name",
    "company_id": 'abs',
    "group_company_id": 'abs',
    "campaign_name": "NY Realtor New",
    "campaign_startdate": "0000-00-00 00:00:00",
    "campaign_enddate": "",
    "ori_campaign_startdate": "0000-00-00 00:00:00",
    "ori_campaign_enddate": "",
    "url_code": "https://test.com",
    "url_code_thankyou": "",
    "url_code_ads": "",
    "embeddedcode_crawl": "T",
    "embedded_status": "test.com<br/>(Make sure the domain begins with https:// or domain can not be found)",
    "questionnaire_answers": "\"\"",
    "trysera": "F",
    "archived": "F",
    "timezone": "America/Chicago",
    "applyreidentificationall": "F",
    "m_paymentterm": "Weekly",
    "m_platformfee": 0,
    "m_lp_max_lead_month": null,
    "m_lp_min_cost_month": null,
    "m_cost_perlead": null,
    "m_lp_limit_leads": 0,
    "m_lp_limit_freq": "day",
    "m_lp_limit_startdate": null,
    "m_lp_enddate": null,
    "sendgrid_is_active": 0,
    "googlesheet_is_active": 0,
    "sendgrid_action": "",
    "sendgrid_list": "",
    "ghl_is_active": 0,
    "payment_status": "success",
    "created_at": "2023-12-07T04:41:18.000000Z",
    "target_nt": false,
    "target_state": false,
    "target_city": false,
    "target_zip": false,
    "selects_state": [],
    "selects_citylist": [],
    "selects_city": [],
    "selects_citystate": [],
    "selects_citystatelist": [],
    "leadspeek_locator_keyword_bulk": "",
    "total_cost": 18,
    "yerterday_leads": 0,
    "yerterday_previous_leads": 0
},
            steps: [
          {
            target: '.campaign-filter-item-wrapper', 
            content: 'Sort your campaigns to see only the statuses you are looking for',
            // params: {
            //   placement: 'top'
            // }
            params: {
                 enableScrolling: false,
            },
          },
          {
            target: '.container__input__campaign__management',  // We're using document.querySelector() under the hood
            content: 'Search by campaign name or ID',
            params: {
                 enableScrolling: false,
            },
          },
        //   {
        //     target: '.client-filter-anchor',  // We're using document.querySelector() under the hood
        //     content: 'Filter to view only specific clients',
        //     params: {
        //          enableScrolling: false,
        //     },
        //   },
          {
            target: '.create-campaign-anchor',
            content: this.$global.settingMenuShow && !this.$global.systemUser ? "<span style='display:block;margin-bottom:6px;'>Click here to add a new campaign</span><br><iframe src='https://drive.google.com/file/d/14KMM2Wbb5vmc-TSiWFNqLrBOzz-p4mwd/preview' width='800'' height='360' allow='autoplay'></iframe>" : "Click here to add a new campaign",
            params: {
                 enableScrolling: false,
            },
         
          },
          {
            target: '.campaign-card-client-name',
            content: 'This is the name of your client',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.campain-card-name',
            content: 'This is the name of your campaign.',
            params: {
                 enableScrolling: false,
            },
          },
          {
            target: '.campaign-card-status-badge',
            content: 'This is the current status of the campaign',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.campaign-card-update-date',
            content: 'This is the date that the campaign last received contacts',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.stat-block-id-anchor',
            content: 'This is the campaign ID, Please reference this when opening any support requests',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.stat-block-total-anchor',
            content: 'This is the total number of contacts ever generated by this campaign',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.stat-block-yesterday-anchor',
            content: 'This is the number of contacts generated Yesterday by this campaign',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.edit-btn-anchor',
            content: 'Click this button to edit the campaign. A campaign can </br> be edited at any time and during any status',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.embed-code-button',
            
            content: this.$global.settingMenuShow && !this.$global.systemUser ? "<span style='display:block;text-align:left;'>Click this button to get a copy of the Embed Code for this campaign. </br>Remember, do not share this code with Slack or any messaging system that will format the text</span><br><iframe src='https://drive.google.com/file/d/1_X9mia303zidQ1S7Fh41mYKEY7SGsuhq/preview' width='800'' height='360' allow='autoplay'></iframe>" : 'Click this button to get a copy of the Embed Code for this campaign. </br>Remember, do not share this code with Slack or any messaging system that will format the text',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.campaign-financials-btn',
            content: ' Click this button to edit the financials for this campaign, </br>including the maximum number of contacts per day.',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.campaign-integration-btn',
            
            content: this.$global.settingMenuShow && !this.$global.systemUser ? "<span style='display:block;text-align:left;'>Click this button to add or edit the Plugins and </br> Integrations for this campaign</span><br><iframe src='https://drive.google.com/file/d/1qpxWlUPJzXY8lRdLKchWOcR25PvyXvPG/preview' width='800'' height='360' allow='autoplay'></iframe>" : 'Click this button to add or edit the Plugins and </br> Integrations for this campaign',
            params: {
                 enableScrolling: false,
            },
            
          },
          {
            target: '.google-sheet-anchor',
            content: 'Click this button to quickly view the Google Sheet or </br> Spreadsheet of contacts for this campaign',
            params: {
                 enableScrolling: false,
            },
          },
          {
            target: '.play-pause-stop-anchor',
            content: 'Click these buttons to Start, Pause, or Stop the campaign',
            params: {
                 enableScrolling: false,
            },
          },
          {
            target: '.menu-drop-anchor',
            content: 'Expand this section to Archive this campaign or </br> to edit the Exclusion List for this campaign',
            params: {
                 enableScrolling: false,
            },
          },
  
        
       
        ],
            clientdefaultprice:'',
            isWebhookFetching: false,
            prepaidType: '',    
            contiDurationSelection: false, 
            includeExclude: "0",  
            stateInclude: [],
            stateExclude: [],
            totalLeads: {
                continualTopUp: '',
                oneTime: '',
            },
            totalAmountTopup: '',
            lp_user_id: '',
            remainingBalanceLeads: '',
            err_totalleads: false,
            listLimitFreq: [
                {
                    id: 0,
                    label: 'Limit Per Day',
                    value: 'day'
                },
                {
                    id: 1,
                    label: 'Limit Per Month',
                    value: 'month'
                }
            ],
            minimumLeadPrepaidOneTime: 50,
            minimumLeadPrepaidContinualLimitDay: 50,
            errMinimumLeadPrepaidContinualLimitDay: false,
            isContainulTopUpStop: false,
            
            // date picker settings 
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
            },
            /** FOR SUPRESSION UPLOAD FILE */
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null,
            uploadFieldName: 'suppressionfile',
            /** FOR SUPRESSION UPLOAD FILE */
            tableDataOri: [],
            tableData: [],
            fuseSearch: null,
            searchedData: [],
            selectedRowData: {},
            searchQuery: '',
            pagination: {
                perPage: 10,
                currentPage: 1,
                // perPageOptions: [],
                total: 0,
                from: 0,
                to: 0,
            },
            modals: {
                helpguide: false,
                helpguideTitle: '',
                helpguideTxt: '',
                phoneConfirmation: false,
                embededcode: false,
                campaign: false,
                campaignEdit: false,
                pricesetup: false,
                integrations: false,
                questionnaire: false,
                whitelist: false,
                helpVideos:false,
            },

            questionnaire: {
                'asec3_1': '',
                'asec3_2': '',
                'asec3_3': false,
                'asec3_4': '',
                'asec3_5': '',
                'asec3_6': '',

                'asec6_1': '',
                'asec6_2': '',
                'asec6_3': '',
                'asec6_4': '',
                'asec6_5': '',
                'asec6_6': false,
                'asec6_7': '',

                'url_code': '',
                'campaign_name': '',
            },

            leadlocatorname: '',
            leadlocalname: '',

            companyID: '',
            activeClientCompanyID: '',
            activeClientCompanyParent: '',

            ClientCompanyName: '',
            ClientCampaignName: '',
            ClientFullName: '',
            ClientEmail: '',
            ClientPhone: '',
            ClientPerLead: '500',
            ClientUserID: '',
            ClientReportSentTo: '',
            ClientUrlCode: '',
            ClientUrlCodeThankyou: '',

            ClientEmbededCode: '',
            copyText: 'Copy',
            popProcessingTxt: 'Please wait, adding new campaign ....',

            GoogleConnectFalse: false,
            GoogleConnectTrue: false,
            CompanyNamedisabled: false,
            isKartraInfoFetching: false,
            isZapierFetching: false,
            isAgencyZoomFetching: false,
            isMailBoxPowerFetching: false,
            isGoHighInfoFetching: false,
            isSendgridInfoFetching: false,
            isGoogleInfoFetching: false,
            isProcessRefundPrepaid: false,

            tmpdefaultadmin: [],

            Reidentificationtime: '1 year',
            ReidentificationTimeOptions: [
                {
                    value: 'never',
                    label: 'Never'
                },
                {
                    value: '1 week',
                    label: '1 Week'
                },
                {
                    value: '1 month',
                    label: '1 Month'
                },
                {
                    value: '3 months',
                    label: '3 Months'
                },
                {
                    value: '6 months',
                    label: '6 Months'
                },
                {
                    value: '1 year',
                    label: '1 Year'
                },
            ],

            LeadspeekMinimumLeadsPerDay: 0,
            LeadspeekMinimumLeadsPerDayAdd: 0,

            showInputLeadspeekPerDay: false,
            showInputLeadspeekPerDayAdd: false,

            errMinClientLeadDay: false,
            errMinClientLeadDayAdd: false,

            checkboxes: {
                hide_phone: true,
                gtm: false,
                phoneenabled: false,
                homeaddressenabled: true,
                requireemailaddress: true,
                ApplyReidentificationToAll: false,
            },

            radios: {
                reportType: 'GoogleSheet',
            },
            selects: {
                state: [],
                statelist: [],
                Citystate: [],
                Citystatelist: [],
                city: [],
                citylist: [],
                country: ['8180'],
                countrylist: [
                    {
                        'country' : 'United States',
                        'country_code' : '8180',
                    }
                ],
            },
            selectsAdministrator: {
                administratorSelected: [],
                administratorList: [],
            },
            selectsCompany: {
                companyId: '',
                companySelected: '',
                companyList: [],
            },
            selectsGroupCompany: {
                companyGroupID: '',
                newCompanyGroupName: '',
                companyGroupAddEdit: false,
                companyGroupSelected: '',
                companyGroupList: [],
            },

            ClientActiveID: '',

            LeadspeekPlatformFee: '0',
            m_LeadspeekPlatformFee: '0',
            t_LeadspeekPlatformFee: '0',
            LeadspeekCompany: '',
            LeadspeekclientEmail: '',
            LeadspeekCostperlead: '0',
            m_LeadspeekCostperlead: '0',
            t_LeadspeekCostperlead: '0',
            LeadspeekMaxLead: '0',
            LeadspeekMinCostMonth: '0',
            m_LeadspeekMinCostMonth: '0',
            m_LeadspeekLimitLead: '10',
            t_LeadspeekMinCostMonth: '0',
            LeadspeekLimitLead: '10',
            LeadspeekEnableMinimumLeadsPerDayAdd: false,
            LeadspeekEnableMinimumLeadsPerDay: false, 
            LeadspeekClientActiveIndex: '',
            LeadspeekMaxDateStart: '',
            LeadspeekDateEnd: '',
            LeadspeekMaxDateVisible: false,
            LeadspeekType: '',
            LeadspeekInvoiceDateNextMonth: '',

            userIdCampaign: '',
            spreadsheetHistory: [],

            campaign_information_type_local_includes_advanced: false,
            current_topup: null,

            t_estleadspermonth: '0',

            LeadspeekInputReadOnly: false,
            OnlyPrepaidDisabled: false,
            ActiveLeadspeekID: '',
            LeadspeekActive: '',
            LeadspeekDisabled: '',
            LeadspeekActiveUser: '',

            t_profit: '0',
            t_freqshow: 'week',
            t_freq: '4',
            t_cost: '0',
            
            txtLeadService: 'per week',
            txtLeadIncluded: 'in that weekly charge',
            txtLeadOver: 'from the weekly charge',

            cardAdvanceInformationReadOnly: false,

            selectsPaymentTerm: {
                PaymentTermSelect: 'Weekly',
                PaymentTerm: [
                    // { value: 'One Time', label: 'One Time'},
                    // { value: 'Weekly', label: 'Weekly'},
                    // { value: 'Monthly', label: 'Monthly'},
                ],
            },
            selectsAppModule: {
                AppModuleSelect: 'LeadsPeek',
                AppModule: [
                    // { value: 'Ads Design', label: 'Ads Design' },
                    // { value: 'Campaign', label: 'Campaign' },
                    { value: 'LeadsPeek', label: 'LeadsPeek' },
                ],
                LeadsLimitSelect: 'Day',
                LeadsLimit: [
                    //{ value: 'Month', label: 'Month'},
                    { value: 'Day', label: 'Day' },
                    //{ value: 'Max', label: 'Max'},
                ],
            },

            costagency: {
                local: {
                    'Weekly': {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'Monthly': {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'OneTime': {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    }
                },
            },

            defaultCostCampaign: {
                paymentterm: 'Weekly',
                LeadspeekPlatformFee: '0',
                LeadspeekCostperlead: '0',
                LeadspeekMinCostMonth: '0',
                LeadspeekLeadsPerday: '0',
                LeadspeekMinimumLeadDay: '0',

                local: {
                    'Weekly': {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'Monthly': {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'OneTime': {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'Prepaid': {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                },
            },

            userTypeOri: '',
            err_companyselect: false,
            fetchingCampaignData: false,
            whiteListLeadspeekID: '',
            whiteListCompanyId: '',
            whiteListLeadspeekApiId: '',
            disabledaddcampaign: true,
            userType: '',
            sendGridActionsOptions: [
                {
                    id: 'add-to-list',
                    name: 'Add to list'
                },
                {
                    id: 'create-contact',
                    name: 'Create a contact'
                },

            ],

            goHighLevelTagsOptions: [],
            ghl_tags : [],
            ghl_tags_remove: [],

            mailBoxPowerOptions: [],
            mbp_groups: [],
            mbp_groups_remove: [],
            mailBoxPowerStates: [],
            mbp_states: [],
            mbp_zip: '',
            mbp_options: 'state',
            mailBoxpowerUploadZipName: 'mailboxpoweupload',
            isMailBoxPowerSavingZip: false,

            sendGridListOptions: [
            ],
            selectedSendgridAction: [],
            selectedSendgridList: [],
            sendGridcampaignId: '',
            selectedKartraList: [],
            selectedKartraTags: [],
            kartraTagsOptions: [],
            kartraListOptions: [],
            // dummy data for integraions 
            integrations: [

            ],
            isLoadingSaveIntegration:false,
            
            zapierEnable: false,
            zapierTestEnable: false,
            zapierTags : [],
            zapierTagsOptions: [],
            zapierWebhook: [''],
            defaultWebhook: true,

            agencyZoomEnable: false,
            agencyZoomTestEnable: false,
            agencyZoomWebhook: [''],
            defaultAgencyZoomWebhook: false,

            // sendjim
            sendjimEnable: false,
            sendjimTags: [],
            sendjimTagsOptions: [],
            sendjimQuickSendEnabled: false,
            sendjimQuickSendTemplates: [],
            sendjimQuickSendOptions: [],

            selectedIntegration: 'googlesheet',
            currentRowIndex: 0,
            currSortBy: '',
            currOrderBy: '',

            supressionProgress: [],
            supressionDone: [],
            supressionInterval: '',
            filterCampaignStatus: 'all',
            dropdownVisible: '',
            optionCampaignStatus: [
                {
                    value: 'all',
                    label: 'All'
                },
                {
                    value: 'play',
                    label: 'Running'
                },
                {
                    value: 'paused',
                    label: 'Paused'
                },
                {
                    value: 'stop',
                    label: 'Stopped'
                },
            ],
            colorOptions: [
                 {
                   background: 'rgb(224, 226, 246)',
                   color: 'rgb(80, 70, 177)',
                 },
                 {
                   background: 'rgb(246, 224, 227)',
                   color: 'rgb(177, 70, 143)',
                 },
                 {
                   background: 'rgb(214, 235, 228)',
                   color: 'rgb(90, 194, 159)',
                 },
                 {
                   background: 'rgb(246, 235, 224)',
                   color: 'rgb(194, 132, 69)',
                 },
                 {
                   background: 'rgb(211, 233, 255)',
                   color: 'rgb(102, 153, 204)',
                 },
            ],
            tourCallbacks:{
                onSkip:this.removeDummyItemFromQueriedData,
                onFinish:this.removeDummyItemFromQueriedData,
                onStop:this.removeDummyItemFromQueriedData,

            },
            prevCampaignFinancial: null,
            isLoadingSendTestLead: false,
            isLoadingSpreedSheetConnection : false,
            testEmbedCodeEmail: '',
            isLoadingSendTestEmbedCode: false,
            isIframeActive: false,
            isErrorEmbededCode: false,
            isErrorEmbededCodeMessage: '',
            isSuccessEmbededCode: false,
            isSuccessEmbededCodeMessage: '',
            isErrorRunEmbededCode: false,
            isErrorRunEmbededCodeMessage: '',
            isSuccessRunEmbededCode: false,
            isSuccessRunEmbededCodeMessage: '',
            isWarningEmbededCode: false,
            isWarningEmbededCodeMessage: '',
            embedCodeStatus: {},
            errors: {
                sendgrid: false,
                mailboxPower: false,
                goHighLevel: false,
                webhook: false,
                kartra: false,
                clickfunnels: false,
            },
            rowCheckboxes: {
                homeaddressenabled: false,
                phoneenabled: false,
                require_email: false,
                gtm: false,
                applyreidentificationall: false,
            },
            menuClickFunnels: 'choose-tag',
            listTagsClickFunnels: [],
            listTagsClickFunnelsSelected: [],
            formNewTagClickFunnels: {
                name: '',
                color: '',
            },
            colorsNewTagClickFunnels: [
                {
                    value: '#9c73d2',
                },
                {
                    value: '#48cdfe',
                },
                {
                    value: '#53f3ed',
                },
                {
                    value: '#47e37f',
                },
                {
                    value: '#f2593d',
                },
                {
                    value: '#f68421',
                },
                {
                    value: '#f9de00',
                },
                {
                    value: '#929292',
                },
                {
                    value: '#5645ef',
                },
            ],
            isLoadingResetSpreadsheet: false,
            isLoadingGetTagsClickFunnels: false,
            isLoadingCreateTagsClickFunnels: false,
            isLoadingGetCampaignTagsClickFunnels: false,
            isLoadingModuleCost : false,
            isCollapseMenuClickFunnels: window.innerWidth < 768,
            LeadspeekLimitLeadDB: 0,
            windowWidth: window.innerWidth,
            formUrlCodes: [""],
            urlActive: '',
            responseTestEmbedCode: {
                msg_exist: '',
                msg_notexist: '',
                msg_block: '',
            },
            isPopOverCheckEmbedCode: false,
            nameIntegration: '',
            idAdvancedInformation: [],
            listAdvancedInformation: [],
            rowIdAdvancedInformation: [],
            rowIdAdvancedInformationB2b: [],
            isLoadingAdvancedInformation: false,
            isErrorAdvancedInformation: false,
            idAdvancedInformationB2b: [],
            listAdvancedInformationB2b: [],
            isLoadingAdvancedInformationB2b: false,
            isErrorAdvancedInformationB2b: false,
            checkAllBasic: false,
            rowCheckAllBasic: false,
            checkAllAdvanced: false,
            rowCheckAllAdvanced: false,
            rowCheckAllAdvancedB2b: false,
            checkAllAdvancedB2b: false,
            campaignInformationData: ['basic'],
            topUpType: 'contact',
            selectedModule: 'basic',
            optionsModule: [
                { label: 'Basic Information', value: 'basic' },
                { label: 'Advanced Information', value: 'advanced' },
                { label: 'B2B Information', value: 'b2b' },
            ],
            basicExampleDataUrl: 'https://sitesettings-api-docs.vercel.app/agency/informations/send-test',
            currentEmbedCode: '',
            currentSuppressionCode: ''
        }
    },
    
    computed: {
        iframeSrc() {
            return `${this.urlActive}?test=true`;
        },
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
        canAddUrl() {
            const lastIndex = this.formUrlCodes.length - 1;
            const lastInput = this.formUrlCodes[lastIndex];
            return lastInput && this.isValidUrl(lastInput.trim());
        },
        parsedUrls() {
            const urls = `${this.selectedRowData.url_code}`;
            // console.log('aaaaaa : ' + urls);
            return urls.split("|");
        },
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        // queriedData() {
        //     let result = this.tableData;
        //     if (this.searchedData.length > 0) {
        //         result = this.searchedData;
        //     }
        //     return result;
        // },
        queriedData: {
         get() {

            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result;
        },
         set(value) {
             if (Array.isArray(value)) {
            if (this.searchedData.length > 0) {
                this.searchedData = value;
            }else{
                this.tableData = value
            }
            
            } else {
             console.warn('queriedData expects an array.');
         }
         }
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        },
        computedWidth() {
            return this.windowWidth > 1024 ? 780 : this.windowWidth - 200;
        },
        filteredHistory() {
            return this.spreadsheetHistory || [];
        },
        checkCampaignInformationTypeLocal(){
            if(this.selectedRowData && typeof this.selectedRowData.campaign_information_type_local != 'undefined'){
                return true;
            } else {
                return false;
            }
        },
        iconConverterClass(){
            return this.windowWidth <= 578 ? 'el-icon-bottom' : 'el-icon-right';
        },
        selectedModuleLabel() {
            const item = this.optionsModule.find(opt => opt.value === this.selectedModule);
            return item ? item.label : '';
        }
    },

    methods: {
        ...mapActions(["getUserSendgridList",'getAgencyWhitelabelDomain', 'getUserIntegrationList', "updateCompanyIntegrationConfiguration","geUsertKartraList","geUsertKartraDetails",'getSelectedKartraListAndTags', "getAgencyZapierDetails", "getCampaignZapierDetails", "getCampaignZapierTags", "getAgencyZapierTags","userLogSaved","getCampaignAgencyZoomDetails","getClientAgencyZoometails"]),
        toggleSendjimQuickSendTemplate(id){
            const idx = this.sendjimQuickSendTemplates.indexOf(id);
            if(idx === -1){
                this.sendjimQuickSendTemplates.push(id);
            } else {
                this.sendjimQuickSendTemplates.splice(idx,1);
            }
        },
        async refundTopupPrepaid() {
            // validation
            if(!(this.LeadspeekActive == 'F' && this.LeadspeekDisabled == 'T' && this.LeadspeekActiveUser == 'F')) {
                this.$notify({
                    type: 'danger',
                    message: 'Please stop the campaign before refund campaign.',
                    icon: 'fas fa-bug'
                });
                return;
            }
            if(this.remainingBalanceLeads == 0) {
                this.$notify({
                    type: 'danger',
                    message: 'You cannot a refund because your remaining balance is 0 contact.',
                    icon: 'fas fa-bug'
                });
                return;
            }
            if(this.selectsPaymentTerm.PaymentTermSelect != 'Prepaid') {
                this.$notify({
                    type: 'danger',
                    message: 'Payment type campaign must be a prepaid.',
                    icon: 'fas fa-bug'
                });
                return;
            }
            // validation

            // calculate estimate price refund
            let amountRefundAgency = 0;
            try {
                this.isProcessRefundPrepaid = true;

                const payload = { leadspeek_api_id: this.ActiveLeadspeekID };
                const response = await this.$store.dispatch('estimateRefundCampaignPrepaid', payload);
                // console.log(response);

                this.isProcessRefundPrepaid = false;
                amountRefundAgency = typeof(response.amountRefundAgency) ? response.amountRefundAgency : 0; 
            } catch (error) {
                // console.error(error);
                this.isProcessRefundPrepaid = false;
                this.$notify({
                    type: 'danger',
                    message: typeof(error.response.data.mesage) != 'undefined' ? error.response.data.mesage : 'Something Went Wrong',
                    icon: 'fas fa-bug'
                });
                return;
            }
            // calculate estimate price refund

            // process refund 
            const userData = this.$store.getters.userData;
            const result = await swal.fire({
                title: 'Refund Campaign',
                html: `Are you sure you want to refund the campaign? Once the refund is processed, an amount of <span style="font-weight: bold">$${amountRefundAgency}</span> will be returned to your data wallet agency. This action cannot be undone and any remaining balance contact will be forfeited`,
                icon: '',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-default btn-fill mr-3',
                    cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Yes, refund it!',
                buttonsStyling: false
            });
            if (result.isConfirmed) {
                try {
                    this.isProcessRefundPrepaid = true;

                    const payload = { 
                        leadspeek_api_id: this.ActiveLeadspeekID,
                        company_id: userData.user_type == 'client' ? userData.company_parent : userData.company_id,
                        ip_user: userData.ip_login,
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        payment_type: 'refund_campaign',
                    };
                    const response = await this.$store.dispatch('refundCampaignPrepaid', payload);
                    // console.log(response);

                    this.remainingBalanceLeads = (typeof(response.remainingBalanceLeads) != 'undefined') ? response.remainingBalanceLeads : 0;
                    this.isContainulTopUpStop = (typeof(response.stopContinual) != 'undefined' && response.stopContinual == 'T') ? true : false;
                    this.isProcessRefundPrepaid = false;
                    this.GetClientList(this.currSortBy,this.currOrderBy)
                    this.$notify({
                        type: 'success',
                        message: typeof(response.message) != 'undefined' ? response.message : 'Refund Campaign Was Successful.',
                        icon: 'fas fa-bug'
                    });
                } catch (error) {
                    // console.error(error);
                    this.isProcessRefundPrepaid = false;
                    this.$notify({
                        type: 'danger',
                        message: typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Went Wrong',
                        icon: 'fas fa-bug'
                    });
                }
            }
            // process refund
        },
        validationInput(type) {
            if(type == 'LeadspeekPlatformFee' && this.LeadspeekPlatformFee === '') {
                this.LeadspeekPlatformFee = 0
            } else if('LeadspeekMinCostMonth' && this.LeadspeekMinCostMonth === '') {
                this.LeadspeekMinCostMonth = 0;
            } else if(type == 'LeadspeekCostperlead' && this.LeadspeekCostperlead === '') {
                this.LeadspeekCostperlead = 0
            } else if(type == 'LeadspeekLimitLead' && this.LeadspeekLimitLead === '') {
                this.LeadspeekLimitLead = 1;
            }
            this.profitcalculation();
        },
        changeGhlTags() {
            this.$nextTick(() => {
                document.querySelectorAll('.select-integration-ghl .el-tag.el-tag--info.el-tag--small.el-tag--light').forEach((element, index) => {
                    const textOption = element.querySelector('.el-select__tags-text').textContent.trim();
                    if(this.ghl_tags_remove.includes(textOption)) {
                        element.classList.add('red-tag');
                    } else {
                        element.classList.remove('red-tag');
                    }
                });
            });
        },
        keydownInputGhlTags() {
            this.changeGhlTags();
        },
        validationMinLeadPrepaidOneTime() {
            if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'onetime' && Number(this.totalLeads.oneTime) < Number(this.minimumLeadPrepaidOneTime)) {
                this.totalLeads.oneTime = this.minimumLeadPrepaidOneTime;
                this.err_totalleads = false;
                this.profitcalculation();
            }
        },
        validationMinLeadPrepaidLimitMonth() {
            if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'continual' && this.selectsAppModule.LeadsLimitSelect == 'month') {
                if(Number(this.LeadspeekLimitLead) < Number(this.minimumLeadPrepaidContinualLimitDay)) {
                    this.LeadspeekLimitLead = this.minimumLeadPrepaidContinualLimitDay;
                    this.errMinimumLeadPrepaidContinualLimitDay = false;
                    this.profitcalculation();
                }
            } else {
                this.validateMinLeadsPerDayBlur('price_campaign');
            }
        },
        prepaidLimitType(event, prepaidType) {
            if(prepaidType == 'continual') {
                if(event == 'day') {
                    this.LeadspeekLimitLead = (this.selectedRowData.paymentterm == 'Prepaid' && this.selectedRowData.topupoptions == 'continual') ? this.selectedRowData.lp_limit_leads : this.clientdefaultprice.local.Prepaid.LeadspeekLeadsPerday;
                    this.contiDurationSelection = false;
                    this.updateWeeklyMonthlyToggle();
                    this.validateMinLeadsPerDayBlur('price_campaign');
                } else if(event == 'month') {
                    this.LeadspeekLimitLead = this.minimumLeadPrepaidContinualLimitDay;
                    this.contiDurationSelection = true;
                    this.profitcalculation();
                }
            }
        },
        stateSelected(event) {
            if(event == 0) { // exclude
                this.stateInclude = this.selects.state;
                this.selects.state = this.stateExclude;
            } else { // include
                this.stateExclude = this.selects.state;
                this.selects.state = this.stateInclude;
            }
        },
        getStateList() {
            this.$store.dispatch('getLocationBigDbm', {
                type: 'state',
                param: '',
                limit: '',
                search: '',
            }).then(response => {
                this.selects.statelist = response.data
            }, error => {
                console.error(error);
            })
         },
        removeEmptyLines() {
            this.mbp_zip = this.mbp_zip
                               .split('\n') // Pisahkan setiap baris berdasarkan newline
                               .filter(line => line.trim() !== '') // Hapus baris kosong atau hanya spasi
                               .join('\n'); // Gabungkan kembali menjadi teks dengan newline
        },
        mailBoxPowerFilesChange(fieldName, fileList) {
            this.isMailBoxPowerSavingZip = true;

            /* VALIDATION EXTENSION */
            const fileExtension = fieldName.name.split('.').pop();
            
            if(fileExtension != 'csv') {
                this.$notify({
                    type: 'danger',
                    message: 'file must be CSV',
                    icon: 'tim-icons icon-bell-55'
                });
                this.mailBoxPowerFilesReset();
                return false;
            }
            /* VALIDATION EXTENSION */

            // handle file changes
            if (!fileList.length) return;
            
            // append the files to FormData
            const formData = new FormData();
            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(this.mailBoxpowerUploadZipName, fileList[x].raw, fileList[x].name);
            });
            formData.append("leadspeek_api_id", this.selectedRowData.leadspeek_api_id);
            // append the files to FormData

            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin' : '*',
                }
           };

           axios.post('/mailboxpower/upload-zipcode', formData, config)
                .then(response => {
                    // console.log(response);
                    this.mailBoxPowerFilesReset();

                    if(response.data.result == 'success') {
                        this.$notify({
                            type: 'success',
                            message: response.data.message,
                            icon: 'tim-icons icon-bell-55'
                        });

                        this.mbp_zip = response.data.mbpzip;
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.mailBoxPowerFilesReset();

                    this.$notify({
                        type: 'danger',
                        message: error.response.data.message,
                        icon: 'tim-icons icon-bell-55'
                    });
                });
        },
        mailBoxPowerFilesReset() {
            this.isMailBoxPowerSavingZip = false;
            this.mailBoxpowerUploadZipName = 'mailboxpoweupload';
            this.$refs.mailBoxPowerZip.clearFiles();
        },
        openHelpModal(index){
            this.activeHelpItem = this.helpContentMap[index]
            this.modals.helpVideos = true;
        },
        openPhoneConfirmationModal(checkbox,val){
            const userData = this.$store.getters.userData
            if (this[checkbox].phoneenabled) {
                this[checkbox].phoneenabled = false

                var _campaignID = '';
                let userId = '';

                if (val != 'checkboxes') {
                    _campaignID = '#' + this[val].leadspeek_api_id;
                    userId = this.selectedRowData.user_id;
                    this.onCheckItemBasicInformation('edit');
                }else{
                    _campaignID = this.ClientCampaignName;
                    userId = this.ClientUserID;
                    this.onCheckItemBasicInformation('add');
                }

                // let data = {
                //     userID: userData.id,
                //     action: "disabled phone number on campaign",
                //     desc: "campaign " + _campaignID,
                //     userIP: this.$store.getters.userData.ip_login,
                // }

                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if(userViewMode){
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                //     data.userID = userRoot.id;
                // }
                
                // this.userLogSaved({ data});

                this.$store.dispatch('onSaveUserLogs', {
                    desc: "campaign " + _campaignID,
                    action: "disabled phone number on campaign",
                    target_id: userId,
                })

                return
            }
            swal.fire({
                  title: "<span style='font-size:21px;'>Phone numbers are provided without warranty or guarantee. The end-user is responsible for verifying the Do-Not-Call status of each number and ensuring compliance with all applicable laws. The end-user must obtain all necessary permissions before making calls or sending messages<span>",
                  text: '',
                  icon: '',
                  showCancelButton: true,
                  customClass: {
                  confirmButton: 'btn btn-fill mr-3',
                  cancelButton: 'btn btn-danger btn-fill'
                  },
                  confirmButtonText: "I Agree",
                  buttonsStyling: false
          }).then(result => {
            // API CAll For Storing Phone Confirmation From The USER
            if (result.isConfirmed) {
                var _campaignID = '';
                let userId = '';

                if (val != 'checkboxes') {
                    _campaignID = '#' + this[val].leadspeek_api_id;
                    userId = this.selectedRowData.user_id;
                }else{
                    _campaignID = this.ClientCampaignName;
                    userId = this.ClientUserID;
                }

                // let data = {
                //     userID: userData.id,
                //     action: "enabled phone number on campaign",
                //     desc: "Agreed with pop up information (enabled phone number) on campaign " + _campaignID,
                //     userIP: this.$store.getters.userData.ip_login,
                // }
                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if(userViewMode){
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                //     data.userID = userRoot.id;
                // }
                
                // this.userLogSaved({ data});
                this.$store.dispatch('onSaveUserLogs', {
                    desc: "Agreed with pop up information (enabled phone number) on campaign " + _campaignID,
                    action: "enabled phone number on campaign",
                    target_id: userId,
                })

            }
            // API Call END
            this[checkbox].phoneenabled = result.isConfirmed ? true : false

            if (val != 'checkboxes') {
                this.onCheckItemBasicInformation('edit');
            }else{
                this.onCheckItemBasicInformation('add');
            }
                  
          });
        },
        async openSaveConfirmationModal(val){
            const userData = this.$store.getters.userData;
            
            return  swal.fire({
                  title: "<span style='font-size:21px;'>Phone Numbers Are Not Enabled <br> <b>Please Confirm</b>?</span>",
                  text: "Phone numbers are provided without warranty or guarantee. The end-user is responsible for verifying the Do-Not-Call status of each number and ensuring compliance with all applicable laws. The end-user must obtain all necessary permissions before making calls or sending messages",
                  icon: '',
                  width: '600px',
                  showConfirmButton: true,
                  showCancelButton: true,
                  customClass: {
                    confirmButton: 'btn btn-fill mr-3',
                    cancelButton: 'btn btn-fill'
                  },
                  confirmButtonText: "Include Phone Numbers",
                  cancelButtonText: "Exclude Phone Numbers",
                  buttonsStyling: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false
          }).then(result => {
            // API CAll For Storing Phone Confirmation From The USER
            var _campaignID = '';
            let userId = '';

            if (val != 'add') {
                _campaignID = '#id=' + val;
                // userId = this.selectedRowData.user_id;
                userId = this.userIdCampaign;
            }else{
                _campaignID = this.ClientCampaignName;
                userId = this.ClientUserID;
            }

            if (result.isConfirmed) {
                

                // let data = {
                //     userID: userData.id,
                //     action: "Agree modal save campaign",
                //     desc: "Agree save campaign with enable phone number on campaign " + _campaignID,
                //     userIP: this.$store.getters.userData.ip_login,
                // }

                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if(userViewMode){
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                //     data.userID = userRoot.id;
                // }
                // this.userLogSaved({ data });
                this.$store.dispatch('onSaveUserLogs', {
                    desc: "Agree save campaign with enable phone number on campaign " + _campaignID,
                    action: "Agree modal save campaign",
                    target_id: userId,
                })

                return true;
            } else if (result.isDismissed && result.dismiss === swal.DismissReason.cancel) {
                // let data = {
                //     userID: userData.id,
                //     action: "Don't Agree modal save campaign",
                //     desc: "Don't Agree save campaign with enable phone number on campaign " + _campaignID,
                //     userIP: this.$store.getters.userData.ip_login,
                // }

                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                // if(userViewMode){
                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                //     data.userID = userRoot.id;
                // }
                // this.userLogSaved({ data });

                this.$store.dispatch('onSaveUserLogs', {
                    desc: "Don't Agree save campaign with enable phone number on campaign " + _campaignID,
                    action: "Don't Agree modal save campaign",
                    target_id: userId,
                })

                return false;
            } else {
                return null; // cancel or dismissed
            }
                  
          });
        },
        startTour(){
            
            const updatedData = [this.dummyCampaignData, ...this.queriedData];
            this.queriedData = updatedData;
            this.$tours['myTour'].start()
        },
        removeDummyItemFromQueriedData() {
            
            const updatedData = this.queriedData.filter(
                     (item) => item.id !== 'dummy-campaign-item'
            );
             this.queriedData = updatedData;
        },
        limitUrlCodeLength(){
            if(this.ClientUrlCode){
                if(this.ClientUrlCode.includes(' ')){
                    this.$notify({
                        type: 'warning',
                        message: 'Spaces are not allowed in the URL.',
                        icon: 'fa fa-exclamation-triangle'
                    });
                    this.ClientUrlCode = this.ClientUrlCode.replace(/\s/g, '');
                }
                if(this.ClientUrlCode.length > 254){
                    this.ClientUrlCode = this.ClientUrlCode.substring(0, 255);
                    this.$notify({
                        type: 'warning',
                        message: 'The URL has been shortened to 255 characters.',
                        icon: 'fa fa-exclamation-triangle'
                    });
                }
            }
        },
        addWebhookUrl(type) {
            if (type == 'zapier') {
                this.zapierWebhook.push('');
            } else if (type == 'agencyzoom') {
                this.agencyZoomWebhook.push('');
            }
        },
        removeWebhookUrl(index, type) {
            if (type == 'zapier') {
                if (this.zapierWebhook.length > 1) {
                    this.zapierWebhook.splice(index, 1);
                }
            } else if (type == 'agencyzoom') {
                if (this.agencyZoomWebhook.length > 1) {
                    this.agencyZoomWebhook.splice(index, 1);
                }
            }
        },
        limitUrlCodeLengthEdit(row){
            if(row.url_code){
                if(row.url_code.includes(' ')){
                    this.$notify({
                        type: 'warning',
                        message: 'Spaces are not allowed in the URL.',
                        icon: 'fa fa-exclamation-triangle'
                    });
                }
                row.url_code = row.url_code.replace(/\s/g, '');
                if(row.url_code.length > 254){
                    row.url_code = row.url_code.substring(0, 255);
                    this.$notify({
                        type: 'warning',
                        message: 'The URL has been shortened to 255 characters.',
                        icon: 'fa fa-exclamation-triangle'
                    });
                }
            }
        },
        validateMinContactPerDayKeyup(type) {
            if(type == 'price_campaign') {
                if(Number(this.LeadspeekMinimumLeadsPerDay) > Number(this.LeadspeekLimitLead)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                    this.profitcalculation();
                }
            }
        },
        validateMinContactPerDayBlur(type) {
            if(type == 'price_campaign') {
                if(this.LeadspeekMinimumLeadsPerDay == '') {
                    this.LeadspeekMinimumLeadsPerDay = 1;
                }
            }
        },
        validateMinLeadsPerDayBlur(type) {
            if(type == 'price_campaign') {
                if (this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.errMinClientLeadDay = false;
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                    this.profitcalculation();
                } else {
                    this.validationInput('LeadspeekLimitLead');
                }
            }
        },
        updateWeeklyMonthlyToggle(){
         this.totalLeads.continualTopUp = this.contiDurationSelection ? (this.LeadspeekLimitLead * 7 ) * 4 : (this.LeadspeekLimitLead * 7)
         this.profitcalculation();
        },
        checkStatusFileUpload() {

            clearInterval(this.supressionInterval);

            /** START CHECK IF THERE IS ANYTHING NOT DONE */
                this.$store.dispatch('jobProgress', {
                    leadspeekID: this.whiteListLeadspeekID,
                    companyId: this.whiteListCompanyId,
                    leadspeekApiId: this.whiteListLeadspeekApiId,
                    campaignType: 'campaign',
                })
                .then(response => {
                    this.supressionProgress = response.data.jobProgress;
                    this.supressionDone = response.data.jobDone;
                    
                    if(this.supressionProgress.length > 0) {
                        this.supressionTimeout = setTimeout(() => {
                            this.supressionInterval = setInterval(() => {
                                this.$store.dispatch('jobProgress', {
                                    leadspeekID: this.whiteListLeadspeekID,
                                    companyId: this.whiteListCompanyId,
                                    leadspeekApiId: this.whiteListLeadspeekApiId,
                                    campaignType: 'campaign',
                                })
                                .then(response => {
                                    this.supressionProgress = response.data.jobProgress;
                                    this.supressionDone = response.data.jobDone;
                                    
                                    if(this.supressionProgress.length == 0) {
                                        clearTimeout(this.supressionTimeout);
                                        clearInterval(this.supressionInterval);
                                    }
                                })
                                .catch(error => {
                                    console.error(error);
                                })
                            }, 2000);
                        }, 2000);
                    } else {
                        clearTimeout(this.supressionTimeout);
                        clearInterval(this.supressionInterval); 
                    }
                })
                .catch(error => {
                    console.error(error);
                })
            /** START CHECK IF THERE IS ANYTHING NOT DONE */
        },
        async stopContinualTopUp() {
            if((this.remainingBalanceLeads == 0 && this.selectsAppModule.LeadsLimitSelect == 'month') && ((this.LeadspeekActive == 'T' && this.LeadspeekDisabled == 'F' && this.LeadspeekActiveUser == 'T') ||(this.LeadspeekActive == 'F' && this.LeadspeekDisabled == 'F' && this.LeadspeekActiveUser == 'T') || (this.LeadspeekActive == 'F' && this.LeadspeekDisabled == 'T' && this.LeadspeekActiveUser == 'T'))) {
                const result = await swal.fire({
                    title: 'Stop Continual Topup',
                    text: 'Your remaining contact balance is 0, and your lead limit is set on a monthly. As a result, your campaign will be stopped.',
                    icon: '',
                    showCancelButton: true,
                    customClass: {
                        confirmButton: 'btn btn-default btn-fill',
                        cancelButton: 'btn btn-danger btn-fill'
                    },
                    confirmButtonText: 'Ok',
                    buttonsStyling: false
                });

                if(!result.isConfirmed) {
                    return;
                }
            }
            
            this.$store.dispatch('stopContinualTopUp', {
                leadspeek_api_id: this.ActiveLeadspeekID,
                lp_limit_freq: this.selectsAppModule.LeadsLimitSelect 
            })
            .then(response => {
                /* RESULT */
                if(!response.data.status) {
                    this.$notify({
                        type: 'danger',
                        message: response.data.message,
                        icon: 'fa fa-save'
                    })
                } else {
                    this.isContainulTopUpStop = response.data.stop_continue === 'T' ? true : false;
                    this.GetClientList();   
                    // console.log(response);
                }
                /* RESULT */

                /* CLOSE MODAL IF */
                if((this.remainingBalanceLeads == 0 && this.selectsAppModule.LeadsLimitSelect == 'month') && ((this.LeadspeekActive == 'T' && this.LeadspeekDisabled == 'F' && this.LeadspeekActiveUser == 'T') ||(this.LeadspeekActive == 'F' && this.LeadspeekDisabled == 'F' && this.LeadspeekActiveUser == 'T') || (this.LeadspeekActive == 'F' && this.LeadspeekDisabled == 'T' && this.LeadspeekActiveUser == 'T'))) {
                    this.modals.pricesetup = false;
                    this.$notify({
                        type: 'success',
                        message: 'Campaign successfully stopped.',
                        icon: 'tim-icons icon-bell-55'
                    });
                }
                /* CLOSE MODAL IF */

            })
            .catch(error => {
                console.error(error);
            })
        },
        ExportLeadsData(index, row) {
            var leadsExportStart = this.format_date(this.$moment(row.created_at).format('YYYY-MM-DD') + " 00:00:00",true,false);
            var leadsExportEnd = this.format_date(this.$moment().format('YYYY-MM-DD') + " 23:59:59", true, false);
            if(row.created_at != '' && row.id != '') {
                //window.open(process.env.VUE_APP_DATASERVER_URL + '/leadspeek/report/lead/export/' + this.companyID + '/' + this.ClientActiveID + '/' + this.LeaddatePickerStart + '/' + this.LeaddatePickerEnd, "_blank");
                document.location = process.env.VUE_APP_DATASERVER_URL + '/leadspeek/report/lead/export/' + row.company_id + '/' + row.id + '/' + leadsExportStart + '/' + leadsExportEnd;
            }
        },
        show_helpguide(helptype) {
            if (helptype == 'suppression') {
                this.modals.helpguideTitle = "Whitelist Your Current Database"
                this.modals.helpguideTxt = "We do not want to charge you for anyone who is currently in your database. You can Whitelist them by providing an encrypted list of email addresses, or by uploading a list of email addresses and we will encrypt them for you. Do not include any other information in the file aside from the email address. <a href='/samplefile/suppressionlist.csv' target='_blank'>Click here</a> to download a Sample File"
            }

            this.modals.helpguide = true;
        },
        validationLeadToBuy(input) {
            if (Number(input) < 50) {
                this.err_totalleads = true;
            } else {
                this.err_totalleads = false;
            }
        },
        changePage(event){
            //console.log(this.pagination,event)
            this.GetClientList(this.currSortBy,this.currOrderBy)
        },
        handleGsheetKeydown(event) {
            if (event.key === ' ' || event.key === ',') {
                event.preventDefault(); // Prevent the default action (space or comma)
                this.selectedRowData.report_sent_to += '\n'; // Add a newline
            }
        },
        handleGSheetPaste(event) {
            event.preventDefault(); // Prevent the default paste action
            // Get the pasted data and replace commas with newline characters
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            const modifiedText = pastedText.replace(/,/g, '\n');
            // Insert the modified text at the current cursor position
            const cursorPos = event.target.selectionStart;
            const textBeforeCursor = this.selectedRowData.report_sent_to.substring(0, cursorPos);
            const textAfterCursor = this.selectedRowData.report_sent_to.substring(cursorPos);
            this.selectedRowData.report_sent_to = textBeforeCursor + modifiedText + textAfterCursor;
        }, 
        handleGsheetKeydowncreate(event) {
            if (event.key === ' ' || event.key === ',') {
                event.preventDefault(); // Prevent the default action (space or comma)
                this.ClientReportSentTo += '\n'; // Add a newline
            }
        },
        handleGSheetPasteCreate(event) {
            event.preventDefault(); // Prevent the default paste action
            // Get the pasted data and replace commas with newline characters
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            const modifiedText = pastedText.replace(/,/g, '\n');
            // Insert the modified text at the current cursor position
            const cursorPos = event.target.selectionStart;
            const textBeforeCursor = this.ClientReportSentTo.substring(0, cursorPos);
            const textAfterCursor = this.ClientReportSentTo.substring(cursorPos);
            this.ClientReportSentTo = textBeforeCursor + modifiedText + textAfterCursor;
        },
        onInput(input, field) {
            if (input == "0") {
                if(field == 'LeadspeekLimitLead') {
                    this.LeadspeekLimitLead = 1;
                } else if(field == 'LeadspeekMinimumLeadsPerDay') {
                    this.LeadspeekMinimumLeadsPerDay = 1;
                }
            }
            if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'continual' && this.selectsAppModule.LeadsLimitSelect == 'month') {
                if(Number(input) < this.minimumLeadPrepaidContinualLimitDay) {
                    this.errMinimumLeadPrepaidContinualLimitDay = true;
                } else {
                    this.errMinimumLeadPrepaidContinualLimitDay = false;
                }
            }
        },
        restrictInput(event,inputType) {
            const input = event.target.value;
            // Allow backspace, arrow keys, and other non-character keys
            const char = event.key;
            if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
                return; 
            }

            if (inputType == 'integer') {
                if (!/^\d$/.test(char)) {
                    event.preventDefault();
                }
            }

            // Check if the character is not a number
            if (!char.match(/[0-9]/) && char !== '.') {
                event.preventDefault();
            }

            // Allow only one period
            if (char === '.' && input.includes('.')) {
                event.preventDefault();
            }
        },
        searchKeyWord() {
          
                 this.pagination.currentPage = 1;
                  this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
         
        },
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
            this.uploadFieldName = 'suppressionfile';
            $('input[type="file"]').val(null);
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

            //console.log(formData);

            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                }
            };
            
            axios.post(process.env.VUE_APP_APISERVER_URL + '/api/leadspeek/suppressionlist/upload', formData, config)
            .then(response => {
                //console.log(response.data);
                if(response.data.result == 'success') {
                    this.currentStatus = STATUS_SUCCESS;
                    this.reset();
                }else{
                    this.currentStatus = STATUS_FAILED;
                    this.reset();
                }
            })
            .catch(error => {
                //console.log(error);
                this.currentStatus = STATUS_FAILED;
                this.reset();
                //reject(error)
            })

            setTimeout(() => {
                this.checkStatusFileUpload()
            }, 2000)
            
            /* UPLOAD FILE */
            // try 
            // {
            //     const response = await axios.post(process.env.VUE_APP_APISERVER_URL + '/api/leadspeek/suppressionlist/upload', formData, config)

            //     console.log(response);
                
            //     if (response.data.result == 'success') {
            //         this.currentStatus = STATUS_SUCCESS;
            //         setTimeout(() => {
            //             this.reset();
            //         }, 2000);
            //     } else {
            //         this.currentStatus = STATUS_FAILED;
            //         setTimeout(() => {
            //             this.reset();
            //         }, 2000);
            //     }
            // } 
            // catch(error) 
            // {
            //     console.error(error);
            //     this.currentStatus = STATUS_FAILED;
            //     setTimeout(() => {
            //         this.reset();
            //     }, 2000);
            // }
            /* UPLOAD FILE */
        },
        purgeSuppressionList(action){
            swal.fire({
                title: 'Record Purge Confirmation',
                text: "Are you sure you want to purge existing records?",
                showCancelButton: true,
                confirmButtonColor: 'blue',
                cancelButtonColor: 'red',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    // Perform the deletion
                    this.$store.dispatch('purgeSuppressionList', {
                        paramID: this.whiteListLeadspeekID,
                        campaignType: action,
                    }).then(response => {
                        this.supressionDone = [];
                        if (response.result === 'success') {
                            swal.fire({
                                icon: 'success',
                                title: response.title,
                                text: response.msg,
                                confirmButtonText: 'OK'
                            });
                        } else {
                            swal.fire({
                                icon: 'error',
                                title: response.title,
                                text: response.msg,
                                confirmButtonText: 'OK'
                            });
                        }
                    }).catch(error => {
                        swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'There was an error processing your request.',
                            confirmButtonText: 'OK'
                        });
                    });
                }
            });
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) return;
            const file = fileList[0];
            const validCSV = /\.(csv)$/i.test(file.name);

            if (!validCSV) {
                this.$notify({
                    type: 'danger',
                    message: 'Invalid file format. This upload only supports CSV files.',
                    icon: 'fas fa-bug'
                })

                return;
            }

            // append the files to FormData
            Array
                .from(Array(fileList.length).keys())
                .map(x => {
                    const fileMapping = fileList[x];
                    const cleanFileName = fileMapping.name
                        .replace(/\s+/g, "_")
                        .replace(/[^a-zA-Z0-9_.-]/g, "")
                        .toLowerCase();

                    const newFile = new File([fileMapping], cleanFileName, { type: fileMapping.type });

                    formData.append(fieldName, newFile, cleanFileName);
                });

            formData.append("leadspeekID", this.whiteListLeadspeekID);

            // save it
            this.save(formData);
        },
        showWhitelist(index, row) {
            this.whiteListLeadspeekID = row.id;
            this.whiteListCompanyId = row.company_id;
            this.whiteListLeadspeekApiId = row.leadspeek_api_id;
            this.modals.whitelist = true;

            this.checkStatusFileUpload();
        },
        archiveCampaign(index, row) {
            if (row.disabled == 'T' && row.active_user == 'F') {
                swal.fire({
                    title: "Are you sure you want to archive this campaign?",
                    text: '',
                    icon: '',
                    showCancelButton: true,
                    customClass: {
                        confirmButton: 'btn btn-default btn-fill',
                        cancelButton: 'btn btn-danger btn-fill'
                    },
                    confirmButtonText: 'Archive this campaign',
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('archiveCampaign', {
                            lpuserid: row.id,
                            status: 'T',
                        }).then(response => {
                            if (response.result == 'success') {
                                this.deleteRow(row);

                                this.$notify({
                                    type: 'success',
                                    message: 'Campaign has been archive.',
                                    icon: 'far fa-save'
                                });

                                // LOGS ACTION
                                let descriptionLogs = `campaign id: ${row.leadspeek_api_id} | campaign type: ${row.leadspeek_type} `
                                const userData = this.$store.getters.userData
                                // const data = {
                                //     userID: userData.id,
                                //     action: 'Campaign archive',
                                //     desc: descriptionLogs,
                                //     userIP: this.$store.getters.userData.ip_login,
                                // }
                                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                                // if (userViewMode) {
                                //     const userRoot = decryptData(localStorage.getItem('userDataOri'));
                                //     data.userID = userRoot.id;
                                // }
                                // this.userLogSaved({ data});

                                this.$store.dispatch('onSaveUserLogs', {
                                    desc: descriptionLogs,
                                    action: 'Campaign archive',
                                    target_id: row.user_id,
                                })
                                // LOGS ACTION
                            }
                        }, error => {
                            this.$notify({
                                type: 'primary',
                                message: 'Sorry there is something wrong, pleast try again later',
                                icon: 'fas fa-bug'
                            });

                        });
                    }

                });

            } else {
                this.$notify({
                    type: 'primary',
                    message: 'Please stop the campaign before archive it.',
                    icon: 'fas fa-bug'
                });
            }
        },
        redirectaddclient() {
            this.$router.push({ name: 'Client List' })
        },
        tooltip_campaign(index, row, stat) {
            if (stat == 'play') {
                if (row.disabled == 'T' && row.active_user == 'F' && row.customer_card_id != '') {
                    return "Start Campaign";
                } else if (row.disabled == 'F' && row.active_user == 'T' && row.customer_card_id != '') {
                    return "Campaign is Running";
                } else if (row.active_user == 'F' && (row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F')) {
                    return "Campaign can not start before your complete payment information"
                } else {
                    return "Start Campaign";
                }
            } else if (stat == 'pause') {
                if (row.disabled == 'F' && row.active_user == 'F' && row.customer_card_id != '') {
                    return "Pause Campaign";
                } else if (row.disabled == 'T' && row.active_user == 'T' && row.customer_card_id != '') {
                    return "Campaign is Paused";
                } else if (row.active_user == 'F' && (row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F')) {
                    return "Campaign can not start before your complete payment information"
                } else {
                    return "Pause Campaign";
                }

            } else if (stat == 'stop') {
                if (row.active_user == 'T' && row.customer_card_id != '') {
                    return "Stop Campaign";
                } else if (row.active_user == 'F' && row.customer_card_id != '') {
                    return "Campaign is Stopped";
                } else if (row.active_user == 'F' && (row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F')) {
                    return "Campaign can not start before your complete payment information"
                } else {
                    return "Stop Campaign";
                }
            }

            return ""
        },
        setModuleCost() {
            this.isLoadingModuleCost = true
            if((this.totalLeads.oneTime < 50) && (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid')) {
                this.$notify({
                    type: 'danger',
                    message: 'Minimum 50 lead',
                    icon: 'far fa-save'
                });
                return;
            } 
            if (this.LeadspeekCostperlead == 0 && this.LeadspeekMinCostMonth > 0 && this.userType == 'client' && this.LeadspeekLimitLead != this.LeadspeekLimitLeadDB){
                this.$notify({
                    type: 'danger',
                    message: "Contact per day can't be changed..",
                    icon: 'far fa-save'
                });
            }
            else {
                    //if (this.selectsAppModule.AppModuleSelect == 'Leads Peek') {
                /** SET MODULE COST */
                if( (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') || (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') || (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'onetime')) {
                    this.selectsAppModule.LeadsLimitSelect  = 'day';
                }
                
                this.$store.dispatch('ClientModuleCost', {
                    companyID: this.companyID,
                    ClientID: this.ClientActiveID,
                    ModuleName: this.selectsAppModule.AppModuleSelect,
                    CostSet: this.LeadspeekCostperlead,
                    CostMonth: this.LeadspeekMinCostMonth,
                    CostMaxLead: this.LeadspeekMaxLead,
                    LimitLead: this.LeadspeekLimitLead,
                    enableMinimumLimitLeads: this.LeadspeekEnableMinimumLeadsPerDay,
                    minimumLimitLeads: this.LeadspeekMinimumLeadsPerDay,
                    LimitLeadFreq: this.selectsAppModule.LeadsLimitSelect,
                    LimitLeadStart: moment(this.LeadspeekMaxDateStart, "YYYY-MM-DD").format('YYYY-MM-DD'),
                    //LimitLeadEnd: moment(this.LeadspeekDateEnd, "YYYY-MM-DD").format('YYYY-MM-DD'),
                    LimitLeadEnd: this.format_date(this.$moment(this.LeadspeekDateEnd).format('YYYY-MM-DD') + " 23:59:59",true,false),
                    PaymentTerm: this.selectsPaymentTerm.PaymentTermSelect,
                    topupoptions: this.prepaidType,
                    leadsbuy: this.prepaidType == 'continual' ? this.totalLeads.continualTopUp : this.totalLeads.oneTime,
                    PlatformFee: this.LeadspeekPlatformFee,
                    LeadspeekApiId: this.ActiveLeadspeekID,
                    idUser: this.$store.getters.userData.id,
                    ipAddress: this.$store.getters.userData.ip_login,
                    // continualBuyOption: this.contiDurationSelection ? 'Monthly' :  'Weekly',
                    contiDurationSelection: this.contiDurationSelection,
                    idSys: this.$global.idsys
                }).then(response => {
                    // USER LOGS EDIT
                    let descriptionLogs = "";
                    const { billingFrequency, topUpOptions, setupFee, campaignFee, costPerLead, leadPerDay, contiDurationSelection, endDate, enableMinimumLeadPerDay, minimumLeadPerDay, lpLimitFreq } = this.prevCampaignFinancial;
                    const updates = [
                        { label: "Billing Frequency", prev: billingFrequency, new: this.selectsPaymentTerm.PaymentTermSelect },
                        { label: "Duration Continual Selection", prev: contiDurationSelection ? 'Monthly' : 'Weekly', new: this.contiDurationSelection ? 'Monthly' : 'Weekly' },
                        { label: "Top Up Options", prev: topUpOptions, new: this.prepaidType },
                        { label: "Set Up Fee", prev: setupFee, new: this.LeadspeekPlatformFee },
                        { label: "Campaign Fee", prev: campaignFee, new: this.LeadspeekMinCostMonth },
                        { label: "Cost Per Lead", prev: costPerLead, new: this.LeadspeekCostperlead },
                        { label: "Limit Leads Per "+this.selectsAppModule.LeadsLimitSelect, prev: leadPerDay, new: this.LeadspeekLimitLead },
                        { label: "End Date", prev: endDate, new: moment(this.LeadspeekDateEnd).format('YYYY-MM-DD') },
                        { label: "Enable Minimum Leads Per Day", prev: enableMinimumLeadPerDay, new: this.LeadspeekEnableMinimumLeadsPerDay },
                        { label: "Minimum Leads Per Day", prev: minimumLeadPerDay, new: this.LeadspeekMinimumLeadsPerDay },
                        { label: "How Many Contact", prev: lpLimitFreq, new: this.selectsAppModule.LeadsLimitSelect },
                    ];

                    updates.forEach(({ label, prev, new: newValue }) => {
                        if (prev !== newValue) {
                            if (label == 'How Many Contact') {
                                descriptionLogs += `${label} : Update values from Limit per ${prev} to Limit per ${newValue} | `;
                            } else {
                                descriptionLogs += `${label} : Update values from ${prev} to ${newValue} | `;
                            }
                        } else {
                            descriptionLogs += `${label} : No changes, value remains ${prev} | `;
                        }
                    });

                    if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid'){
                        descriptionLogs += `Remaining Balance : ${this.remainingBalanceLeads} | `;
                        descriptionLogs += `Leads Buy : ${this.prepaidType == 'continual' ? this.totalLeads.continualTopUp : this.totalLeads.oneTime} | `;
                    }

                    descriptionLogs = descriptionLogs.trim().replace(/\|$/, "");
                    const desc = descriptionLogs ? descriptionLogs : 'No updates were made as all values remain unchanged.';

                    const userData = this.$store.getters.userData
                    // const data = {
                    //     userID: userData.id,
                    //     action: 'Edit Campaign Financial Local',
                    //     desc: `Campaign Id: ${this.ActiveLeadspeekID} | ${desc}`,
                    //     userIP: this.$store.getters.userData.ip_login,
                    // }
                    // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                    // if(userViewMode){
                    //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                    //     data.userID = userRoot.id;
                    // }
                    // this.userLogSaved({ data});

                    this.$store.dispatch('onSaveUserLogs', {
                        desc: `Campaign Id: ${this.ActiveLeadspeekID} | ${desc}`,
                        action: 'Edit Campaign Financial Local',
                        // target_id: this.selectedRowData.user_id,
                        target_id: this.userIdCampaign,
                    })
                    // USER LOGS EDIT

                    this.modals.pricesetup = false;

                    if(typeof(response.result) != 'undefined' && (response.result == 'failed_campaign_already_active' || response.result == 'failed_campaign_already_paused')) {
                        this.GetClientList();
                        this.$notify({
                            type: 'danger',
                            message: response.message,
                            icon: 'fas fa-bug'
                        });
                        return false;
                    }

                    /** UPDATE ROW */
                    this.tableData[this.LeadspeekClientActiveIndex].lp_min_cost_month = this.LeadspeekMinCostMonth
                    this.tableData[this.LeadspeekClientActiveIndex].lp_max_lead_month = this.LeadspeekMaxLead
                    this.tableData[this.LeadspeekClientActiveIndex].cost_perlead = this.LeadspeekCostperlead
                    this.tableData[this.LeadspeekClientActiveIndex].lp_limit_leads = this.LeadspeekLimitLead
                    this.tableData[this.LeadspeekClientActiveIndex].enable_minimum_limit_leads = (this.LeadspeekEnableMinimumLeadsPerDay)?'T':'F'
                    this.tableData[this.LeadspeekClientActiveIndex].minimum_limit_leads = this.LeadspeekMinimumLeadsPerDay
                    this.tableData[this.LeadspeekClientActiveIndex].lp_limit_freq = this.selectsAppModule.LeadsLimitSelect
                    this.tableData[this.LeadspeekClientActiveIndex].lp_limit_startdate = this.LeadspeekMaxDateStart
                    this.tableData[this.LeadspeekClientActiveIndex].lp_enddate = this.LeadspeekDateEnd
                    this.tableData[this.LeadspeekClientActiveIndex].paymentterm = this.selectsPaymentTerm.PaymentTermSelect
                    this.tableData[this.LeadspeekClientActiveIndex].platformfee = this.LeadspeekPlatformFee
                    this.tableData[this.LeadspeekClientActiveIndex].topupoptions = this.prepaidType
                    this.tableData[this.LeadspeekClientActiveIndex].leadsbuy = this.prepaidType == 'continual' ? this.totalLeads.continualTopUp : this.totalLeads.oneTime
                    this.tableData[this.LeadspeekClientActiveIndex].stopcontinual =  (this.isContainulTopUpStop)? 'T':'F'
                    this.tableData[this.LeadspeekClientActiveIndex].continual_buy_options = this.contiDurationSelection;
                    /** UPDAE ROW */

                    this.$notify({
                        type: 'success',
                        message: 'Data has been updated successfully',
                        icon: 'far fa-save'
                    });
                    this.isLoadingModuleCost = false
                }, error => {
                    this.isLoadingModuleCost = false
                });
                /** SET MODULE COST */
                //}
            }
            
        },
        paymentTermChange() {
            if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                this.txtLeadService = 'per week';
                this.txtLeadIncluded = 'in that weekly charge';
                this.txtLeadOver = 'from the weekly charge';
                this.prepaidType= '';

                this.m_LeadspeekPlatformFee = this.costagency.local.Weekly.LeadspeekPlatformFee;
                if(this.campaign_information_type_local_includes_advanced) {
                    this.m_LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperleadAdvanced;
                } else {
                    this.m_LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperlead;
                }
                this.m_LeadspeekMinCostMonth = this.costagency.local.Weekly.LeadspeekMinCostMonth;
                this.m_LeadspeekLimitLead = this.clientdefaultprice.local.Weekly.LeadspeekLeadsPerday;
                this.m_LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.local.Weekly.LeadspeekLeadsPerday) != 'undefined' ? this.clientdefaultprice.local.Weekly.LeadspeekLeadsPerday : 10;

                this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.m_LeadspeekCostperlead; 
                this.LeadspeekMinCostMonth = this.m_LeadspeekMinCostMonth;
                this.LeadspeekLimitLead = this.m_LeadspeekLimitLead;
                this.LeadspeekMinimumLeadsPerDay = this.m_LeadspeekMinimumLeadsPerDay >= 1 ? this.m_LeadspeekMinimumLeadsPerDay : 1;

                /*if (this.selectsPaymentTerm.PaymentTermSelect != this.defaultCostCampaign.paymentterm) {
                    console.log('1');
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.local.Weekly.LeadspeekPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.local.Weekly.LeadspeekCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.local.Weekly.LeadspeekMinCostMonth;
                } else {*/
                if (this.selectsPaymentTerm.PaymentTermSelect == this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.LeadspeekPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.LeadspeekCostperlead
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.LeadspeekMinCostMonth;
                    this.LeadspeekLimitLead = this.defaultCostCampaign.LeadspeekLeadsPerday;
                    
                    if(this.defaultCostCampaign.LeadspeekMinimumLeadDay != null && this.defaultCostCampaign.LeadspeekMinimumLeadDay != '') {
                        this.LeadspeekMinimumLeadsPerDay = this.defaultCostCampaign.LeadspeekMinimumLeadDay;
                    }
                }else{
                    if (this.clientdefaultprice != "") {
                        this.LeadspeekPlatformFee = this.clientdefaultprice.local.Weekly.LeadspeekPlatformFee;
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.LeadspeekCostperlead = this.clientdefaultprice.local.Weekly.LeadspeekCostperleadAdvanced;
                        } else {
                            this.LeadspeekCostperlead = this.clientdefaultprice.local.Weekly.LeadspeekCostperlead;
                        }
                        this.LeadspeekMinCostMonth = this.clientdefaultprice.local.Weekly.LeadspeekMinCostMonth;
                    }else{
                        this.LeadspeekPlatformFee = this.defaultCostCampaign.local.Weekly.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.defaultCostCampaign.local.Weekly.LeadspeekCostperlead;
                        this.LeadspeekMinCostMonth = this.defaultCostCampaign.local.Weekly.LeadspeekMinCostMonth;
                        //this.LeadspeekLimitLead = this.defaultCostCampaign.local.Weekly.LeadspeekLimitLead;
                    }
                }

                /* VALIDATE MINIMUM LED PER DAY */
                if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                }
                /* VALIDATE MINIMUM LED PER DAY */

            } else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                this.txtLeadService = 'per month';
                this.txtLeadIncluded = 'in that monthly charge';
                this.txtLeadOver = 'from the monthly charge';
                this.prepaidType= '';

                this.m_LeadspeekPlatformFee = this.costagency.local.Monthly.LeadspeekPlatformFee;
                if(this.campaign_information_type_local_includes_advanced) {
                    this.m_LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperleadAdvanced;
                } else {
                    this.m_LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperlead;
                }
                this.m_LeadspeekMinCostMonth = this.costagency.local.Monthly.LeadspeekMinCostMonth;
                this.m_LeadspeekLimitLead = this.clientdefaultprice.local.Monthly.LeadspeekLeadsPerday;
                this.m_LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.local.Monthly.LeadspeekLeadsPerday) != 'undefined' ? this.clientdefaultprice.local.Monthly.LeadspeekLeadsPerday : 10;

                this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.m_LeadspeekCostperlead; 
                this.LeadspeekMinCostMonth = this.m_LeadspeekMinCostMonth;
                this.LeadspeekLimitLead = this.m_LeadspeekLimitLead;
                this.LeadspeekMinimumLeadsPerDay = this.m_LeadspeekMinimumLeadsPerDay >= 1 ? this.m_LeadspeekMinimumLeadsPerDay : 1;
                /*if (this.selectsPaymentTerm.PaymentTermSelect != this.defaultCostCampaign.paymentterm) {
                     console.log('3');
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.local.Monthly.LeadspeekPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.local.Monthly.LeadspeekCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.local.Monthly.LeadspeekMinCostMonth;
                } else {*/
                if (this.selectsPaymentTerm.PaymentTermSelect == this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.LeadspeekPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.LeadspeekCostperlead
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.LeadspeekMinCostMonth;
                    this.LeadspeekLimitLead = this.defaultCostCampaign.LeadspeekLeadsPerday;

                    if(this.defaultCostCampaign.LeadspeekMinimumLeadDay != null && this.defaultCostCampaign.LeadspeekMinimumLeadDay != '') {
                        this.LeadspeekMinimumLeadsPerDay = this.defaultCostCampaign.LeadspeekMinimumLeadDay;
                    }
                }else{
                    if (this.clientdefaultprice != "") {
                        this.LeadspeekPlatformFee = this.clientdefaultprice.local.Monthly.LeadspeekPlatformFee;
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.LeadspeekCostperlead = this.clientdefaultprice.local.Monthly.LeadspeekCostperleadAdvanced;
                        } else {
                            this.LeadspeekCostperlead = this.clientdefaultprice.local.Monthly.LeadspeekCostperlead;
                        }
                        this.LeadspeekMinCostMonth = this.clientdefaultprice.local.Monthly.LeadspeekMinCostMonth;
                    }else{
                        this.LeadspeekPlatformFee = this.defaultCostCampaign.local.Monthly.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.defaultCostCampaign.local.Monthly.LeadspeekCostperlead;
                        this.LeadspeekMinCostMonth = this.defaultCostCampaign.local.Monthly.LeadspeekMinCostMonth;
                        //this.LeadspeekLimitLead = this.defaultCostCampaign.local.Monthly.LeadspeekLimitLead;
                    }
                }

                /* VALIDATE MINIMUM LED PER DAY */
                if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                }
                /* VALIDATE MINIMUM LED PER DAY */

            } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                // this.prepaidType = 'continual';
                // console.log('prepaid');
                // console.log(this.prepaidType);;
                // console.log('prepaid');
                this.txtLeadService = 'per month';
                this.txtLeadIncluded = 'in that week charge';
                this.txtLeadOver = 'from the week charge';
                this.prepaidType = this.selectedRowData.topupoptions ? this.selectedRowData.topupoptions : 'continual';
                if (typeof(this.costagency.local.Prepaid) == 'undefined') {
                    this.$set(this.costagency.local,'Prepaid',{
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    });
                }

                if (typeof(this.costagency.local.Prepaid.LocatorLeadsPerday) == 'undefined') {
                    this.$set(this.costagency.local.Prepaid, 'LeadspeekLeadsPerday', '10');
                    this.costagency.local.Prepaid.LeadspeekLeadsPerday = '10';
                }

                this.m_LeadspeekPlatformFee = this.costagency.local.Prepaid.LeadspeekPlatformFee;
                if(this.campaign_information_type_local_includes_advanced) {
                    this.m_LeadspeekCostperlead = this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced;
                } else {
                    this.m_LeadspeekCostperlead = this.costagency.local.Prepaid.LeadspeekCostperlead;
                }
                this.m_LeadspeekMinCostMonth = this.costagency.local.Prepaid.LeadspeekMinCostMonth;
                this.m_LeadspeekLimitLead = this.clientdefaultprice.local.Prepaid.LeadspeekLeadsPerday;
                this.m_LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.local.Prepaid.LeadspeekLeadsPerday) != 'undefined' ? this.clientdefaultprice.local.Prepaid.LeadspeekLeadsPerday : 10;

                this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.m_LeadspeekCostperlead; 
                this.LeadspeekMinCostMonth = this.m_LeadspeekMinCostMonth;
                this.LeadspeekLimitLead = this.m_LeadspeekLimitLead;
                this.LeadspeekMinimumLeadsPerDay = this.m_LeadspeekMinimumLeadsPerDay >= 1 ? this.m_LeadspeekMinimumLeadsPerDay : 1;
                
                /*if (this.selectsPaymentTerm.PaymentTermSelect != this.defaultCostCampaign.paymentterm) {
                     console.log('5');
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.local.OneTime.LeadspeekPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.local.OneTime.LeadspeekCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.local.OneTime.LeadspeekMinCostMonth;
                } else {*/
                if (this.selectsPaymentTerm.PaymentTermSelect == this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.LeadspeekPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.LeadspeekCostperlead
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.LeadspeekMinCostMonth;
                    this.LeadspeekLimitLead = this.defaultCostCampaign.LeadspeekLeadsPerday;
                }else{
                    if (this.clientdefaultprice != "") {
                        this.LeadspeekPlatformFee = this.clientdefaultprice.local.Prepaid.LeadspeekPlatformFee;
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.LeadspeekCostperlead = this.clientdefaultprice.local.Prepaid.LeadspeekCostperleadAdvanced
                        } else {
                            this.LeadspeekCostperlead = this.clientdefaultprice.local.Prepaid.LeadspeekCostperlead
                        }
                        this.LeadspeekMinCostMonth = this.clientdefaultprice.local.Prepaid.LeadspeekMinCostMonth;
                    }else{
                        this.LeadspeekPlatformFee = this.defaultCostCampaign.local.Prepaid.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.defaultCostCampaign.local.Prepaid.LeadspeekCostperlead
                        this.LeadspeekMinCostMonth = this.defaultCostCampaign.local.Prepaid.LeadspeekMinCostMonth;
                        //this.LeadspeekLimitLead = this.defaultCostCampaign.local.Prepaid.EnhanceLeadsPerday;
                    }
                }

                if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'continual' && this.selectsAppModule.LeadsLimitSelect == 'month') {
                    this.validationMinLeadPrepaidLimitMonth();
                } else {
                    /* VALIDATE MINIMUM LED PER DAY */
                    if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                        this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                    }
                    /* VALIDATE MINIMUM LED PER DAY */
                }

            } else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                this.txtLeadService = '';
                this.txtLeadIncluded = '';
                this.txtLeadOver = '';

                this.m_LeadspeekPlatformFee = this.costagency.local.OneTime.LeadspeekPlatformFee;
                if(this.campaign_information_type_local_includes_advanced) { 
                    this.m_LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperleadAdvanced;
                } else {
                    this.m_LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperlead;
                }
                this.m_LeadspeekMinCostMonth = this.costagency.local.OneTime.LeadspeekMinCostMonth;
                this.m_LeadspeekLimitLead = this.clientdefaultprice.local.OneTime.LeadspeekLeadsPerday;
                this.m_LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.local.OneTime.LeadspeekLeadsPerday) != 'undefined' ? this.clientdefaultprice.local.OneTime.LeadspeekLeadsPerday : 10;

                this.LeadspeekPlatformFee = this.m_LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.m_LeadspeekCostperlead; 
                this.LeadspeekMinCostMonth = this.m_LeadspeekMinCostMonth;
                this.LeadspeekLimitLead = this.m_LeadspeekLimitLead;
                this.m_LeadspeekMinimumLeadsPerDay = this.m_LeadspeekMinimumLeadsPerDay >= 1 ? this.m_LeadspeekMinimumLeadsPerDay : 1;
                /*if (this.selectsPaymentTerm.PaymentTermSelect != this.defaultCostCampaign.paymentterm) {
                     console.log('5');
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.local.OneTime.LeadspeekPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.local.OneTime.LeadspeekCostperlead;
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.local.OneTime.LeadspeekMinCostMonth;
                } else {*/
                if (this.selectsPaymentTerm.PaymentTermSelect == this.defaultCostCampaign.paymentterm) {
                    this.LeadspeekPlatformFee = this.defaultCostCampaign.LeadspeekPlatformFee;
                    this.LeadspeekCostperlead = this.defaultCostCampaign.LeadspeekCostperlead
                    this.LeadspeekMinCostMonth = this.defaultCostCampaign.LeadspeekMinCostMonth;
                    this.LeadspeekLimitLead = this.defaultCostCampaign.LeadspeekLeadsPerday;
                }

                /* VALIDATE MINIMUM LED PER DAY */
                if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                }
                /* VALIDATE MINIMUM LED PER DAY */

            }

            // USER LOGS EDIT
            const updateLogs = {
                ...this.prevCampaignFinancial,
                contiDurationSelection: this.contiDurationSelection ? 'Monthly' : 'Weekly',
                topUpOptions: this.prepaidType,
                setupFee: this.LeadspeekPlatformFee,
                campaignFee: this.LeadspeekMinCostMonth,
                costPerLead: this.LeadspeekCostperlead,
                leadPerDay: this.LeadspeekLimitLead,
                endDate: moment(this.LeadspeekDateEnd).format('YYYY-MM-DD'),
                enableMinimumLeadPerDay: this.LeadspeekEnableMinimumLeadsPerDay,
                minimumLeadPerDay: this.LeadspeekMinimumLeadsPerDay,
            }

            this.prevCampaignFinancial = updateLogs
            // USER LOGS EDIT

            /** CALCULATION PROFIT PER TERM */
            this.profitcalculation();
            /** CALCULATION PROFIT PER TERM */

            // if(this.selectsPaymentTerm.PaymentTermSelect != 'Prepaid'){
            //     this.topUpType = 'contact';
            // }
        },
        checkLeadsType() {
            if (this.selectsAppModule.LeadsLimitSelect == 'Max') {
                this.LeadspeekMaxDateVisible = true;
            } else {
                this.LeadspeekMaxDateVisible = false;
            }
        },
        formatPrice(value) {
            if (isNaN(value)) {
                return "0";
            }

            //let val = (value/1).toFixed(2).replace(',', '.')
            let val = (value/1).toFixed(2)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        profitcalculation_() {
            this.t_LeadspeekPlatformFee = this.LeadspeekPlatformFee - this.m_LeadspeekPlatformFee;
            this.t_LeadspeekMinCostMonth = this.LeadspeekMinCostMonth - this.m_LeadspeekMinCostMonth;
            this.t_LeadspeekCostperlead = this.LeadspeekCostperlead - this.m_LeadspeekCostperlead;

            if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                //console.log(this.t_LeadspeekPlatformFee + ' | ' +  this.t_LeadspeekMinCostMonth + ' | ' + this.m_LeadspeekCostperlead + ' | ' + this.LeadspeekMaxLead);
                this.t_profit = this.formatPrice(this.t_LeadspeekPlatformFee + this.t_LeadspeekMinCostMonth - (this.m_LeadspeekCostperlead * this.LeadspeekMaxLead));
                this.t_LeadspeekCostperlead = this.formatPrice(this.m_LeadspeekCostperlead * this.LeadspeekMaxLead);
                this.t_freqshow = '';
            } else {
                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    this.t_freqshow = 'week';
                    this.t_freq = '1';
                } else {
                    this.t_freqshow = 'month';
                    this.t_freq = '4';
                }
                var _estleadspermonth = ((this.LeadspeekLimitLead * 7) * this.t_freq) * this.t_LeadspeekCostperlead;
                this.t_estleadspermonth = this.formatPrice(_estleadspermonth);
                this.t_profit = this.formatPrice(this.t_LeadspeekMinCostMonth + _estleadspermonth);
                this.t_LeadspeekCostperlead = this.formatPrice(this.t_LeadspeekCostperlead);
            }
        },
        // new function profitcalculation, add estimate client cost - AGIES
        profitcalculation() {
            /* VALIDATE MINIMUM LED PER DAY */
            if(this.selectsPaymentTerm.PaymentTermSelect != 'Prepaid' || this.selectsAppModule.LeadsLimitSelect != 'month') {
                if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {
                    this.errMinClientLeadDay = true;
                } else {
                    this.errMinClientLeadDay = false;
                }
            }
            /* VALIDATE MINIMUM LED PER DAY */
            
            if (this.LeadspeekLimitLead == "") {
                return false;
            }
            this.t_LeadspeekPlatformFee = this.LeadspeekPlatformFee - this.m_LeadspeekPlatformFee;
            this.t_LeadspeekMinCostMonth = this.LeadspeekMinCostMonth - this.m_LeadspeekMinCostMonth;
            this.t_LeadspeekCostperlead = this.LeadspeekCostperlead - this.m_LeadspeekCostperlead;

            if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                //console.log(this.t_LeadspeekPlatformFee + ' | ' +  this.t_LeadspeekMinCostMonth + ' | ' + this.m_LeadspeekCostperlead + ' | ' + this.LeadspeekMaxLead);
                this.t_profit = this.formatPrice(this.t_LeadspeekPlatformFee + this.t_LeadspeekMinCostMonth - (this.m_LeadspeekCostperlead * this.LeadspeekMaxLead));
                this.t_LeadspeekCostperlead = this.formatPrice(this.m_LeadspeekCostperlead * this.LeadspeekMaxLead);
                this.t_freqshow = '';
            } 
            // else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'continual') {
            //     this.totalLeads.continualTopUp = this.LeadspeekLimitLead * 7 * 4;
            // } 
            else {
                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    this.t_freqshow = 'week';
                    this.t_freq = '1';
                } else {
                    this.t_freqshow = 'month';
                    this.t_freq = '4';
                }

                var _estleadspermonth = ((this.LeadspeekLimitLead * 7) * this.t_freq) * this.t_LeadspeekCostperlead;

                this.t_cost = this.formatPrice( this.t_LeadspeekMinCostMonth + (((this.LeadspeekCostperlead * this.LeadspeekLimitLead) * 7) * parseInt(this.t_freq)));
                this.t_estleadspermonth = this.formatPrice(_estleadspermonth);
                this.t_profit = this.formatPrice(this.t_LeadspeekMinCostMonth + _estleadspermonth);

                if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.contiDurationSelection) {
                    this.t_profit = this.formatPrice(this.t_LeadspeekPlatformFee + (_estleadspermonth));
                } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && !this.contiDurationSelection) {
                    this.t_profit = this.formatPrice(this.t_LeadspeekPlatformFee + (_estleadspermonth / 4));
                }

                this.t_LeadspeekCostperlead = this.formatPrice(this.t_LeadspeekCostperlead);
                
                if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && this.prepaidType == 'continual') {
                    if(this.selectsAppModule.LeadsLimitSelect == 'day') {
                        this.totalLeads.continualTopUp = this.contiDurationSelection ? (this.LeadspeekLimitLead * 7) * 4: (this.LeadspeekLimitLead * 7);
                    } else {
                        this.totalLeads.continualTopUp = this.LeadspeekLimitLead;
                    }
                }
            }
        },
        showQuestionnaire(index, row) {
            this.questionnaire.campaign_name = row.campaign_name;
            this.questionnaire.url_code = row.url_code;

            var aq = JSON.parse(row.questionnaire_answers);
            this.questionnaire.asec3_1 = aq.asec3_1;
            this.questionnaire.asec3_2 = aq.asec3_2;
            this.questionnaire.asec3_3 = (aq.asec3_3) ? 'I agree' : '';
            this.questionnaire.asec3_4 = aq.asec3_4;
            this.questionnaire.asec3_5 = aq.asec3_5;
            this.questionnaire.asec3_6 = aq.asec3_6;

            this.questionnaire.asec6_1 = (aq.asec6_1 == "GoogleSheet") ? "Google Sheet" : "Google Sheet";
            if (typeof (aq.asec6_2) != 'undefined') {
                this.questionnaire.asec6_2 = aq.asec6_2.replace('_', ' ');
            }
            this.questionnaire.asec6_3 = (typeof (aq.asec6_3) == 'undefined') ? '' : aq.asec6_3;
            this.questionnaire.asec6_4 = (typeof (aq.asec6_4) == 'undefined') ? '' : aq.asec6_4;

            if (aq.asec6_5 == "FirstName,LastName,MailingAddress") {
                this.questionnaire.asec6_5 = "Must Have Contact Name and Mailing Address";
            } else if (aq.asec6_5 == "FirstName,LastName") {
                this.questionnaire.asec6_5 = "Must Have Contact Name";
            } else if (aq.asec6_5 == "MailingAddress") {
                this.questionnaire.asec6_5 = "Must Have Mailing Address";
            }

            this.questionnaire.asec6_6 = (aq.asec6_6) ? "I understand and agree to follow the law and will notify anyone using these contacts of the law." : "";
            this.questionnaire.asec6_7 = aq.asec6_7;

            this.LeadspeekCompany = row.campaign_name + ' #' + row.leadspeek_api_id + ' (' + row.company_name + ')';
            this.modals.questionnaire = true;
        },
        resetAgencyCost() {
            this.m_LeadspeekPlatformFee = '0';
            this.m_LeadspeekCostperlead = '0';
            this.m_LeadspeekMinCostMonth = '0';

            this.costagency.local.Weekly.LeadspeekPlatformFee = '0';
            this.costagency.local.Weekly.LeadspeekCostperlead = '0';
            this.costagency.local.Weekly.LeadspeekMinCostMonth = '0';

            this.costagency.local.Monthly.LeadspeekPlatformFee = '0';
            this.costagency.local.Monthly.LeadspeekCostperlead = '0';
            this.costagency.local.Monthly.LeadspeekMinCostMonth = '0';

            this.costagency.local.OneTime.LeadspeekPlatformFee = '0';
            this.costagency.local.OneTime.LeadspeekCostperlead = '0';
            this.costagency.local.OneTime.LeadspeekMinCostMonth = '0';

            if (typeof(this.costagency.local.Prepaid) !== 'undefined') {
                this.costagency.local.Prepaid.LeadspeekPlatformFee = '0';
                this.costagency.local.Prepaid.LeadspeekCostperlead = '0';
                this.costagency.local.Prepaid.LeadspeekMinCostMonth = '0';
            }
        },
        getMasterAgencyCost() {
            this.resetAgencyCost();
            this.$store.dispatch('getGeneralSetting', {
                companyID: this.companyID,
                settingname: 'costagency',
                idSys: this.$global.idsys,
                pk: this.activeClientCompanyID,
            }).then(response => {
                //console.log(response.data);
                if (response.data != '') {
                    this.costagency = response.data;
                    this.clientdefaultprice = response.clientDefaultPrice;
                    // console.log('getMasterAgencyCost', {'this.costagency': this.costagency,'this.clientdefaultprice': this.clientdefaultprice,});

                    /* VALIDATE MINIMUM LED PER DAY */
                    if(this.LeadspeekMinimumLeadsPerDay == null) {
                        if(this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                            this.LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.local.Weekly.LeadspeekLeadsPerday) != 'undefined' ? this.clientdefaultprice.local.Weekly.LeadspeekLeadsPerday : 10;
                        } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                            this.LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.local.Monthly.LeadspeekLeadsPerday) != 'undefined' ? this.clientdefaultprice.local.Monthly.LeadspeekLeadsPerday : 10;
                        } else if(this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                            this.LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.local.OneTime.LeadspeekLeadsPerday) != 'undefined' ? this.clientdefaultprice.local.OneTime.LeadspeekLeadsPerday : 10;
                        } else if(this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                            this.LeadspeekMinimumLeadsPerDay = typeof(this.clientdefaultprice.local.Prepaid.LeadspeekLeadsPerday) != 'undefined' ? this.clientdefaultprice.local.Prepaid.LeadspeekLeadsPerday : 10;
                        }
                    }

                    this.LeadspeekMinimumLeadsPerDay = this.LeadspeekMinimumLeadsPerDay >= 1 ? this.LeadspeekMinimumLeadsPerDay : 1;

                    if(this.LeadspeekEnableMinimumLeadsPerDay == true && Number(this.LeadspeekLimitLead) < Number(this.LeadspeekMinimumLeadsPerDay)) {    
                        this.LeadspeekLimitLead = this.LeadspeekMinimumLeadsPerDay;
                    }
                    /* VALIDATE MINIMUM LED PER DAY */
                    
                    if (typeof(this.costagency.local.Weekly.LeadspeekLeadsPerday) === 'undefined') {
                        this.costagency.local.Weekly.LeadspeekLeadsPerday = '10';
                    }
                    if (typeof(this.costagency.local.Monthly.LeadspeekLeadsPerday) === 'undefined') {
                        this.costagency.local.Monthly.LeadspeekLeadsPerday = '10';
                    }
                    if (typeof(this.costagency.local.OneTime.LeadspeekLeadsPerday) === 'undefined') {
                        this.costagency.local.OneTime.LeadspeekLeadsPerday = '10';
                    }

                    if (typeof(this.costagency.local.Prepaid) == 'undefined') {
                        this.$set(this.costagency.local,'Prepaid',{
                            LeadspeekPlatformFee: '0',
                            LeadspeekCostperlead: '0',
                            LeadspeekMinCostMonth: '0',
                            LeadspeekLeadsPerday: '10',
                        });
                    }

                    if (typeof(this.costagency.local.Prepaid.LeadspeekLeadsPerday) === 'undefined') {
                        this.$set(this.costagency.local.Prepaid, 'LeadspeekLeadsPerday', '10');
                        this.costagency.local.Prepaid.LeadspeekLeadsPerday = '10';
                    }
                    if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.m_LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperleadAdvanced;
                        } else {
                            this.m_LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperlead;
                        }
                        this.m_LeadspeekPlatformFee = this.costagency.local.Weekly.LeadspeekPlatformFee;
                        this.m_LeadspeekMinCostMonth = this.costagency.local.Weekly.LeadspeekMinCostMonth;
                        this.m_LeadspeekLimitLead = this.costagency.local.Weekly.LeadspeekLeadsPerday;
                    } else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.m_LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperleadAdvanced;
                        } else {
                            this.m_LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperlead;
                        }
                        
                        this.m_LeadspeekPlatformFee = this.costagency.local.Monthly.LeadspeekPlatformFee;
                        this.m_LeadspeekMinCostMonth = this.costagency.local.Monthly.LeadspeekMinCostMonth;
                        this.m_LeadspeekLimitLead = this.costagency.local.Monthly.LeadspeekLeadsPerday;
                    } else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.m_LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperleadAdvanced;
                        } else {
                            this.m_LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperlead;
                        }
                        this.m_LeadspeekPlatformFee = this.costagency.local.OneTime.LeadspeekPlatformFee;
                        this.m_LeadspeekMinCostMonth = this.costagency.local.OneTime.LeadspeekMinCostMonth;
                        this.m_LeadspeekLimitLead = this.costagency.local.OneTime.LeadspeekLeadsPerday;
                    } else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.m_LeadspeekCostperlead = this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced;
                        } else {
                            this.m_LeadspeekCostperlead = this.costagency.local.Prepaid.LeadspeekCostperlead;
                        }
                        this.m_LeadspeekPlatformFee = this.costagency.local.Prepaid.LeadspeekPlatformFee;
                        this.m_LeadspeekMinCostMonth = this.costagency.local.Prepaid.LeadspeekMinCostMonth;
                        this.m_LeadspeekLimitLead = this.costagency.local.Prepaid.LeadspeekLeadsPerday;
                    }

                    this.paymentTermChange();

                    /** CALCULATION PROFIT PER TERM */
                    this.profitcalculation();
                    /** CALCULATION PROFIT PER TERM */

                } else {
                    this.m_LeadspeekPlatformFee = '0';
                    this.m_LeadspeekCostperlead = '0';
                    this.m_LeadspeekMinCostMonth = '0';
                    this.m_LeadspeekLimitLead = '10';
                }

                /** HACK TEMPORARY FOR TRYSERA CAMPAIGN STILL */
                let campaignIDexception = ["2530", "2558", "2559", "2581", "2560", "2555", "2546", "2441", "2563", "2562"];
                let leadpriceException = ["0.15", "0.15", "0.15", "0.17", "0.17", "0.17", "0.17", "0.17", "0.17", "0.17"];
                const searchexecption = campaignIDexception.indexOf(this.ActiveLeadspeekID);

                if (searchexecption >= 0) {
                    this.m_LeadspeekCostperlead = leadpriceException[searchexecption];
                }
                /** HACK TEMPORARY FOR TRYSERA CAMPAIGN STILL */

                /** CALCULATION PROFIT PER TERM */
                this.profitcalculation();
                /** CALCULATION PROFIT PER TERM */

                this.modals.pricesetup = true;

            }, error => {

            });
        },
        handlePriceSet(index, row) {
            this.prevCampaignFinancial = {
                billingFrequency: row.paymentterm,
                topUpOptions: row.topupoptions,
                setupFee: row.platformfee,
                campaignFee: row.lp_min_cost_month,
                costPerLead: row.cost_perlead,
                leadPerDay: row.lp_limit_leads,
                contiDurationSelection: row.continual_buy_options,
                endDate: row.lp_enddate,
                enableMinimumLeadPerDay: row.enable_minimum_limit_leads,
                minimumLeadPerDay: row.minimum_limit_leads,
                lpLimitFreq: row.lp_limit_freq,
            }

            this.selectedRowData = row
            // console.log(row);
            this.activeClientCompanyID = row.company_id;
            this.activeClientCompanyParent = row.company_parent;
            this.ClientActiveID = row.id;
            this.selectsPaymentTerm.PaymentTermSelect = row.paymentterm;
            this.LeadspeekCostperlead = row.cost_perlead;
            this.LeadspeekMaxLead = row.lp_max_lead_month;
            this.LeadspeekMinCostMonth = row.lp_min_cost_month;
            this.LeadspeekLimitLead = row.lp_limit_leads;
            this.LeadspeekEnableMinimumLeadsPerDay = row.enable_minimum_limit_leads == 'T' ? true : false;
            this.LeadspeekMinimumLeadsPerDay = row.minimum_limit_leads;
            this.LeadspeekLimitLeadDB = row.lp_limit_leads;
            this.selectsAppModule.LeadsLimitSelect = row.lp_limit_freq;
            this.LeadspeekCompany = row.campaign_name + ' #' + row.leadspeek_api_id + ' (' + row.company_name + ')';
            this.LeadspeekclientEmail = row.email;
            this.LeadspeekClientActiveIndex = index;
            this.LeadspeekPlatformFee = row.platformfee;
            this.ActiveLeadspeekID = row.leadspeek_api_id;
            this.LeadspeekType = row.leadspeek_type;
            this.prepaidType = row.topupoptions ? row.topupoptions : 'continual';
            this.isContainulTopUpStop = (row.stopcontinual === 'T')?true:false;
            this.contiDurationSelection = row.continual_buy_options;
            this.LeadspeekInvoiceDateNextMonth = row.lp_invoice_date_next_month;
            this.LeadspeekActive =  row.active;
            this.LeadspeekDisabled =  row.disabled;
            this.LeadspeekActiveUser =  row.active_user;
            this.userIdCampaign = row.user_id;
            
            this.campaign_information_type_local_includes_advanced = this.selectedRowData.campaign_information_type_local.includes('advanced');
            // this.topUpType = (this.selectedRowData.campaign_information_type_local.includes('advanced') || this.selectedRowData.campaign_information_type_local.includes('b2b')) ? 'money' : 'contact';
            
            // this.prepaidType = row.prepaid_type;
            this.totalLeads.oneTime = 50;
            if(row.paymentterm == 'Prepaid' && row.topupoptions == 'onetime') {
                this.totalLeads.oneTime = row.leadsbuy;
            }
            // console.log('handle price set');
            // console.log(this.LeadspeekType);
            // console.log('handle price set');

            this.defaultCostCampaign.paymentterm = row.paymentterm;
            this.defaultCostCampaign.LeadspeekCostperlead = row.cost_perlead;
            this.defaultCostCampaign.LeadspeekMinCostMonth = row.lp_min_cost_month;
            this.defaultCostCampaign.LeadspeekPlatformFee = row.platformfee;
            this.defaultCostCampaign.LeadspeekLeadsPerday = row.lp_limit_leads;
            this.defaultCostCampaign.LeadspeekMinimumLeadDay = row.minimum_limit_leads;

            //this.m_LeadspeekPlatformFee = (row.m_platformfee == null)?'0':row.m_platformfee;


            if (row.lp_limit_startdate == '' || row.lp_limit_startdate == null) {
                this.LeadspeekMaxDateStart = moment().format('YYYY-MM-DD HH:mm:ss');
            } else {
                this.LeadspeekMaxDateStart = moment(row.lp_limit_startdate).format('YYYY-MM-DD HH:mm:ss');
            }
            if (row.lp_enddate == '' || row.lp_enddate == null) {
                this.LeadspeekDateEnd = '';
            } else {
                this.LeadspeekDateEnd = row.lp_enddate !== '0000-00-00 00:00:00' ? moment(row.lp_enddate).format('YYYY-MM-DD HH:mm:ss') : '';
            }
            if (row.lp_limit_freq == 'max') {
                this.LeadspeekMaxDateVisible = true;
            } else {
                this.LeadspeekMaxDateVisible = false;
            }
            if (
                (row.paymentterm != 'Prepaid') &&
                (
                    (row.active == 'T' && row.disabled == 'F' && row.active_user == 'T') || // play
                    (row.active == 'F' && row.disabled == 'T' && row.active_user == 'T') || // paused
                    (row.active == 'F' && row.disabled == 'F' && row.active_user == 'T')    // paused on run
                )
            ) {
                this.LeadspeekInputReadOnly = true;
            } else {
                this.LeadspeekInputReadOnly = false;

                if (row.paymentterm == 'Prepaid' && row.active_user == 'F' && row.active == 'F') {
                    this.OnlyPrepaidDisabled = false;
                }else if (row.paymentterm != 'Prepaid' && row.active_user == 'F' && row.active == 'F') {
                    this.OnlyPrepaidDisabled = false;
                }else{
                    this.OnlyPrepaidDisabled = true;
                }
            }

            /** GET MASTER AGENCY COST */
            this.getMasterAgencyCost();
            /** GET MASTER AGENCY COST */

            /* GET remaining balance leads */
            this.getRemainingBalanceLeads();
            /* GET remaining balance leads */
        },
        getRemainingBalanceLeads() {
            this.$store.dispatch(`getRemainingBalanceLeads`, {
                leadspeek_api_id: this.ActiveLeadspeekID
            })
            .then(response => {
                this.remainingBalanceLeads = response.data.remainingBalanceLeads ? response.data.remainingBalanceLeads : 0;
            })
            .catch(error => {
                console.error(error);
            })
        },
        chkHideShowGTM(row) {
            if (this.selectedRowData.gtminstalled == 'T') {
                this.selectedRowData.gtminstalled = 'F';
            } else {
                this.selectedRowData.gtminstalled = 'T';
            }
        },
        chkHideShowCol(row) {
            if (row.hide_phone == 'T') {
                row.hide_phone = 'F';
            } else {
                row.hide_phone = 'T';
            }
        },
        companyGroupChange(_companyGroupSelected, id) {
            if (id == '') {
                for (let i = 0; i < this.selectsGroupCompany.companyGroupList.length; i++) {
                    if (this.selectsGroupCompany.companyGroupList[i].id == _companyGroupSelected) {
                        this.selectsGroupCompany.companyGroupID = this.selectsGroupCompany.companyGroupList[i].id;
                        this.selectsGroupCompany.newCompanyGroupName = this.selectsGroupCompany.companyGroupList[i].group_name;
                    }
                }
            } else {
                for (let i = 0; i < this.selectsGroupCompany.companyGroupList.length; i++) {
                    if (this.selectsGroupCompany.companyGroupList[i].id == _companyGroupSelected) {
                        id.group_company_id = this.selectsGroupCompany.companyGroupList[i].id;
                        id.group_name = this.selectsGroupCompany.companyGroupList[i].group_name;
                    }
                }
            }
        },
        processAddEditCompanyGroup(id) {

            if (id == '') {
                this.$store.dispatch('AddEditGroupCompany', {
                    companyGroupID: this.selectsGroupCompany.companyGroupID,
                    companyGroupName: this.selectsGroupCompany.newCompanyGroupName,
                    companyID: this.companyID,
                    moduleID: '3',
                }).then(response => {
                    //console.log(response[0]);
                    if (response.result == 'success') {
                        if (response.params.action == 'Add') {
                            this.selectsGroupCompany.companyGroupList.push({ 'id': response.params.id, 'group_name': response.params.group_name });
                            this.$global.selectsGroupCompany.companyGroupList.push({ 'id': response.params.id, 'group_name': response.params.group_name });
                            this.selectsGroupCompany.companyGroupSelected = response.params.id;
                            this.selectsGroupCompany.companyGroupID = response.params.id;
                            this.selectsGroupCompany.newCompanyGroupName = response.params.group_name;

                        } else if (response.params.action == 'Edit') {
                            /** UPDATE */
                            for (let i = 0; i < this.selectsGroupCompany.companyGroupList.length; i++) {
                                if (this.selectsGroupCompany.companyGroupList[i].id == response.params.id) {
                                    this.selectsGroupCompany.newCompanyGroupName = response.params.group_name;
                                    this.selectsGroupCompany.companyGroupList[i].group_name = response.params.group_name;
                                }
                            }

                            for (let i = 0; i < this.$global.selectsGroupCompany.companyGroupList.length; i++) {
                                if (this.$global.selectsGroupCompany.companyGroupList[i].id == response.params.id) {
                                    this.$global.selectsGroupCompany.companyGroupList[i].group_name = response.params.group_name;
                                }
                            }


                            /** UPDATE */
                        }

                        $('#editGroupName' + id).hide();
                        $('#listGroupName' + id).show();

                    }

                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });

                }, error => {

                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    });
                });

            } else {

                this.$store.dispatch('AddEditGroupCompany', {
                    companyGroupID: id.group_company_id,
                    companyGroupName: id.group_name,
                    companyID: this.companyID,
                    moduleID: '3',
                }).then(response => {
                    //console.log(response[0]);
                    if (response.result == 'success') {
                        if (response.params.action == 'Add') {
                            this.selectsGroupCompany.companyGroupList.push({ 'id': response.params.id, 'group_name': response.params.group_name });
                            this.$global.selectsGroupCompany.companyGroupList.push({ 'id': response.params.id, 'group_name': response.params.group_name });
                            id.group_company_id = response.params.id;
                            id.group_name = response.params.group_name;
                            //this.selectsGroupCompany.companyGroupID = response.params.id;
                            //this.selectsGroupCompany.newCompanyGroupName = response.params.group_name;

                        } else if (response.params.action == 'Edit') {
                            /** UPDATE */
                            for (let i = 0; i < this.selectsGroupCompany.companyGroupList.length; i++) {
                                if (this.selectsGroupCompany.companyGroupList[i].id == response.params.id) {
                                    id.group_name = response.params.group_name;
                                    //this.selectsGroupCompany.newCompanyGroupName = response.params.group_name;
                                    this.selectsGroupCompany.companyGroupList[i].group_name = response.params.group_name;
                                }
                            }

                            for (let i = 0; i < this.$global.selectsGroupCompany.companyGroupList.length; i++) {
                                if (this.$global.selectsGroupCompany.companyGroupList[i].id == response.params.id) {
                                    this.$global.selectsGroupCompany.companyGroupList[i].group_name = response.params.group_name;
                                }
                            }


                            /** UPDATE */
                        }

                        id = id.id;
                        $('#editGroupName' + id).hide();
                        $('#listGroupName' + id).show();

                    }

                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });

                }, error => {

                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    });
                });
            }
        },
        cancelAddeditCompanyGroup(id) {
            if (id == '') {
                this.selectsGroupCompany.companyGroupSelected = '';
                this.selectsGroupCompany.companyGroupID = '';
                this.selectsGroupCompany.newCompanyGroupName = ''
            } else {
                id = id.id;
                //console.log('edit : ' + id);
            }
            $('#editGroupName' + id).hide();
            $('#listGroupName' + id).show();
        },
        removeCompanyGroup(act, id) {
            var _companyGroupID;

            if (id == '') {
                _companyGroupID = this.selectsGroupCompany.companyGroupID;
            } else {
                _companyGroupID = id.group_company_id;
            }

            swal.fire({
                title: 'Are you sure want to delete this?',
                text: `You won't be able to revert this!`,
                icon: '',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-default btn-fill',
                    cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Ok',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    /** REMOVE COMPANY GROUP */

                    this.$store.dispatch('RemoveCompanyGroup', {
                        companyID: this.companyID,
                        companyGroupID: _companyGroupID,
                    }).then(response => {

                        this.selectsGroupCompany.companyGroupSelected = '';
                        this.selectsGroupCompany.companyGroupID = '';
                        this.selectsGroupCompany.newCompanyGroupName = '';

                        id.group_company_id = '';
                        id.group_name = '';

                        /** REMOVE THE COMPANY GROUP FROM ARRAY */
                        for (let i = 0; i < this.selectsGroupCompany.companyGroupList.length; i++) {
                            if (this.selectsGroupCompany.companyGroupList[i].id == _companyGroupID) {
                                this.selectsGroupCompany.companyGroupList.splice(i, 1);
                            }
                        }

                        for (let i = 0; i < this.$global.selectsGroupCompany.companyGroupList.length; i++) {
                            if (this.$global.selectsGroupCompany.companyGroupList[i].id == _companyGroupID) {
                                this.$global.selectsGroupCompany.companyGroupList.splice(i, 1);
                            }
                        }
                        /** REMOVE THE COMPANY GROUP FROM ARRAY */
                        swal.fire({
                            title: 'Deleted!',
                            text: `You deleted Company Group`,
                            icon: 'success',
                            confirmButtonClass: 'btn btn-default btn-fill',
                            buttonsStyling: false
                        });
                    }, error => {

                    });

                    /** REMOVE COMPANY GROUP */
                }
            });

        },
        addeditCompanyGroup(act, id) {
            if (id == '') {
                if (act == 'Add') {
                    this.selectsGroupCompany.companyGroupID = '';
                    this.selectsGroupCompany.newCompanyGroupName = '';
                } else if (act == 'Edit') {
                    if (this.selectsGroupCompany.companyGroupID == '') {
                        return;
                    }
                }
            } else {
                if (act == 'Add') {
                    id.group_company_id = '';
                    id.group_name = '';
                } else if (act == 'Edit') {
                    if (id.group_company_id == '') {
                        return;
                    }
                    //id.group_company_id = this.selectsGroupCompany.companyGroupID;
                    //id.group_name = this.selectsGroupCompany.newCompanyGroupName;
                }

                id = id.id;
            }

            $('#listGroupName' + id).hide();
            $('#editGroupName' + id).show();

        },
        sortcolumn: function (a, b) {
            return a.value - b.value;
        },
        sortdate: function (a, b) {
            return new Date(a.last_lead_added) - new Date(b.last_lead_added);
        },
        sortnumber: function (a, b) {
            return a - b;
        },
        process_activepauseclient(index, row, descriptionLogs) {
            const userData = this.$store.getters.userData
            var _status = 'F';

            if (row.disabled == 'F') {
                _status = 'T';
            }

            if (row.disabled == 'F') {
                this.popProcessingTxt = "Please wait, pausing campaign ....";
            }else{
                this.popProcessingTxt = "Please wait, activating campaign ....";
            }

            $('#processingArea').addClass('disabled-area');
            $('#popProcessing').show();

            this.$store.dispatch('activepauseLeadsPeek', {
                companyID: this.companyID,
                leadspeekID: row.id,
                status: _status,
                activeuser: row.active_user,
                userID: row.user_id,
                ip_user: this.$store.getters.userData.ip_login,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                idSys: this.$global.idsys,
            }).then(result => {
                if (typeof (result.result) !== 'undefined' && result.result === 'failedPayment') {
                    $('#processingArea').removeClass('disabled-area');
                    $('#popProcessing').hide();

                    $('#activePause' + index).removeClass('fas fa-pause gray').addClass('fas fa-pause orange nocursor');
                    $('#activePlay' + index).removeClass('fas fa-play green nocursor').addClass('fas fa-play gray');
                    
                    // LOG ACTION
                    // const data = {
                    //     userID: userData.id,
                    //     action: "Campaign failed payment",
                    //     desc: descriptionLogs,
                    //     userIP: this.$store.getters.userData.ip_login,
                    // }
                    // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                    // if(userViewMode){
                    //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                    //     data.userID = userRoot.id;
                    // }
                    // this.userLogSaved({ data });

                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action: "Campaign failed payment",
                        target_id: row.user_id,
                    })
                    // LOG ACTION

                    this.GetClientList();
                    this.$notify({
                        type: 'danger',
                        message: result.msg,
                        icon: 'fas fa-bug'
                    });
                    return false;
                } else if(typeof(result.result) !== 'undefined' && (result.result == 'failed_campaign_already_active' || result.result == 'failed_campaign_already_paused')) {
                    $('#processingArea').removeClass('disabled-area');
                    $('#popProcessing').hide();

                    $('#activePause' + index).removeClass('fas fa-pause gray').addClass('fas fa-pause orange nocursor');
                    $('#activePlay' + index).removeClass('fas fa-play green nocursor').addClass('fas fa-play gray');

                    /* LOG ACTION */
                    const action = (result.result == 'failed_campaign_already_active') ? 'Campaign Is Already Active' : 'Campaign Is Already Pause'
                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action:  action,
                        target_id: row.user_id,
                    })
                    /* LOG ACTION */

                    this.GetClientList();
                    this.$notify({
                        type: 'danger',
                        message: result.msg,
                        icon: 'fas fa-bug'
                    });
                    return false;
                } else {
                       
                    $('#processingArea').removeClass('disabled-area');
                    $('#popProcessing').hide();

                    if (row.disabled == 'F') { // for paused campaign
                        _status = 'T';
                        row.active = 'F'
                        row.disabled = 'T';
                        row.active_users = 'T';
                        $('#activePause' + index).removeClass('fas fa-pause gray').addClass('fas fa-pause orange nocursor');
                        $('#activePlay' + index).removeClass('fas fa-play green nocursor').addClass('fas fa-play gray');
                        this.$notify({
                            type: 'success',
                            message: 'Campaign successfully paused.',
                            icon: 'tim-icons icon-bell-55'
                        });

                        // LOG ACTION
                        // const data = {
                        //     userID: userData.id,
                        //     action: "Campaign pause",
                        //     desc: descriptionLogs,
                        //     userIP: this.$store.getters.userData.ip_login,
                        // }
                        // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                        // if(userViewMode){
                        //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                        //     data.userID = userRoot.id;
                        // }
                        // this.userLogSaved({ data });

                        this.$store.dispatch('onSaveUserLogs', {
                            desc: descriptionLogs,
                            action: "Campaign pause",
                            target_id: row.user_id,
                        })
                        // LOG ACTION
                    }else{ // for play campaign
                        row.active = 'T';
                        row.disabled = 'F';
                        row.active_user = 'T';
                        $('#activePause' + index).removeClass('fas fa-pause orange').addClass('fas fa-pause gray');
                        $('#activePlay' + index).removeClass('fas fa-play gray').addClass('fas fa-play green nocursor');
                        let msg = 'Campaign successfully activated.';
                        if (row.active_user == 'F') {
                            msg = "Initial Campaign Start...";
                        }
                        this.$notify({
                            type: 'success',
                            message: msg,
                            icon: 'tim-icons icon-bell-55'
                        });
                        // LOG ACTION
                        // const data = {
                        //     userID: userData.id,
                        //     action: "Campaign activate",
                        //     desc: descriptionLogs,
                        //     userIP: this.$store.getters.userData.ip_login,
                        // }
                        // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                        // if(userViewMode){
                        //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                        //     data.userID = userRoot.id;
                        // }
                        // this.userLogSaved({ data });

                        this.$store.dispatch('onSaveUserLogs', {
                            desc: descriptionLogs,
                            action: "Campaign activate",
                            target_id: row.user_id,
                        })
                        // LOG ACTION
                    }
                }
            }).catch(error => {
                $('#processingArea').removeClass('disabled-area');
                $('#popProcessing').hide();

                this.$notify({
                    type: 'primary',
                    message: 'sorry this campaign cannot be started, please contact your administrator with campaign ID : #' + row.leadspeek_api_id + ' (1)',
                    icon: 'fas fa-bug'
                });
            });
           
        },
        async activepauseclient(index, row, action) {
            const topUpType = (row.campaign_information_type_local.includes('advanced') || row.campaign_information_type_local.includes('b2b')) ? 'money' : 'contact';

            if(row.paymentterm.toLowerCase() === 'prepaid' && (row.leadsbuy == 0 || row.leadsbuy == null)) {
                swal.fire({
                    icon: "error",
                    text: "You cannot start the campaign until you have set up the campaign financials. Please click the dollar icon to set them ups.",
                }).then((result) => {
                    if(result.isConfirmed) {
                        this.handlePriceSet(index, row); 
                        this.modals.pricesetup = true;
                    }
                })
                return false;
            }

            if ((action == 'pause' && row.disabled == 'T')) {
                return false;
            } else if ((action == 'play' && row.disabled == 'F')) {
                return false;
            } else if (action == 'play' && row.disabled == 'T' && row.active_user == 'F' && (row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F')) {
                return false;
            }

            let descriptionLogs = `campaign id: ${row.leadspeek_api_id} | campaign type: ${row.leadspeek_type} | payment term: ${row.paymentterm.toLowerCase()} `;
            if(row.paymentterm.toLowerCase() == 'prepaid') {
                descriptionLogs += `| top up options : ${row.topupoptions.toLowerCase()} `;
                if(row.topupoptions.toLowerCase() == 'continual') {
                    descriptionLogs += `| continual buy options : ${row.continual_buy_options === true ? 'monthly': 'weekly'} | continual topup is : ${row.stopcontinual === 'T' ? 'disabled' : 'enabled'} `;
                } 
            }

            /* GET COSTAGENCY IF COST_PERLEAD ZERO */
            this.contiDurationSelection = row.continual_buy_options;
            if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                try {
                    const response = await this.$store.dispatch('getGeneralSetting', {
                        companyID: this.companyID,
                        settingname: 'costagency',
                        idSys: this.$global.idsys,
                        pk: row.company_id,
                    });

                    this.campaign_information_type_local_includes_advanced = row.campaign_information_type_local.includes('advanced');
                    this.costagency = response.data

                    if(row.paymentterm.toLowerCase() == 'weekly') {
                        this.m_LeadspeekPlatformFee = this.costagency.local.Weekly.LeadspeekPlatformFee;
                        this.m_LeadspeekMinCostMonth =  this.costagency.local.Weekly.LeadspeekMinCostMonth;
                        
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.m_LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperleadAdvanced;
                        } else {
                            this.m_LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperlead;
                        }
                    } else if(row.paymentterm.toLowerCase() == 'monthly') {
                        this.m_LeadspeekPlatformFee = this.costagency.local.Monthly.LeadspeekPlatformFee;
                        this.m_LeadspeekMinCostMonth =  this.costagency.local.Monthly.LeadspeekMinCostMonth;

                        if(this.campaign_information_type_local_includes_advanced) {
                            this.m_LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperleadAdvanced;
                        } else {
                            this.m_LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperlead;
                        }
                    } else if(row.paymentterm.toLowerCase() == 'one time') {
                        this.m_LeadspeekPlatformFee = this.costagency.local.OneTime.LeadspeekPlatformFee;
                        this.m_LeadspeekMinCostMonth =  this.costagency.local.OneTime.LeadspeekMinCostMonth;
                        
                        if(this.campaign_information_type_local_includes_advanced) {
                            this.m_LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperleadAdvanced;
                        } else {
                            this.m_LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperlead;
                        }
                    } else if(row.paymentterm.toLowerCase() == 'prepaid') {
                        this.m_LeadspeekPlatformFee = this.costagency.local.Prepaid.LeadspeekPlatformFee;
                        this.m_LeadspeekMinCostMonth =  this.costagency.local.Prepaid.LeadspeekMinCostMonth;

                        if(this.campaign_information_type_local_includes_advanced) {
                            this.m_LeadspeekCostperlead = this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced;
                        } else {
                            this.m_LeadspeekCostperlead = this.costagency.local.Prepaid.LeadspeekCostperlead;
                        }
                    }
                } catch (error) {
                    console.error(error);
                    return false;
                }
            }
            /* GET COSTAGENCY IF COST_PERLEAD ZERO */

            if (action == 'play' && row.disabled == 'T' && row.active_user == 'F') {
                // var defaultText = 'Activating this will charge a One Time startup fee of $' + row.platformfee + ' and the ' + row.paymentterm + ' fee of $' + row.lp_min_cost_month + '. This campaign is set up for ' + row.paymentterm.toLowerCase() + ' billing and your client will be billed on the same day each ' + row.paymentterm.toLowerCase() + '.';
                // const userData = this.$store.getters.userData;
                // if (userData.user_type == 'client') {
                //     defaultText = 'Activating this will charge a One Time startup fee of $' + row.platformfee + ' and the ' + row.paymentterm + ' fee of $' + row.lp_min_cost_month + '. This campaign is set up for ' + row.paymentterm.toLowerCase() + ' billing and you will be billed on the same day each ' + row.paymentterm.toLowerCase() + '.';
                // }
                var btnOkName = 'Ok';
                var defaultText = '<p style="text-align: left; color: initial;">Activating this will authorize the following charges:<br>';
                    defaultText += '<ul style="text-align: left;">';
                    defaultText += '<li class="alert-li">A start up fee of $' + this.formatPrice(row.platformfee) + '</li>';
                    
                    // jika prepaid
                    if(row.paymentterm.toLowerCase() === 'prepaid') {
                        defaultText += '<li class="alert-li">  A monthly campaign fee of $' + this.formatPrice(row.lp_min_cost_month) + ' starting one month after today</li>';
                    } else {
                        defaultText += '<li class="alert-li">  A  ' + row.paymentterm.toLowerCase() + ' campaign fee of $' + this.formatPrice(row.lp_min_cost_month) + '</li>';
                    }

                    defaultText += '<li class="alert-li">Up to ';
                        
                    if (row.lp_limit_leads == 0){
                        defaultText += 'Unlimited' + ' contacts per ' + row.lp_limit_freq + ' at a cost of $' + this.formatPrice(row.cost_perlead) + ' each contact </li>';
                    }else{
                        defaultText += `${row.lp_limit_leads} contacts per ${row.lp_limit_freq} at a cost of $`
                        defaultText += this.formatPrice(row.cost_perlead)
                        defaultText += ' each contact </li>';
                    }
                    defaultText += '</ul>';

                    // jika prepaid
                    if(row.paymentterm.toLowerCase() === 'prepaid') {
                        defaultText += 'This campaign is set up for ' + row.paymentterm.toLowerCase() + ' ' + row.topupoptions.toLowerCase() + ' billing';
                        if(row.topupoptions.toLowerCase() == 'continual') {
                            defaultText += ' with continual buy options ' + (row.continual_buy_options === true ? 'monthly' : 'weekly') + ', continual topup is ' + (row.stopcontinual === 'T' ? 'disabled' : 'enabled') + ', ';
                        }    
                        defaultText += ' and will charge ';

                        if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                            defaultText += "immediately. The Client cost is  ";
                        }
                    } else {
                        defaultText += 'This campaign is set up for ' + row.paymentterm.toLowerCase() + ' billing and will be billed on the same day each ' + row.paymentterm.toLowerCase().replace(/ly\b/g,'') + '. ';
                        defaultText += 'If this campaign reaches its ' + row.paymentterm.toLowerCase() + ' contact limit goal, ';    
                    
                        if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                            defaultText += "the Clients cost for contacts will be ";
                        } else {
                            defaultText += 'your total cost for contacts will be ';
                        }
                    }
                    
                    if (row.lp_limit_leads == 0) {
                        defaultText += 'unlimited.<br/>';
                    }else{ 
                        if(row.paymentterm.toLowerCase() === 'prepaid' && row.topupoptions === 'continual') {
                            if(row.lp_limit_freq == 'day') {
                                var platformfee = parseFloat(row.platformfee);
                                var cost_perlead = parseFloat(row.cost_perlead);
                                var lp_limit_leads = parseInt(row.lp_limit_leads);

                                var totalCost = this.contiDurationSelection ? this.formatPrice(platformfee + (((cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(platformfee + ((cost_perlead * lp_limit_leads) * 7));
                                //var totalCost = this.formatPrice(((cost_perlead * lp_limit_leads) * 7) * 4);
                                defaultText += '$' +  totalCost;
    
                                if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                                    var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
                                    var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
                                    var agency_total_cost = this.contiDurationSelection ? this.formatPrice(agency_platformfee + (((agency_cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(agency_platformfee + ((agency_cost_perlead * lp_limit_leads) * 7));
                                    defaultText += ` and your Agency's cost is $${agency_total_cost}.`;
                                }
                            }
                            else {
                                var platformfee = parseFloat(row.platformfee);
                                var cost_perlead = parseFloat(row.cost_perlead);
                                var lp_limit_leads = parseInt(row.lp_limit_leads);
                                var totalCost = this.formatPrice(platformfee + (cost_perlead * lp_limit_leads));
                                
                                defaultText += '$' +  totalCost;
    
                                if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                                    var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
                                    var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
                                    var agency_total_cost = this.formatPrice(agency_platformfee + (agency_cost_perlead * lp_limit_leads));
                                    
                                    defaultText += ` and your Agency's cost is $${agency_total_cost}.`;
                                }
                            }
                        }
                        else if(row.paymentterm.toLowerCase() === 'prepaid' && row.topupoptions === 'onetime') {
                            var platformfee = parseFloat(row.platformfee);
                            var cost_perlead = parseFloat(row.cost_perlead);
                            var leadsbuy = parseInt(row.leadsbuy);

                            var totalCost = this.formatPrice(platformfee + (cost_perlead * leadsbuy));
                            //var totalCost = this.formatPrice(cost_perlead * leadsbuy);
                            defaultText += '$' +  totalCost;

                            if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                                var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
                                var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
                                var agency_total_cost = this.formatPrice(agency_platformfee + (agency_cost_perlead * leadsbuy));
                                
                                defaultText += ` and your Agency's cost is $${agency_total_cost}.`;
                            }
                        }
                        else {
                            var lp_min_cost_month = parseFloat(row.lp_min_cost_month);
                            var cost_perlead = parseFloat(row.cost_perlead);
                            var lp_limit_leads = parseInt(row.lp_limit_leads);
                            
                            if(row.paymentterm.toLowerCase() === 'weekly') {
                                var totalCost = this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7)));
                            } else {
                                var totalCost = this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7 * 4)));
                            }
                            
                            defaultText += '$' +  totalCost;

                            if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                                var agency_min_cost = parseFloat(this.m_LeadspeekMinCostMonth);
                                var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);

                                if(row.paymentterm.toLowerCase() === 'weekly') {
                                    var agency_total_cost = this.formatPrice(agency_min_cost + (((agency_cost_perlead * lp_limit_leads) * 7)));
                                } else {
                                    var agency_total_cost = this.formatPrice(agency_min_cost + (((agency_cost_perlead * lp_limit_leads) * 7 * 4)));
                                }

                                defaultText += ` and your Agency's cost will be $${agency_total_cost}`;
                            }

                            defaultText += '.<br>';
                        }
                    }

                    // jika prepaid
                    if(row.paymentterm.toLowerCase() === 'prepaid') {
                        if (row.topupoptions == 'continual') {
                            if (row.lp_limit_freq == 'day') {
                                if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                                    defaultText += ' It will automatically rebill when the campaign falls to ' + row.lp_limit_leads + ' contacts available.'
                                } else {
                                    defaultText += ' immediately, and again when the campaign falls to ' + row.lp_limit_leads + ' contacts available'
                                }
                            } else if (row.lp_limit_freq == 'month') {
                                if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                                    defaultText += ' An automatic top-up will occur when your pre-purchased contacts reach 0, and at the end of each 28-day billing cycle.'
                                } else {
                                    defaultText += ' immediately, An automatic top-up will occur when your pre-purchased contacts reach 0, and at the end of each 28-day billing cycle.'
                                }
                            }
                        }else if (row.topupoptions == 'onetime') {
                            if(this.$store.getters.userData.user_type == 'client') {
                                defaultText += ' immediately. ';
                            }
                        }
                    }
                    /** IF PREPAID PUT THIS AGREEMENT */
                    if(row.paymentterm.toLowerCase() === 'prepaid') {
                        defaultText += '<br><br>';
                        defaultText += 'I understand that the purchase of prepaid contacts is non-refundable.';
                        btnOkName = 'I agree';
                    }
                    /** IF PREPAID PUT THIS AGREEMENT */
                    defaultText += '<br>';
                    if (row.lp_limit_leads == 0 ) {
                        defaultText += '<span><strong style="color:red">WARNING: </strong>by setting a campaign to Unlimited contacts, the cost for this campaign could be thousands of dollars per day.</span>';
                    }
                    defaultText += '</p>';

                descriptionLogs += `| setup fee: $${this.formatPrice(row.platformfee)} | campaign fee: $${this.formatPrice(row.lp_min_cost_month)} | cost per contact: $${this.formatPrice(row.cost_perlead)} | contact per day: ${row.lp_limit_leads} | client cost: $${totalCost} ${agency_total_cost == undefined ? '' : `| agency cost: $${agency_total_cost}`} | campaign information type local: ${row.campaign_information_type_local.join(',')}`
                swal.fire({
                    title: "Are you sure you want to activate this campaign?",
                    html: defaultText,
                    icon: '',
                    showCancelButton: true,
                    customClass: {
                        confirmButton: 'btn btn-default btn-fill',
                        cancelButton: 'btn btn-danger btn-fill'
                    },
                    confirmButtonText: btnOkName,
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        this.process_activepauseclient(index, row, descriptionLogs);
                    }
                });

            } else {
                if(row.paymentterm.toLowerCase() === 'prepaid' && row.topupoptions === 'continual') {
                    // var platformfee = parseFloat(row.platformfee);
                    // var cost_perlead = parseFloat(row.cost_perlead);
                    // var lp_limit_leads = parseInt(row.lp_limit_leads);
                    // var totalCost = this.contiDurationSelection ? this.formatPrice(platformfee + (((cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(platformfee + ((cost_perlead * lp_limit_leads) * 7));

                    // if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                    //     var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
                    //     var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
                    //     var agency_total_cost = this.contiDurationSelection ? this.formatPrice(agency_platformfee + (((agency_cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(agency_platformfee + ((agency_cost_perlead * lp_limit_leads) * 7));
                    // }

                    if(row.lp_limit_freq == 'day') {
                        var platformfee = parseFloat(row.platformfee);
                        var cost_perlead = parseFloat(row.cost_perlead);
                        var lp_limit_leads = parseInt(row.lp_limit_leads);
                        var totalCost = this.contiDurationSelection ? this.formatPrice(platformfee + (((cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(platformfee + ((cost_perlead * lp_limit_leads) * 7));
                        //var totalCost = this.formatPrice(((cost_perlead * lp_limit_leads) * 7) * 4);

                        if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                            var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
                            var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
                            var agency_total_cost = this.contiDurationSelection ? this.formatPrice(agency_platformfee + (((agency_cost_perlead * lp_limit_leads) * 7) * 4)) : this.formatPrice(agency_platformfee + ((agency_cost_perlead * lp_limit_leads) * 7));
                        }
                    }
                    else {
                        var platformfee = parseFloat(row.platformfee);
                        var cost_perlead = parseFloat(row.cost_perlead);
                        var lp_limit_leads = parseInt(row.lp_limit_leads);
                        var totalCost = this.formatPrice(platformfee + (cost_perlead * lp_limit_leads));

                        if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                            var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
                            var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
                            var agency_total_cost = this.formatPrice(agency_platformfee + (agency_cost_perlead * lp_limit_leads));
                        }
                    }
                }
                else if(row.paymentterm.toLowerCase() === 'prepaid' && row.topupoptions === 'onetime') {
                    var platformfee = parseFloat(row.platformfee);
                    var cost_perlead = parseFloat(row.cost_perlead);
                    var leadsbuy = parseInt(row.leadsbuy);
                    var totalCost = this.formatPrice(platformfee + (cost_perlead * leadsbuy));

                    if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                        var agency_platformfee = parseFloat(this.m_LeadspeekPlatformFee);
                        var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
                        var agency_total_cost = this.formatPrice(agency_platformfee + (agency_cost_perlead * leadsbuy));
                    }
                }
                else {
                    var lp_min_cost_month = parseFloat(row.lp_min_cost_month);
                    var cost_perlead = parseFloat(row.cost_perlead);
                    var lp_limit_leads = parseInt(row.lp_limit_leads);
                    var totalCost = (row.paymentterm.toLowerCase() === 'weekly') ? this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7))) : this.formatPrice(lp_min_cost_month + (((cost_perlead * lp_limit_leads) * 7 * 4)));

                    if(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') {
                        var agency_min_cost = parseFloat(this.m_LeadspeekMinCostMonth);
                        var agency_cost_perlead = parseFloat(this.m_LeadspeekCostperlead);
                        var agency_total_cost = (row.paymentterm.toLowerCase() === 'weekly') ? this.formatPrice(agency_min_cost + (((agency_cost_perlead * lp_limit_leads) * 7))) : this.formatPrice(agency_min_cost + (((agency_cost_perlead * lp_limit_leads) * 7 * 4)));
                    }
                }

                descriptionLogs += `| setup fee: $${this.formatPrice(row.platformfee)} | campaign fee: $${this.formatPrice(row.lp_min_cost_month)} | cost per contact: $${this.formatPrice(row.cost_perlead)} | contact per day: ${row.lp_limit_leads} | client cost: $${totalCost} ${agency_total_cost == undefined ? '' : `| agency cost: $${agency_total_cost}`} | campaign information type local: ${row.campaign_information_type_local.join(',')}`;
                this.process_activepauseclient(index, row, descriptionLogs);
            }
        },
        setIconReportType(row) {
            if (row.report_type == "CSV") {
                return '<i class="fas fa-file-csv" style="color:white;padding-right:10px"></i> CSV File';
            } else if (row.report_type == "Excel") {
                return '<i class="far fa-file-excel" style="color:white;padding-right:10px"></i> Microsoft Excel File';
            } else if (row.report_type == "GoogleSheet") {
                return '<i class="fab fa-google-drive" style="color:white;padding-right:10px"></i> <a style="color:white" href="https://docs.google.com/spreadsheets/d/' + row.spreadsheet_id + '/edit#gid=0" target="_blank">Google Spreadsheet</a>';
            }
        },
        disconnect_googleSpreadSheet() {
            this.$store.dispatch('disconectGoogleSheet', {
                companyID: this.companyID,
            }).then(response => {
                //console.log(response.googleSpreadsheetConnected);
                this.GoogleConnectTrue = false;
                this.GoogleConnectFalse = true;
            }, error => {

            });
        },
        connect_googleSpreadSheet() {
            window.removeEventListener('message', this.callbackGoogleConnected);
            window.addEventListener('message', this.callbackGoogleConnected);

            var left = (screen.width / 2) - (1024 / 2);
            var top = (screen.height / 2) - (800 / 2);
            var fbwindow = window.open(process.env.VUE_APP_DATASERVER_URL + '/auth/google-spreadSheet/' + this.companyID, 'Google SpreadSheet Auth', "menubar=no,toolbar=no,status=no,width=640,height=800,toolbar=no,location=no,modal=1,left=" + left + ",top=" + top);
        },
        onCompanyChange(_companySelected) {
            this.selectsCompany.companyId = _companySelected;

            for (let i = 0; i < this.selectsCompany.companyList.length; i++) {
                if (this.selectsCompany.companyList[i].id == _companySelected) {
                    this.ClientFullName = this.selectsCompany.companyList[i].name;
                    this.ClientEmail = this.selectsCompany.companyList[i].email;
                    this.ClientPhone = this.selectsCompany.companyList[i].phonenum;
                    this.ClientUserID = this.selectsCompany.companyList[i].id;
                    this.ClientCompanyName = this.selectsCompany.companyList[i].company_name;
                    this.selectsCompany.companySelected = this.selectsCompany.companyList[i].company_name;
                    this.ClientReportSentTo = this.selectsCompany.companyList[i].email;

                    var enabled_phone_number;
                    if (this.selectsCompany.companyList[i].enabled_phone_number == 'T') {
                        enabled_phone_number = true;
                    } else {
                        enabled_phone_number = false;
                    }
                    this.checkboxes.phoneenabled = enabled_phone_number;
                }
            }
            for(let i=0;i<this.$global.selectsGroupCompany.companyGroupList.length;i++) {
                if (this.$global.selectsGroupCompany.companyGroupList[i].id == _companySelected) {
                    this.LeadspeekMinimumLeadsPerDayAdd = this.$global.selectsGroupCompany.companyGroupList[i].LeadspeekLeadsPerday;
                    if(this.LeadspeekMinimumLeadsPerDayAdd < 1) {
                        this.LeadspeekMinimumLeadsPerDayAdd = 1;
                    }
                    
                    this.LeadspeekEnableMinimumLeadsPerDayAdd = this.$global.selectsGroupCompany.companyGroupList[i].LeadspeekEnableMinimumLeadsPerday;
                }
            }
        },
        async rowClicked(index, row) {
            try {
                const response = await this.$store.dispatch('getCurrentTopupPrepaid', {
                    leadspeek_api_id: row.leadspeek_api_id,
                });
                this.current_topup = response.current_topup;
            } catch (error) {
                console.log(error);
                return false;
            }
            
            this.formUrlCodes = [""];

            // Cek apakah row.url ada dan tidak kosong
            if (row.url_code && row.url_code !== "") {
                this.formUrlCodes = row.url_code.split('|'); // Ubah string jadi array
            }
            
            this.modals.campaignEdit = !this.modals.campaignEdit
            this.selectedRowData = row
            
            this.rowCheckboxes.homeaddressenabled = false;
            this.rowCheckboxes.phoneenabled = false;
            this.rowCheckboxes.require_email = false;
            this.rowCheckboxes.applyreidentificationall = false;
            this.rowCheckboxes.gtm = false;

            if(
                (row.paymentterm != 'Prepaid') &&
                (
                    (row.active == 'T' && row.disabled == 'F' && row.active_user == 'T') || // play
                    (row.active == 'F' && row.disabled == 'T' && row.active_user == 'T') || // pause
                    (row.active == 'F' && row.disabled == 'F' && row.active_user == 'T')    // paused on run
                )
            ) {
                this.cardAdvanceInformationReadOnly = true;
            } else {
                this.cardAdvanceInformationReadOnly = false;
            }

            if (row.homeaddressenabled == 'T') {
                this.rowCheckboxes.homeaddressenabled = true;
            }

            if (row.phoneenabled == 'T') {
                this.rowCheckboxes.phoneenabled = true;
            }

            if (row.require_email == 'T') {
                this.rowCheckboxes.require_email = true;
            }

            if (row.applyreidentificationall == 'T') {
                this.rowCheckboxes.applyreidentificationall = true;
            }

            if (row.gtminstalled == 'T') {
                this.rowCheckboxes.gtm = true;
            }

            this.onCheckItemBasicInformation('edit')
            this.rowIdAdvancedInformation = this.selectedRowData.advance_information;
            this.onRowCheckItemAdvancedInformation();
            this.rowIdAdvancedInformationB2b = this.selectedRowData.b2b_information;
            this.onRowCheckItemAdvancedInformationB2b();

            // this.includeExclude = (row.leadspeek_locator_state_type == 'include') ? '1' : '0';
            this.includeExclude = '0';
            this.selects.state = [];
            this.stateExclude = [];
            this.stateInclude = [];

            if((row.leadspeek_locator_state_exclude != null && row.leadspeek_locator_state_exclude != '')) {
                this.includeExclude = '0';
                this.stateExclude = row.leadspeek_locator_state_exclude.split(',');
                this.selects.state = this.stateExclude;
            }
            else if(row.leadspeek_locator_state != null && row.leadspeek_locator_state != '') {
                this.includeExclude = '1';
                this.stateInclude = row.leadspeek_locator_state.split(',');
                this.selects.state = this.stateInclude;
            } else {
                this.includeExclude = (row.leadspeek_locator_state_type == 'include') ? '1' : '0';
            }
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            return 'clickable-rows ClientRow' + rowIndex;
        },
        ClearClientForm() {
            this.ClientCompanyName = '';
            // this.ClientFullName = '';
            // this.ClientEmail = '';
            // this.ClientPhone = '';
            // this.ClientUserID = '';
            // this.ClientReportSentTo = '';
            this.ClientPerLead = '100';
            this.radios.reportType = 'GoogleSheet';
            this.selectsAdministrator.administratorSelected = [];
            this.ClientCampaignName = '';
            this.ClientUrlCode = '';
            this.ClientUrlCodeThankyou = '';
            let _tmpdefaultadmin = Array();
            $.each(this.tmpdefaultadmin, function (key, value) {
                if (value['defaultadmin'] == 'T') {
                    _tmpdefaultadmin.push(value['id']);
                }
            });

            this.selectsAdministrator.administratorSelected = _tmpdefaultadmin;
            // if ((localStorage.getItem('companyGroupSelected') == null || localStorage.getItem('companyGroupSelected') == '')) {
            //     this.selectsCompany.companySelected = '';
            // }
            this.checkAllBasic = false;
            this.checkboxes.phoneenabled = false;
            this.checkboxes.homeaddressenabled = true;
            this.checkboxes.requireemailaddress = true;
            this.checkboxes.ApplyReidentificationToAll = false;

            this.includeExclude = '0';
            this.selects.state = [];
            this.stateExclude = [];
            this.stateInclude = [];
        },
        ClearClientFormEdit(id) {
            if (id.homeaddressenabled) {
                id.homeaddressenabled = 'T';
            } else {
                id.homeaddressenabled = 'F';
            }

            if (id.phoneenabled) {
                id.phoneenabled = 'T';
            } else {
                id.phoneenabled = 'F';
            }

            if (id.applyreidentificationall) {
                id.applyreidentificationall = 'T';
            } else {
                id.applyreidentificationall = 'F';
            }

            if (id.require_email) {
                id.require_email = 'T';
            } else {
                id.require_email = 'F';
            }

            this.includeExclude = '0';
            this.selects.state = [];
            this.stateExclude = [];
            this.stateInclude = [];
        },
        AddEditClient(id) {
            const companyGroupSelected = localStorage.getItem('companyGroupSelected');
            if(companyGroupSelected != null && companyGroupSelected != '') {
                this.onCompanyChange(companyGroupSelected)
            } else if(this.selectsCompany.companyId != '') {
                this.onCompanyChange(this.selectsCompany.companyId)
            }

            this.formUrlCodes = [""];
            this.modals.campaign = !this.modals.campaign 
            // $('#showAddEditClient' + id).collapse('show');
        },
        CancelAddEditClient(id) {
            if (id == '') {
                this.ClearClientForm();
                this.modals.campaign = false
            } else {
                this.ClearClientFormEdit(id);
              
                this.modals.campaignEdit = false
            }

        },
        ResendLink(id) {
            if (id.id != '') {
                $('#btnResend' + id.id).attr('disabled', true);
                $('#btnResend' + id.id).html('Sending...');

                /** RESEND THE INVITATION */
                this.$store.dispatch('ResendGoogleLink', {
                    companyID: this.companyID,
                    userID: id.company_id,
                    leadspeekID: id.id,
                    reportSentTo: id.report_sent_to,
                    adminNotifyTo: id.admin_notify_to,
                }).then(response => {
                    //console.log(response[0]);
                    this.modals.campaignEdit = false
                    // this.$refs.tableData.toggleRowExpansion(id);
                    $('#btnResend' + id.id).attr('disabled', false);
                    $('#btnResend' + id.id).html('Resend Google Sheet Link');

                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });

                }, error => {
                    $('#btnResend' + id.id).attr('disabled', false);
                    $('#btnResend' + id.id).html('Resend Google Sheet Link');

                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    });
                });
                /** RESEND THE INVITATION */
            }
        },
        getMainDomain(url) {
            try {
                // Tambahkan protokol jika tidak ada agar bisa di-parse
                const formattedUrl = url.startsWith("http") ? url : `https://${url}`;
                const hostname = new URL(formattedUrl).hostname;
                return hostname.replace(/^www\./, ""); // Hanya hostname utama
            } catch (e) {
                return url.replace(/^www\./, ""); // Jika parsing gagal, gunakan string asli
            }
        },
        isValidUrlFlexible(value) {
            if (typeof value !== 'string') {
                return false;
            }

            const trimmed = value.trim();
            if (!trimmed) {
                return false;
            }

            // Tolak jika mengandung whitespace (spasi, tab, newline, dll)
            // karena browser bisa auto-encode jadi %20 tapi Node bisa error
            if (/\s/.test(trimmed)) {
                return false;
            }

            // Deteksi apakah sudah ada protokol (http://, https://, dll)
            const hasProtocol = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(trimmed);
            // Jika tidak ada, tambahkan https:// supaya bisa diparse oleh new URL()
            const candidate = hasProtocol ? trimmed : `https://${trimmed}`;

            try {
                // console.log(`candidate = ${candidate}`)
                const url = new URL(candidate);
                // Tolak jika hostname berisi karakter aneh seperti %, _
                if (!/^[a-zA-Z0-9.-]+$/.test(url.hostname)) {
                    // console.log("invalid hostname characters → invalid");
                    return false;
                }
                const hostParts = url.hostname.split('.');
                // console.log(`candidate success`, url)
                return hostParts.length >= 2 && hostParts.every(Boolean);
            } catch {
                // console.log(`candidate error`)
                return false;
            }
        },
        validateURL(index) {
            // const regex = /^(https?:\/\/)([\w.-]+)\.([a-z]{2,})([\/\w .-]*)*\/?$/i;
            // const regex = /^(https?:\/\/)[\w.-]+\.[a-z]{2,}([\/\w.-]*)*\/?$/i;
            // return regex.test(url);
            if (!this.errors) this.errors = {}; 

            const url = this.formUrlCodes[index].trim();
            // const regex = /^(https?:\/\/)[\w.-]+\.[a-z]{2,}([\/\w.-]*)*\/?$/i;
            // const regex = /^[\w.-]+\.[a-z]{2,}(\/[\w.-]*)*\/?$/i;
            // const regex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}([\/\w.-]*)*\/?$/i;
            // const regex = /^(https?:\/\/)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}([\/\w.-]*)*\/?$/i;

            if (!url) {
                this.$set(this.errors, index, "URL cannot be empty.!");
            } 
            // else if (!regex.test(url)) {
            else if (!this.isValidUrlFlexible(url)) {
                this.$set(this.errors, index, "URL not valid!");
                // this.$set(this.errors, index, "URL harus valid!");
            } 
            // else if (this.formUrlCodes.filter((item, i) => i !== index && item === url).length > 0) {
            //     this.$set(this.errors, index, "This URL is already added!");
            // } 
            else {
                // **Ekstrak hostname utama dari URL**
                const mainUrl = this.getMainDomain(url);

                // **Cek apakah main URL sudah ada di list sebelumnya**
                const isDuplicate = this.formUrlCodes.some((item, i) => 
                    i !== index && this.getMainDomain(item) === mainUrl
                );

                if (isDuplicate) {
                    this.$set(this.errors, index, "This URL is already added (same main domain).");
                } else {
                    this.$delete(this.errors, index); // Pastikan error dihapus jika valid
                }

                // this.$delete(this.errors, index); // Pastikan error dihapus jika valid
            }
        },
        async ProcessAddEditClient(id) {
            var url_lengkap;
            if (id == '') {
                /** PROCESS ADD / EDIT ORGANIZATION */
                if (id == '') {
                    var _formpass = true;
                    let saveConfPhoneNumber = this.checkboxes.phoneenabled;

                    // if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '')) {
                        // this.selectsGroupCompany.companyGroupID = localStorage.getItem('companyGroupSelected');
                    // } else {
                        this.selectsGroupCompany.companyGroupID = this.ClientUserID;
                    // }
                    //HIDE PHONE WILL BE DEFAULT WHEN ADD CLIENT
                    var hidePhone = 'T';
                    var gtminstalled = 'F';
                    if (this.checkboxes.hide_phone) {
                        hidePhone = 'T';
                    }

                    if (this.checkboxes.gtm) {
                        gtminstalled = 'T';
                    }

                    if (this.ClientCampaignName == "") {
                        _formpass = false;
                        $('#err_campaignname').show();
                    } else {
                        $('#err_campaignname').hide();
                    }

                    if (this.selectsCompany.companySelected == '') {
                        _formpass = false;
                        this.err_companyselect = true;
                    } else {
                        this.err_companyselect = false;
                    }

                    if (_formpass == false) {
                        this.$notify({
                            type: 'primary',
                            message: 'Please check the required fields.',
                            icon: 'fas fa-bug'
                        });
                        return false;
                    }

                    const regex = /^\s*$/;
                    if (regex.test(this.ClientCampaignName)) {
                        this.$notify({
                            type: 'danger',
                            message: 'Campaign Name invalid',
                            icon: 'fas fa-exclamation'
                        });
                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save'); 
                        return; 
                    }

                    // if (regex.test(this.ClientUrlCode)) {
                    //     this.$notify({
                    //         type: 'danger',
                    //         message: 'Invalid URL',
                    //         icon: 'fas fa-exclamation'
                    //     });
                    //     $('#btnSave' + id).attr('disabled',false);
                    //     $('#btnSave' + id).html('Save'); 
                    //     return; 
                    // }

                    if (this.formUrlCodes[0] === "") {
                        this.$notify({
                            type: 'danger',
                            message: 'Please provide at least one URL code.',
                            icon: 'fas fa-exclamation'
                        });
                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save'); 
                        return; 
                    }

                    // // const rgx = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}([\/\w.-]*)*\/?$/i;
                    // const rgx = /^[\w.-]+\.[a-z]{2,}([\/\w.-]*)*\/?$/i;
                    // // if (!rgx.test(this.ClientCampaignName)) {
                    //     console.log(rgx.test(this.ClientCampaignName));
                        
                    // // }


                    this.errors = {}; 
                    this.formUrlCodes.forEach((url, index) => this.validateURL(index));
                    if (Object.keys(this.errors).length > 0) {
                        // Ambil index error terkecil
                        const errorIndex = Math.min(...Object.keys(this.errors).map(Number));

                        this.$notify({
                            type: 'danger',
                            // message: 'Please check your input URL Code.',
                            message: this.errors[errorIndex],
                            icon: 'fas fa-exclamation'
                        });
                        // console.log(errors[index]);
                        
                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save'); 
                        return; 
                    }

                    if(this.formUrlCodes[0] && this.formUrlCodes[0] != '')
                        url_lengkap = this.formUrlCodes[0];
                    if(this.formUrlCodes[1] && this.formUrlCodes[1] != '')
                        url_lengkap = url_lengkap + '|' + this.formUrlCodes[1];
                    if(this.formUrlCodes[2] && this.formUrlCodes[2] != '')
                        url_lengkap = url_lengkap + '|' + this.formUrlCodes[2];
                    if(this.formUrlCodes[3] && this.formUrlCodes[3] != '')
                        url_lengkap = url_lengkap + '|' + this.formUrlCodes[3];
                    if(this.formUrlCodes[4] && this.formUrlCodes[4] != '')
                        url_lengkap = url_lengkap + '|' + this.formUrlCodes[4];

                    // console.log('aaaaaa : '+url_lengkap);

                    // answer for state
                    const answers = {
                        includeExclude: this.includeExclude,
                        state: this.selects.state
                    };
                    // answer for state

                    //// checking enable phone number??
                    if (!saveConfPhoneNumber) {
                        saveConfPhoneNumber = await this.openSaveConfirmationModal('add');
                    }

                    this.onValidateInformationData();

                    this.popProcessingTxt = "Please wait, adding new campaign ....";
                    $('#processingArea').addClass('disabled-area');
                    $('#popProcessing').show();

                    $('#btnSave' + id).attr('disabled', true);
                    $('#btnSave' + id).html('Processing...');
                    /** CREATE CLIENT */
                    this.$store.dispatch('CreateLeadsPeekClient', {
                        companyID: this.companyID,
                        userID: this.ClientUserID,
                        companyName: this.ClientCompanyName,
                        reportType: this.radios.reportType,
                        reportSentTo: this.ClientReportSentTo,
                        adminNotifyTo: this.selectsAdministrator.administratorSelected,
                        leadsAmountNotification: this.ClientPerLead,
                        enableMinimumLimitLeads: this.LeadspeekEnableMinimumLeadsPerDayAdd,
                        minimumLimitLeads: this.LeadspeekMinimumLeadsPerDayAdd,
                        leadspeekType: 'local',
                        companyGroupID: this.selectsGroupCompany.companyGroupID,
                        clientHidePhone: hidePhone,
                        campaignName: this.ClientCampaignName,
                        // urlCode: this.ClientUrlCode,
                        urlCode: url_lengkap,
                        urlCodeThankyou: this.ClientUrlCodeThankyou,
                        gtminstalled: gtminstalled,
                        // phoneenabled: this.checkboxes.phoneenabled,
                        phoneenabled: saveConfPhoneNumber,
                        homeaddressenabled: this.checkboxes.homeaddressenabled,
                        requireemailaddress: this.checkboxes.requireemailaddress,
                        reidentificationtype: this.Reidentificationtime,
                        applyreidentificationall: this.checkboxes.ApplyReidentificationToAll,
                        locationtarget: 'Focus',
                        answers: answers,
                        globalviewmode: this.$global.globalviewmode,
                        listAdvanceInformationId: this.idAdvancedInformation,
                        listB2BInformationId: this.idAdvancedInformationB2b,
                        idSys: this.$global.idsys,
                        campaignInformationTypeLocal: this.campaignInformationData,
                    }).then(response => {
                        //console.log(response);
                        //console.log(response[0]);
                        if (typeof (response.result) != 'undefined' && response.result == 'failed') {
                            $('#processingArea').removeClass('disabled-area');
                            $('#popProcessing').hide();
                            this.modals.campaign = false
                            $('#btnSave' + id).attr('disabled', false);
                            $('#btnSave' + id).html('Save');

                            this.$notify({
                                type: 'primary',
                                message: response.message,
                                icon: 'fas fa-bug'
                            });
                            return;
                        } else {
                            response = this.AttachedAdminNotify(response);
                            this.tableData.push(response[(response.length - 1)]);
                            this.modals.campaign = false
                            this.initialSearchFuse();
                            this.ClearClientForm();
                            $('#showAddEditClient' + id).collapse('hide');
                            $('#processingArea').removeClass('disabled-area');
                            $('#popProcessing').hide();
                            
                            $('#btnSave' + id).attr('disabled', false);
                            $('#btnSave' + id).html('Save');
                            
                            this.$notify({
                                type: 'success',
                                message: 'Data has been added successfully',
                                icon: 'far fa-save'
                            });
                            
                            this.GetClientList(this.currSortBy,this.currOrderBy)
                        }
                    }, error => {
                        $('#processingArea').removeClass('disabled-area');
                        $('#popProcessing').hide();

                        $('#btnSave' + id).attr('disabled', false);
                        $('#btnSave' + id).html('Save');

                        this.$notify({
                            type: 'primary',
                            message: 'Server might be busy please try again later',
                            icon: 'fas fa-bug'
                        });
                    });
                    /** CREATE CLIENT */
                }
                /** PROCESS ADD / EDIT ORGANIZATION */
            } else {

                if ((id.report_type != '' && id.email != '') && (typeof id.report_type != 'undefined' && typeof id.email != 'undefined')) {
                    var _formpass = true;
                    var saveConfPhoneNumber = this.rowCheckboxes.phoneenabled;

                    this.userIdCampaign = id.user_id;

                    if (id.campaign_name == "") {
                        _formpass = false;
                        $('#err_campaignname' + id.id).show();
                    } else {
                        $('#err_campaignname' + id.id).hide();
                    }

                    if (_formpass == false) {
                        this.$notify({
                            type: 'primary',
                            message: 'Please check the required fields.',
                            icon: 'fas fa-bug'
                        });
                        return false;
                    }

                    const regex = /^\s*$/;
                    if (regex.test(id.campaign_name)) {
                        this.$notify({
                            type: 'danger',
                            message: 'Campaign Name invalid',
                            icon: 'fas fa-exclamation'
                        });
                        $('#btnSave' + id.id).attr('disabled',false);
                        $('#btnSave' + id.id).html('Save'); 
                        return; 
                    }

                    // if (regex.test(id.url_code)) {
                    //     this.$notify({
                    //         type: 'danger',
                    //         message: 'Invalid URL',
                    //         icon: 'fas fa-exclamation'
                    //     });
                    //     $('#btnSave' + id.id).attr('disabled',false);
                    //     $('#btnSave' + id.id).html('Save'); 
                    //     return; 
                    // }

                    if (this.formUrlCodes[0] === "") {
                        this.$notify({
                            type: 'danger',
                            message: 'Please provide at least one URL code.',
                            icon: 'fas fa-exclamation'
                        });
                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save'); 
                        return; 
                    }

                    this.errors = {}; 
                    this.formUrlCodes.forEach((url, index) => this.validateURL(index));
                    // console.log('errrrooooorrr : ', this.errors);
                    if (Object.keys(this.errors).length > 0) {
                        // Ambil index error terkecil
                        const errorIndex = Math.min(...Object.keys(this.errors).map(Number)); 

                        this.$notify({
                            type: 'danger',
                            // message: 'Please check your input URL Code.',
                            message: this.errors[errorIndex],
                            icon: 'fas fa-exclamation'
                        });
                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save'); 
                        return; 
                    }
                    
                    if(this.formUrlCodes[0] && this.formUrlCodes[0] != '')
                        url_lengkap = this.formUrlCodes[0];
                    if(this.formUrlCodes[1] && this.formUrlCodes[1] != '')
                        url_lengkap = url_lengkap + '|' + this.formUrlCodes[1];
                    if(this.formUrlCodes[2] && this.formUrlCodes[2] != '')
                        url_lengkap = url_lengkap + '|' + this.formUrlCodes[2];
                    if(this.formUrlCodes[3] && this.formUrlCodes[3] != '')
                        url_lengkap = url_lengkap + '|' + this.formUrlCodes[3];
                    if(this.formUrlCodes[4] && this.formUrlCodes[4] != '')
                        url_lengkap = url_lengkap + '|' + this.formUrlCodes[4];

                    // console.log('aaaaaa : '+url_lengkap);

                    // answer for state
                    const answers = {
                        includeExclude: this.includeExclude,
                        state: this.selects.state
                    };
                    // answer for state

                    //// checking enable phone number??
                    if (!saveConfPhoneNumber) {
                        saveConfPhoneNumber = await this.openSaveConfirmationModal(id.id);
                    }

                    this.onRowValidateInformationData();

                    this.popProcessingTxt = "Please wait, updating campaign ....";
                    $('#processingArea').addClass('disabled-area');
                    $('#popProcessing').show();

                    $('#btnSave' + id.id).attr('disabled', true);
                    $('#btnSave' + id.id).html('Processing...');
                    /** UPDATE CLIENT */
                    this.$store.dispatch('UpdateLeadsPeekClient', {
                        companyID: this.companyID,
                        userID: id.company_id,
                        leadspeekID: id.id,
                        reportType: id.report_type,
                        reportSentTo: id.report_sent_to,
                        adminNotifyTo: id.admin_notify_to,
                        leadsAmountNotification: id.leads_amount_notification,
                        leadspeekType: id.leadspeek_type,
                        companyGroupID: id.group_company_id,
                        clientHidePhone: id.hide_phone,
                        campaignName: id.campaign_name,
                        // urlCode: id.url_code,
                        urlCode: url_lengkap,
                        urlCodeThankyou: id.url_code_thankyou,
                        gtminstalled: this.rowCheckboxes.gtm,

                        // phoneenabled: this.rowCheckboxes.phoneenabled,
                        phoneenabled: saveConfPhoneNumber,
                        homeaddressenabled: this.rowCheckboxes.homeaddressenabled,
                        requireemailaddress: this.rowCheckboxes.require_email,
                        reidentificationtype: id.reidentification_type,
                        applyreidentificationall: this.rowCheckboxes.applyreidentificationall,
                        answers: answers,
                        globalviewmode: this.$global.globalviewmode,
                        listAdvanceInformationId: this.rowIdAdvancedInformation,
                        listB2BInformationId: this.rowIdAdvancedInformationB2b,
                        campaignInformationTypeLocal: this.selectedRowData.campaign_information_type_local,
                    }).then(response => {
                        //console.log(response[0]);
                        $('#processingArea').removeClass('disabled-area');
                        $('#popProcessing').hide();
                        this.modals.campaignEdit = false

                        $('#btnSave' + id.id).attr('disabled', false);
                        $('#btnSave' + id.id).html('Save');

                        this.$notify({
                            type: 'success',
                            message: 'Data has been updated successfully',
                            icon: 'far fa-save'
                        });

                        this.ClearClientFormEdit(id);

                        if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '') && localStorage.getItem('companyGroupSelected') != id.group_company_id) {
                            this.deleteRow(id);
                        }

                        if (id.leadspeek_type != 'local') {
                            this.deleteRow(id);
                        }

                        this.GetClientList(this.currSortBy,this.currOrderBy)
                    }, error => {
                        $('#processingArea').removeClass('disabled-area');
                        $('#popProcessing').hide();

                        $('#btnSave' + id.id).attr('disabled', false);
                        $('#btnSave' + id.id).html('Save');

                        this.$notify({
                            type: 'primary',
                            message: 'Server might be busy please try again later',
                            icon: 'fas fa-bug'
                        });
                    });
                    /** UPDATE CLIENT */
                }
            }
        },
        checkGoogleConnect() {
            this.$store.dispatch('checkGoogleConnectSheet', {
                companyID: this.companyID,
            }).then(response => {
                //console.log(response.googleSpreadsheetConnected);
                if (response.googleSpreadsheetConnected) {
                    this.GoogleConnectTrue = true;
                    this.GoogleConnectFalse = false;
                } else {
                    this.GoogleConnectTrue = false;
                    this.GoogleConnectFalse = true;
                }
            }, error => {

            });
        },
        AttachedAdminNotify(response) {
            /** SET ADMIN NOTIFY */
            for (let i = 0; i < response.length; i++) {
                let tmp = response[i]['admin_notify_to'];
                let tmpArray = [];

                if (typeof tmp === 'string' && tmp.trim() !== '') {
                    // Split hanya angka valid
                    tmpArray = tmp
                        .split(',')
                        .map(item => parseInt(item))
                        .filter(num => !isNaN(num)); // buang NaN
                }

                response[i]['admin_notify_to'] = tmpArray;
            }
            return response;
            /** SET ADMIN NOTIFY */
        },
        GetAdministratorList() {
            this.$store.dispatch('GetClientList', {
                companyID: this.companyID,
                idsys: this.$global.idsys,
                userType: 'user',
            }).then(response => {
                let _tmpdefaultadmin = Array();
                $.each(response, function (key, value) {
                    if (value['defaultadmin'] == 'T') {
                        _tmpdefaultadmin.push(value['id']);
                    }
                });
                this.tmpdefaultadmin = response;
                this.selectsAdministrator.administratorSelected = _tmpdefaultadmin;
                this.selectsAdministrator.administratorList = response;
            }, error => {

            });
        },
        GetCompanyList() {
            this.fetchingCampaignData = true;
            $('.el-select-dropdown__empty').html('Loading data...');
            var _groupCompanyID = '';

            if (this.userType == 'client') {
                const userData = this.$store.getters.userData;
                _groupCompanyID = userData.id;
            }
           
            /** GET CLIENT LIST */
            this.$store.dispatch('GetClientList', {
                companyID: this.companyID,
                idsys: this.$global.idsys,
                userType: 'client',
                userModule: 'LeadsPeek',
                groupCompanyID: _groupCompanyID,
            }).then(response => {
                //console.log(response);
                if (response.length == 0) {
                    $('.el-select-dropdown__empty').html('No new client');
                }
                this.selectsCompany.companyList = response
                if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '')) {
                    this.onCompanyChange(localStorage.getItem('companyGroupSelected'));
                    this.CompanyNamedisabled = true;
                }
                // this.fetchingCampaignData = false
            }, error => {
                this.fetchingCampaignData = false
            });
            /** GET CLIENT LIST */
        },
        sortdynamic(column, order, prop) {
        
            this.currSortBy = column;
            this.currOrderBy = order;
            this.GetClientList(column, order);
        },
        GetClientList(sortby, order,searchkey) {
            this.fetchingCampaignData = true;
            var _sortby = '';
            var _order = '';
            var _searchkey = '';

            if (typeof (sortby) != 'undefined') {
                _sortby = sortby;
            }
            if (typeof (order) != 'undefined') {
                _order = order;
            }

            if (this.searchQuery != '') {
                _searchkey = this.searchQuery;
              
            }


            var _groupCompanyID = '';
            if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '')) {
                _groupCompanyID = localStorage.getItem('companyGroupSelected');
            }

            /** GET CLIENT LIST */
            // this.tableData = [];
            $('.el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');
            this.$store.dispatch('GetLeadsPeekClientList', {
                companyID: this.companyID,
                leadspeekType: 'local',
                groupCompanyID: _groupCompanyID,
                sortby: _sortby,
                order: _order,
                searchkey: _searchkey,
                page:this.pagination.currentPage,
                view: 'campaign',
                campaignStatus: this.filterCampaignStatus,
            }).then(response => {
                if (response.data.length === 0 && this.pagination.currentPage !== 1) {
                      this.pagination.currentPage = 1;
                      this.GetClientList(sortby, order, searchkey);
                      return;
                }
                //console.log(response)
                //console.log(response.length);
                this.pagination.currentPage = response.current_page? response.current_page : 1
                this.pagination.total = response.total ?response.total : 0
                this.pagination.lastPage = response.last_page ? response.last_page : 2
                this.pagination.from = response.from ? response.from : 0
                this.pagination.to = response.to ? response.to : 0

                if (response.data.length == 0) {
                    $('.el-table__empty-text').html('No Data');
                }
                
                this.tableData = this.AttachedAdminNotify(response.data);
                // this.searchedData = this.tableData;
                // this.searchQuery = "";
                this.initialSearchFuse();
                this.fetchingCampaignData = false;
            }, error => {
                this.fetchingCampaignData = false;
            }).finally(() => {
                this.fetchingCampaignData = false;
            });;
            /** GET CLIENT LIST */
        },

        GetCompanyGroup() {
            const userData = this.$store.getters.userData;
            const companyID = (userData.user_type != 'client') ? userData.company_id : userData.company_parent;
            /** GET COMPANY GROUP */
            this.$store.dispatch('GetCompanyGroup', {
                companyID: companyID,
                userModule: 'LeadsPeek',
            }).then(response => {
                //console.log(response.length);
                if (response.result == 'success') {
                    //this.$global.selectsGroupCompany.companyGroupList = [];
                    //this.$global.selectsGroupCompany.companyGroupList = response.params;
                    // this.selectsGroupCompany.companyGroupList = response.params;
                    // this.selectsGroupCompany.companyGroupList.unshift({ 'id': 0, 'group_name': 'none' });

                    this.$global.selectsGroupCompany.companyGroupList = response.params;
                    this.$global.selectsGroupCompany.companyGroupList.unshift({'id':'','group_name':'View All'});
                    
                    if (localStorage.getItem('companyGroupSelected') == null && response.params.length > 1) {
                        localStorage.setItem('companyGroupSelected',response.params[1].id);
                    }
                }
            }, error => {

            });
            /** GET COMPANY GROUP */
        },

        initialSearchFuse() {
            // Fuse search initialization.
            // this.fuseSearch = new Fuse(this.tableData, {
            //     keys: ['company_name', 'campaign_name', 'leadspeek_api_id', 'last_lead_added'],
            //     threshold: 0.1
            // });
        },

        handleLike(index, row) {
            swal.fire({
                title: `You liked ${row.name}`,
                buttonsStyling: false,
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-default btn-fill'
                }
            });
        },
        copytoclipboard(idembeded) {
            $('#' + idembeded).select();
            document.execCommand('copy');
            $('#' + idembeded + 'Link');
            this.copyText = 'Copied';

        },
        async handleEmbededCode(index, row) {
            this.urlActive = '';
            this.isPopOverCheckEmbedCode = false;
            this.selectedRowData = row
            this.testEmbedCodeEmail = this.$store.getters.userData.email
            this.copyText = 'Copy',

            this.$set(this.embedCodeStatus, row.id, {
                isErrorEmbededCode: this.embedCodeStatus[row.id] &&  this.embedCodeStatus[row.id].isErrorEmbededCode != undefined ? this.embedCodeStatus[row.id].isErrorEmbededCode : false,
                isSuccessEmbededCode: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isSuccessEmbededCode != undefined ? this.embedCodeStatus[row.id].isSuccessEmbededCode : false,
                isErrorRunEmbededCode: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isErrorRunEmbededCode != undefined ? this.embedCodeStatus[row.id].isErrorRunEmbededCode : false,
                isSuccessRunEmbededCode: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isSuccessRunEmbededCode != undefined ? this.embedCodeStatus[row.id].isSuccessRunEmbededCode : false,
                isLoadingSendTestEmbedCode: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isLoadingSendTestEmbedCode != undefined ? this.embedCodeStatus[row.id].isLoadingSendTestEmbedCode : false,
                isIframeActive: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isIframeActive != undefined ? this.embedCodeStatus[row.id].isIframeActive : false,
                isWarningEmbededCode: this.embedCodeStatus[row.id] &&  this.embedCodeStatus[row.id].isWarningEmbededCode != undefined ? this.embedCodeStatus[row.id].isWarningEmbededCode : false,
                isErrorEmbededCodeMessage: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isErrorEmbededCodeMessage != undefined ? this.embedCodeStatus[row.id].isErrorEmbededCodeMessage : '',
                isSuccessEmbededCodeMessage: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isSuccessEmbededCodeMessage != undefined ? this.embedCodeStatus[row.id].isSuccessEmbededCodeMessage : '',
                isErrorRunEmbededCodeMessage: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isErrorRunEmbededCodeMessage != undefined ? this.embedCodeStatus[row.id].isErrorRunEmbededCodeMessage : '',
                isSuccessRunEmbededCodeMessage: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isSuccessRunEmbededCodeMessage != undefined ? this.embedCodeStatus[row.id].isSuccessRunEmbededCodeMessage : '',
                isWarningEmbededCodeMessage: this.embedCodeStatus[row.id] && this.embedCodeStatus[row.id].isWarningEmbededCodeMessage != undefined ? this.embedCodeStatus[row.id].isWarningEmbededCodeMessage : '',
            });

            if (row.trysera == 'T') {
                var codeembeded = '<script>';
                codeembeded += 'var ts = {';
                codeembeded += 'c: "14798651632618831906",';
                codeembeded += 'd: "oi.0o0o.io",';
                codeembeded += 's: ' + row.leadspeek_api_id + ',';
                codeembeded += '};';
                codeembeded += 'if("undefined"!=typeof ts){var url="//";ts.hasOwnProperty("d")?url+=ts.d:url+="oi.0o0o.io",url+="/ts.min.js",function(e,t,n,a,r){var o,s,d;e.ts=e.ts||[],o=function(){e.ts=ts},(s=t.createElement(n)).src=a,s.async=1,s.onload=s.onreadystatechange=function(){var e=this.readyState;e&&"loaded"!==e&&"complete"!==e||(o(),s.onload=s.onreadystatechange=null)},(d=t.getElementsByTagName(n)[0]).parentNode.insertBefore(s,d)}(window,document,"script",url)}';
                codeembeded += '<\/script>';
                codeembeded += '<noscript>';
                codeembeded += '<img src="https://oi.0o0o.io/i/14798651632618831906/s/' + row.leadspeek_api_id + '/tsimg.png" width="1" height="1" style="display:none;overflow:hidden">';
                codeembeded += '</noscript>';
                //console.log(codeembeded);
                this.currentEmbedCode = codeembeded;
                this.currentSuppressionCode = '<img src="https://oi.0o0o.io/c/14798651632618831906" style="width:1px;height:1px;border:0" />';
                $('#leadspeekembededcode').val(codeembeded);
                $('#leadspeekembededcodesupression').val(this.currentSuppressionCode);
                $('#suppressioncode').show();
            } else {
                
                let response = await this.getAgencyWhitelabelDomain({ companyID: this.selectedRowData.company_parent})
                let domain = window.location.hostname
                if (response.data && response.data != '' && response.data != null) {
                    domain = response.data.trim()
                }
                var jspx = "px.min.js";
                if (process.env.VUE_APP_DEVMODE == 'true') {
                    jspx = "px-sandbox.min.js";
                }
                var codeembeded = '<script>';
                codeembeded += '(function(doc, tag, id){';
                codeembeded += 'var js = doc.getElementsByTagName(tag)[0];';
                codeembeded += 'if (doc.getElementById(id)) {return;}';
                codeembeded += 'js = doc.createElement(tag); js.id = id;';
                codeembeded += 'js.src = "https://' + domain + '/' + jspx + '";';
                codeembeded += 'js.type = "text/javascript";';
                codeembeded += 'doc.head.appendChild(js);';
                codeembeded += 'js.onload = function() {pxfired();};';
                codeembeded += "}(document, 'script', 'px-grabber'));";
                //codeembeded += 'window.addEventListener("load", function () {';
                codeembeded += 'function pxfired() {';
                codeembeded += 'PxGrabber.setOptions({';
                codeembeded += 'Label: "' + row.leadspeek_api_id + '|" + window.location.href,';
                codeembeded += '});';
                codeembeded += 'PxGrabber.render();';
                //codeembeded += '});';
                codeembeded += '};';
                codeembeded += '<\/script>';

                this.currentEmbedCode = codeembeded;
                this.currentSuppressionCode = '';

                $('#leadspeekembededcode').val(codeembeded);

                $('#suppressioncode').hide();
            }
            this.modals.embededcode = true;
        }, 
        downloadEmbedCode(fileName = 'embedcode.txt') {
            const blob = new Blob([this.currentEmbedCode], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();

            URL.revokeObjectURL(url);
        },
        async handleIntegrationClick(index, row) {
            this.selectedRowData = row
            this.currentRowIndex = index
            this.selectedRowData.mbp_is_active = this.selectedRowData.mbp_is_active
            this.selectedRowData.zap_is_active = this.selectedRowData.zap_is_active
            this.selectedRowData.sendjim_is_active = this.selectedRowData.sendjim_is_active
            this.selectedRowData.clickfunnels_is_active = this.selectedRowData.clickfunnels_is_active
            this.selectedRowData.sendgrid_is_active = this.selectedRowData.sendgrid_is_active
            this.selectedRowData.ghl_is_active = this.selectedRowData.ghl_is_active
            this.selectedRowData.kartra_is_active = this.selectedRowData.kartra_is_active
            let data = await this.getUserIntegrationList({ companyID: this.selectedRowData.company_id, companyParent: this.selectedRowData.company_parent })
            let conditionSpreadsheet = []

            if(row.spreadsheet_id != ''){
                conditionSpreadsheet.push({
                    name: 'Google Sheet',
                    description: 'Deliver Exceptional Email Experiences with SendGrid',
                    logo: 'fa-brands fa-google-drive',
                    active: '3',
                    slug: 'googlesheet',
                    custom_icon: null,
                    custom_description: null,
                    custom_img: null,
                    custom_name: null,
                    custom_slug: null,
                })
            }
            this.getHistorySpreadsheet(this.selectedRowData.leadspeek_api_id);
            
            this.integrations = conditionSpreadsheet

            if (data.length > 0) {
                data.forEach(item => {
                    if(item.company_integration_details.slug === 'sendgrid'){
                        this.selectedRowData.sendgrid_is_active =  this.selectedRowData.sendgrid_is_active === 1
                    }
                    this.integrations.push(item.company_integration_details)
                });
            }
            this.ghl_tags = [];
            this.ghl_tags_remove = [];
            this.selectedIntegration = 'googlesheet'
            this.nameIntegration = row.spreadsheet_id != '' ? 'Google Sheet' : '';
            this.sendGridListOptions =  this.getUserSendgridList({ companyID: this.selectedRowData.company_id })
            this.modals.integrations = true;
        },
        validateConfiguration(data) {
            // console.log('validateConfiguration', {data});
            const notifyError = (message) => {
                this.$notify({
                    type: 'primary',
                    icon: 'fas fa-exclamation-circle',
                    message
                });
            };
    
            const rules = {
                zapier: () => {
                    if (
                        !Array.isArray(data.zapier_webhook) ||
                        data.zapier_webhook.length === 0 ||
                        data.zapier_webhook.some(key => !key || key.trim() === '')
                    ) {
                        notifyError('Url is required');
                        return false;
                    }
                    return true;
                },
                agencyzoom: () => {
                    if (
                        !Array.isArray(data.agencyzoom_webhook) ||
                        data.agencyzoom_webhook.length === 0 ||
                        data.agencyzoom_webhook.some(key => !key || key.trim() === '')
                    ) {
                        notifyError('Url is required');
                        return false;
                    }
                    return true;
                },
            };
    
            if (rules[data.integration_slug]) {
                return rules[data.integration_slug]();
            }
    
            return true;
        },
        async saveIntegrationConfiguration() {
            this.isLoadingSaveIntegration = true
            if (this.validateIntegrationFields()) {
                let data = {
                    id: this.selectedRowData.id,
                    company_id: this.selectedRowData.company_parent,
                    integration_slug: this.selectedIntegration,
                }
                if (this.selectedIntegration === 'googlesheet') {
                    data.reportSentTo = this.selectedRowData.report_sent_to
                    data.adminNotifyTo = this.selectedRowData.admin_notify_to
                } else if (this.selectedIntegration === 'sendgrid') {
                    data.sendgrid_action = this.selectedRowData.sendgrid_action
                    data.sendgrid_list = this.selectedRowData.sendgrid_list ? this.selectedRowData.sendgrid_list : []
                    data.sendgrid_is_active = this.selectedRowData.sendgrid_is_active ? 1 : 0
                } else if (this.selectedIntegration === 'gohighlevel') {
                    data.ghl_tags = this.ghl_tags
                    data.ghl_is_active =  this.selectedRowData.ghl_is_active ? 1 : 0
                    data.company_parent_id = this.selectedRowData.company_id;
                    data.leadspeek_api_id = this.selectedRowData.leadspeek_api_id;
                } else if (this.selectedIntegration === 'kartra') {
                    data.tag = this.selectedKartraTags
                    data.list = this.selectedKartraList
                    // data.campaign_id =  this.selectedRowData.id,
                    data.kartra_is_active =  this.selectedRowData.kartra_is_active ? 1 : 0
                } else if (this.selectedIntegration === 'zapier') {
                    data.zapier_webhook = this.zapierWebhook
                    data.zapier_tags = this.zapierTags
                    data.zapier_is_active = this.selectedRowData.zap_is_active ? 1 : 0
                    data.zapier_test_enable = this.zapierTestEnable ? 1 : 0
                    data.leadspeek_api_id = this.selectedRowData.leadspeek_api_id
                    data.campaign_type = 'site_id'
                    data.company_id_zap = this.selectedRowData.company_id
                } else if(this.selectedIntegration === 'mailboxpower') {
                    data.mbp_groups = this.mbp_groups;
                    data.mbp_states = this.mbp_states;
                    data.mbp_zip = this.mbp_zip;
                    data.mbp_options = this.mbp_options;
                    data.mbp_is_active =  this.selectedRowData.mbp_is_active ? 1 : 0;
                    data.company_parent_id = this.selectedRowData.company_id;
                    data.leadspeek_api_id = this.selectedRowData.leadspeek_api_id;
                } else if (this.selectedIntegration === 'clickfunnels') {
                    const listIdTagsClickFunnelsSelected = this.listTagsClickFunnelsSelected.map((tag) => tag.id)
                    data.company_parent_id = this.selectedRowData.company_id;
                    data.clickfunnels_is_active =  this.selectedRowData.clickfunnels_is_active ? 1 : 0;
                    data.clickfunnels_tags = listIdTagsClickFunnelsSelected;
                } else if (this.selectedIntegration === 'agencyzoom') {
                    data.agencyzoom_webhook = this.agencyZoomWebhook
                    data.agencyzoom_is_active = this.selectedRowData.agencyzoom_is_active ? 1 : 0
                    data.agencyzoom_test_enable = this.agencyZoomTestEnable ? 1 : 0
                    data.leadspeek_api_id = this.selectedRowData.leadspeek_api_id
                    data.company_id_agencyzoom = this.selectedRowData.company_id
                } else if (this.selectedIntegration === 'sendjim') {
                    if (this.sendjimQuickSendEnabled && (!Array.isArray(this.sendjimQuickSendTemplates) || this.sendjimQuickSendTemplates.length === 0)) {
                        this.$notify({ type: 'danger', message: 'Please select at least one Quick Send template', icon: 'fas fa-bug' });
                        this.isLoadingSaveIntegration = false;
                        return;
                    }
                    data.sendjim_is_active = this.selectedRowData.sendjim_is_active ? 1 : 0
                    data.sendjim_tags = this.sendjimTags
                    data.sendjim_quicksend_is_active = this.sendjimQuickSendEnabled ? 1 : 0
                    data.sendjim_quicksend_templates = this.sendjimQuickSendTemplates
                }

                if (!this.validateConfiguration(data)) {
                    this.isLoadingSaveIntegration = false
                    return;
                }

                await this.updateCompanyIntegrationConfiguration({ data })
                // reflect saved state locally so UI shows the latest without reloading
                if (this.selectedIntegration === 'sendjim') {
                    this.selectedRowData.sendjim_is_active = data.sendjim_is_active;
                    this.selectedRowData.sendjim_quicksend_is_active = data.sendjim_quicksend_is_active;
                    this.selectedRowData.sendjim_quicksend_templates = data.sendjim_quicksend_templates;
                    // sync toggles
                    this.selectedRowData.sendjim_is_active = !!data.sendjim_is_active;
                    this.sendjimQuickSendEnabled = !!data.sendjim_quicksend_is_active;
                }
                // this.modals.integrations = false
                this.tableData[this.currentRowIndex] = this.selectedRowData
                // this.tableData[this.currentRowIndex].sendgrid_is_active = this.tableData[this.currentRowIndex].sendgrid_is_active ? 1 : 0
            }
            this.isLoadingSaveIntegration = false
        },
        validateIntegrationFields() {
            return true
            if (this.selectedRowData.sendgrid_action &&  this.selectedRowData.sendgrid_action.length < 1) {
                this.$notify({
                    type: 'primary',
                    message: 'Please select at least one action',
                    icon: 'fas fa-bug'
                });
                return false
            }
            if (this.selectedRowData.sendgrid_action && this.selectedRowData.sendgrid_action.includes('add-to-list') && this.selectedRowData.sendgrid_list.length < 1) {
                this.$notify({
                    type: 'primary',
                    message: 'Please select at least one sendgrid list',
                    icon: 'fas fa-bug'
                });
                return false
            }
            return true
        },
        prefillSendgridIntegrationData() {
            this.selectedSendgridAction =this.selectedRowData.sendgrid_action ? this.selectedRowData.sendgrid_action : '' ;
            this.selectedSendgridList = this.selectedRowData.sendgrid_list ? this.selectedRowData.sendgrid_list : ''
       
        },
        async integrationItemClick(item) {
            this.nameIntegration = item.custom_name || item.name;
            
            if(item.slug === this.selectedIntegration){
                return;
            }

            this.selectedIntegration = item.slug
            if (this.selectedIntegration === 'sendgrid') {
                this.isSendgridInfoFetching = true;
                this.errors.sendgrid = false;
                this.selectedSendgridAction = []
                this.selectedSendgridList = []
                let res = await this.getUserSendgridList({ companyID: this.selectedRowData.company_id })
                if(res.error){
                    this.isSendgridInfoFetching = false;
                    this.errors.sendgrid = true;
                    return;
                }
                this.sendGridListOptions = res
                this.prefillSendgridIntegrationData()
                this.isSendgridInfoFetching = false;
            } else if (this.selectedIntegration === 'gohighlevel') {
                this.isGoHighInfoFetching = true;
                this.errors.goHighLevel = false;
                this.ghl_tags = [];
                this.ghl_tags_remove = [];
                this.selectedRowData.ghl_is_active = 0;

                this.$store.dispatch('getGoHighLevelTags', {
                    companyID: this.selectedRowData.company_id,
                }).then(response => {
                    this.goHighLevelTagsOptions = response.param.tags.map((item) => {
                        return { id: item.id + '|' + item.name, name: item.name }
                    });
                    
                    //this.selectedRowData.ghl_is_active =  this.selectedRowData.ghl_is_active === 1

                    this.$store.dispatch('getGhlUserTags', {
                            campaignID: this.selectedRowData.leadspeek_api_id,
                            companyID: this.selectedRowData.company_id,
                            userIP: this.$store.getters.userData.ip_login,
                        }).then(response => {
                            this.ghl_tags = [];
                            response.param.map((item) => {
                                // this.ghl_tags.push(item.id + '|' + item.name);
                                if(typeof(item.id) == 'undefined') {
                                    this.ghl_tags.push(item.name);
                                } else {
                                    this.ghl_tags.push(item.id + '|' + item.name);
                                }
                            });
                            this.selectedRowData.ghl_is_active = response.ghlactive === 1;
                            this.ghl_tags_remove = response.tagremove;
                            this.isGoHighInfoFetching = false;

                            setTimeout(() => {
                                const inputGhlTags = this.$refs.selectGhlTags.$el.querySelector('.select-integration-ghl .el-select__input');
                                if (inputGhlTags) {
                                    inputGhlTags.addEventListener('keyup', this.keydownInputGhlTags);
                                }
                                this.changeGhlTags('getGhlUserTags');
                            }, 100);
                        },error => {
                            this.isGoHighInfoFetching = false;
                            this.errors.goHighLevel = true;
                        });                       
                },error => {
                    this.isGoHighInfoFetching = false;
                    this.errors.goHighLevel = true;
                });
            } else if (this.selectedIntegration === 'kartra') {
                this.onKartraIntegrationSelect()
            } else if (this.selectedIntegration === 'googlesheet') {     
                this.isGoogleInfoFetching = true;
                this.sendGridListOptions = await this.getUserSendgridList({ companyID: this.selectedRowData.company_id })
                this.isGoogleInfoFetching = false;
            } else if (this.selectedIntegration === 'zapier') {
                this.isZapierFetching = true;
                const campaign_webhook = await this.getCampaignZapierDetails({campaign_id: this.selectedRowData.id})
                const campaign_tags = await this.getCampaignZapierTags({campaign_id: this.selectedRowData.id})
                const agency_webhook = await this.getAgencyZapierDetails({ company_id: this.selectedRowData.company_id})
                const agency_tags = await this.getAgencyZapierTags({ company_id: this.selectedRowData.company_id})
                this.zapierTagsOptions = []
                if(agency_tags){
                    this.zapierTagsOptions = agency_tags.map((item) => {
                        return { name: item.name }
                    });
                }
                if ((campaign_webhook.zap_webhook != '' && campaign_webhook.zap_webhook != null) && campaign_webhook.zap_webhook != agency_webhook[0].api_key) {
                    this.defaultWebhook = false;
                    this.selectedRowData.zap_is_active = campaign_webhook.zap_is_active === 1
                    this.zapierTestEnable = 0
                    this.zapierWebhook = campaign_webhook.zap_webhook
                    this.leadspeek_api_id = this.selectedRowData.leadspeek_api_id
                    this.zapierTags = [];
                    if (campaign_tags.zap_tags) {
                        campaign_tags.zap_tags.map((item) => {
                                this.zapierTags.push(item.name);
                        });
                    }
                } else {
                    this.defaultWebhook = true;
                    this.selectedRowData.zap_is_active = campaign_webhook.zap_is_active === 1;
                    this.zapierTestEnable = 0
                    this.zapierWebhook = [];
                    if (agency_webhook[0].api_key) {
                        agency_webhook[0].api_key.forEach(item => {
                            this.zapierWebhook.push(item)
                        });
                    }
                    this.leadspeek_api_id = this.selectedRowData.leadspeek_api_id
                    this.zapierTags = [];
                    if (campaign_tags.zap_tags) {
                        campaign_tags.zap_tags.map((item) => {
                                this.zapierTags.push(item.name);
                        });
                    }
                }
                this.isZapierFetching = false;
            } else if (this.selectedIntegration === 'mailboxpower') {
                this.isMailBoxPowerFetching = true;
                this.errors.mailboxPower = false;
                this.mbp_groups = [];
                this.mbp_groups_remove = [];
                this.selectedRowData.mbp_is_active = 0;

                this.$store.dispatch('getMailBoxPowerGroups', {
                    companyID: this.selectedRowData.company_id,
                    campaignID: this.selectedRowData.leadspeek_api_id,
                })
                .then(response => {
                    // console.log({action: 'getMailBoxPowerGroups', response: response});

                    this.mailBoxPowerOptions = response.param.map((item) => {
                        return { id: item.ID + '|' + item.NAME, name: item.NAME }
                    });
                    this.mailBoxPowerStates = response.states;
                    // console.log({'this.isMailBoxPowerFetching': this.isMailBoxPowerFetching,'this.mailBoxPowerOptions': this.mailBoxPowerOptions});

                    
                    this.$store.dispatch('getMailBoxPowerUserGroups', {
                        campaignID: this.selectedRowData.leadspeek_api_id,
                        companyID: this.selectedRowData.company_id,
                    })
                    .then(response => {
                        // console.log({action: 'getMailBoxPowerUserGroups', response: response});

                        this.mbp_groups = [];
                        response.param.map((item) => {
                            this.mbp_groups.push(item.id + '|' + item.name);
                        });

                        this.mbp_states = response.mbpstates;
                        this.mbp_zip = response.mbpzip;
                        this.mbp_options = response.mbpoptions;
                        this.selectedRowData.mbp_is_active = response.mbpactive === 1;
                        this.mbp_groups_remove = response.mbpremove;
                        this.isMailBoxPowerFetching = false;
                        // console.log({'this.mbp_groups': this.mbp_groups,'this.mbp_states': this.mbp_states});
                    })
                    .catch(error => {
                        this.isMailBoxPowerFetching = false;
                        this.errors.mailboxPower = true;
                    });
                })
                .catch(error => {
                    this.isMailBoxPowerFetching = false;
                    this.errors.mailboxPower = true;
                })
            } else if (this.selectedIntegration === 'clickfunnels') {
                this.getListTagsClickFunnels();
            } else if (this.selectedIntegration === 'agencyzoom') {
                this.isAgencyZoomFetching = true;
                const campaign_webhook = await this.getCampaignAgencyZoomDetails({campaign_id: this.selectedRowData.id})
                const client_webhook = await this.getClientAgencyZoometails({ company_id: this.selectedRowData.company_id})
                // console.log({campaign_webhook,client_webhook});

                this.leadspeek_api_id = this.selectedRowData.leadspeek_api_id;
                this.selectedRowData.agencyzoom_is_active = campaign_webhook.agencyzoom_is_active === 1;
                this.agencyZoomWebhook = [];

                if ((campaign_webhook.agencyzoom_webhook != '' && campaign_webhook.agencyzoom_webhook != null) && campaign_webhook.agencyzoom_webhook != client_webhook[0].api_key) {
                    this.defaultAgencyZoomWebhook = false;
                    this.agencyZoomWebhook = campaign_webhook.agencyzoom_webhook;
                } else {
                    this.defaultAgencyZoomWebhook = true;
                    if (client_webhook[0].api_key) {
                        client_webhook[0].api_key.forEach(item => {
                            this.agencyZoomWebhook.push(item);
                        });
                    }
                }

                this.isAgencyZoomFetching = false;
            } else if (this.selectedIntegration === 'sendjim') {
                this.selectedRowData.sendjim_is_active = !!this.selectedRowData.sendjim_is_active;
                try {
                    const tags = await this.$store.dispatch('getSendJimCampaignTags', { campaign_id: this.selectedRowData.id });
                    if (Array.isArray(tags)) {
                        this.sendjimTags = tags;
                        this.sendjimTagsOptions = tags.map(name => ({ name }));
                    } else {
                        this.sendjimTags = [];
                        this.sendjimTagsOptions = [];
                    }
                } catch (e) {
                    this.sendjimTags = [];
                    this.sendjimTagsOptions = [];
                }
                // quicksend fields
                try {
                    this.sendjimQuickSendEnabled = !!this.selectedRowData.sendjim_quicksend_is_active;
                    const tplRaw = this.selectedRowData.sendjim_quicksend_templates;
                    this.sendjimQuickSendTemplates = Array.isArray(tplRaw) ? tplRaw : (tplRaw ? JSON.parse(tplRaw) : []);
                } catch (e) {
                    this.sendjimQuickSendEnabled = false;
                    this.sendjimQuickSendTemplates = [];
                }
                // load available templates from client
                try {
                    const list = await this.$store.dispatch('getSendJimQuickSends', { company_id: this.selectedRowData.company_id });
                    this.sendjimQuickSendOptions = Array.isArray(list) ? list.map(it => ({ id: it.Id || it.id, name: it.Name || it.name, image: it.ImageUrl || it.image || '' })).filter(it => it.id) : [];
                } catch (e) {
                    this.sendjimQuickSendOptions = [];
                }
            }
            // this.selectedRowData.sendgrid_action = null
            // this.selectedRowData.sendgrid_list = null
           
        },
        async onKartraIntegrationSelect(){
                this.isKartraInfoFetching = true
                this.errors.kartra = false
                this.selectedKartraList = []
               
                this.selectedKartraTags = []
                const data = {
                    campaign_id: this.selectedRowData.id,
                    company_id: this.selectedRowData.company_parent,
                    integration_slug: this.selectedIntegration,
                }
                let res = await this.geUsertKartraDetails({ companyID: this.selectedRowData.company_id })
                if(res.error){
                    this.errors.kartra = true;
                    this.isKartraInfoFetching = false
                    return;
                }
                let resListandTag = await this.getSelectedKartraListAndTags({data})
                this.selectedRowData.kartra_is_active = resListandTag.data.kartra_is_active  === 1 
                this.selectedKartraTags = resListandTag.data.tag
                this.selectedKartraList = resListandTag.data.list
                this.kartraTagsOptions = res.tags ?  res.tags : []
                this.kartraListOptions = res.lists ?  res.lists : []
                this.isKartraInfoFetching = false
                
        },
        handleDelete(index, row) {
            const userData = this.$store.getters.userData
            var _status = 'F';
            if (row.active_user == 'F') {
                _status = 'T';
            }
            if (_status == 'T') {
                return false;
            }
            //console.log('Row: ' + index);

            //LOG ACTION
            let descriptionLogs = `campaign id: ${row.leadspeek_api_id} | campaign type: ${row.leadspeek_type} | payment term: ${row.paymentterm.toLowerCase()} `
            //LOG ACTION

            swal.fire({
                title: 'Are you sure you want to stop this campaign?',
                html: 'Restarting a Stopped campaign will charge any setup fees and reoccurring weekly/monthly fees. Restarting a Paused campaign will not charge any setup fees, however a paused campaign will still charge any reoccurring weekly/monthly fees.',
                icon: '',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-default btn-fill',
                    cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Ok',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.popProcessingTxt = "Please wait, stopping campaign ....";

                    $('#processingArea').addClass('disabled-area');
                    $('#popProcessing').show();

                    /** REMOVE ORGANIZATION */
                    this.$store.dispatch('RemoveLeadsPeekClient', {
                        companyID: this.companyID,
                        leadspeekID: row.id,
                        status: _status,
                        userID: row.user_id,
                    }).then(response => {
                        //console.log(response)
                        $('#processingArea').removeClass('disabled-area');
                        $('#popProcessing').hide();

                        if (_status == 'T') {
                            row.active_user = 'T';
                            row.disabled = 'F';
                            $('#userstartstop' + index).removeClass('fas fa-stop gray').addClass('fas fa-stop green');
                            this.GetClientList();
                            this.$notify({
                                type: 'success',
                                message: 'This campaign will activated',
                                icon: 'tim-icons icon-bell-55'
                            });
                        } else { // for stop campaign
                            row.active = 'F';
                            row.disabled = 'T';
                            row.active_user = 'F';
                            $('#userstartstop' + index).removeClass('fas fa-stop green').addClass('fas fa-stop gray');
                            this.GetClientList();
                            
                            if(typeof(response.status_invoice) != 'undefined' && response.status_invoice == 'failed') {
                                this.$notify({
                                    type: 'danger',
                                    message: 'Campaign successfully stopped. but charging the campaign failed.',
                                    icon: 'tim-icons icon-bell-55'
                                }); 

                                // LOG ACTION
                                // const data = {
                                //     userID: userData.id,
                                //     action: "Campaign Stopped failed charge",
                                //     desc: descriptionLogs,
                                //     userIP: this.$store.getters.userData.ip_login,
                                // }
                                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                                // if(userViewMode){
                                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                                //     data.userID = userRoot.id;
                                // }
                                // this.userLogSaved({ data });

                                this.$store.dispatch('onSaveUserLogs', {
                                    desc: descriptionLogs,
                                    action: "Campaign Stopped failed charge",
                                    target_id: row.user_id,
                                })
                                // LOG ACTION
                            } else if(typeof(response.result) != 'undefined' && response.result == 'failed_campaign_already_stopped') {
                                this.$notify({
                                    type: 'danger',
                                    message: response.message,
                                    icon: 'tim-icons icon-bell-55'
                                }); 

                                this.$store.dispatch('onSaveUserLogs', {
                                    desc: descriptionLogs,
                                    action: "Campaign Is Already Stopped",
                                    target_id: row.user_id,
                                })
                            } else { 
                                this.$notify({
                                    type: 'success',
                                    message: 'Campaign successfully stopped.',
                                    icon: 'tim-icons icon-bell-55'
                                }); 
                                
                                // LOG ACTION
                                // const data = {
                                //     userID: userData.id,
                                //     action: "Campaign Stopped",
                                //     desc: descriptionLogs,
                                //     userIP: this.$store.getters.userData.ip_login,
                                // }
                                // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                                // if(userViewMode){
                                //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                                //     data.userID = userRoot.id;
                                // }
                                // this.userLogSaved({ data });

                                this.$store.dispatch('onSaveUserLogs', {
                                    desc: descriptionLogs,
                                    action: "Campaign Stopped",
                                    target_id: row.user_id,
                                })
                                // LOG ACTION
                            }
                        }
                    }, error => {
                        $('#processingArea').removeClass('disabled-area');
                        $('#popProcessing').hide();
                    });

                    /** REMOVE ORGANIZATION */
                }
            });
        },
        deleteRow(row) {
            let indexToDelete = this.tableData.findIndex(
                tableRow => tableRow.id === row.id
            );
            if (indexToDelete >= 0) {
                this.tableData.splice(indexToDelete, 1);
            }
        },

        callbackGoogleConnected(e) {
            window.removeEventListener('message', this.callbackGoogleConnected);
            if (e.origin == process.env.VUE_APP_DATASERVER_URL) {
                if (e.data == 'success') {
                    this.GoogleConnectTrue = true;
                    this.GoogleConnectFalse = false;
                }
            }
        },
        initial_default_price() {
            this.resetAgencyCost();
            this.$store.dispatch('getGeneralSetting', {
                companyID: this.companyID,
                settingname: 'agencydefaultprice',
                idSys: this.$global.idsys
            }).then(response => {
                if (response.data != '') {
                    //console.log(response.data);
                    this.defaultCostCampaign.local.Monthly.LeadspeekPlatformFee = (response.data.local.Monthly.LeadspeekPlatformFee != '') ? response.data.local.Monthly.LeadspeekPlatformFee : '0';
                    this.defaultCostCampaign.local.Monthly.LeadspeekCostperlead = (response.data.local.Monthly.LeadspeekCostperlead != '') ? response.data.local.Monthly.LeadspeekCostperlead : '0';
                    this.defaultCostCampaign.local.Monthly.LeadspeekMinCostMonth = (response.data.local.Monthly.LeadspeekMinCostMonth != '') ? response.data.local.Monthly.LeadspeekMinCostMonth : '0';

                    this.defaultCostCampaign.local.Weekly.LeadspeekPlatformFee = (response.data.local.Weekly.LeadspeekPlatformFee != '') ? response.data.local.Weekly.LeadspeekPlatformFee : '0';
                    this.defaultCostCampaign.local.Weekly.LeadspeekCostperlead = (response.data.local.Weekly.LeadspeekCostperlead != '') ? response.data.local.Weekly.LeadspeekCostperlead : '0';
                    this.defaultCostCampaign.local.Weekly.LeadspeekMinCostMonth = (response.data.local.Weekly.LeadspeekMinCostMonth != '') ? response.data.local.Weekly.LeadspeekMinCostMonth : '0';
                    
                    this.defaultCostCampaign.local.Prepaid.LeadspeekPlatformFee = (response.data.local.Prepaid.LeadspeekPlatformFee != '') ? response.data.local.Prepaid.LeadspeekPlatformFee : '0';
                    this.defaultCostCampaign.local.Prepaid.LeadspeekCostperlead = (response.data.local.Prepaid.LeadspeekCostperlead != '') ? response.data.local.Prepaid.LeadspeekCostperlead : '0';
                    this.defaultCostCampaign.local.Prepaid.LeadspeekMinCostMonth = (response.data.local.Prepaid.LeadspeekMinCostMonth != '') ? response.data.local.Prepaid.LeadspeekMinCostMonth : '0';
                    
                    this.defaultCostCampaign.local.OneTime.LeadspeekPlatformFee = (response.data.local.OneTime.LeadspeekPlatformFee != '') ? response.data.local.OneTime.LeadspeekPlatformFee : '0';
                    this.defaultCostCampaign.local.OneTime.LeadspeekCostperlead = (response.data.local.OneTime.LeadspeekCostperlead != '') ? response.data.local.OneTime.LeadspeekCostperlead : '0';
                    this.defaultCostCampaign.local.OneTime.LeadspeekMinCostMonth = (response.data.local.OneTime.LeadspeekMinCostMonth != '') ? response.data.local.OneTime.LeadspeekMinCostMonth : '0';

                    // this.defaultCostCampaign.local.Prepaid.LeadspeekPlatformFee = (typeof(this.costagency.local.Prepaid !== 'undefined') && response.data.local.Prepaid.LeadspeekPlatformFee != '') ? response.data.local.Prepaid.LeadspeekPlatformFee : '0';
                    // this.defaultCostCampaign.local.Prepaid.LeadspeekCostperlead = (typeof(this.costagency.local.Prepaid !== 'undefined') && response.data.local.Prepaid.LeadspeekCostperlead != '') ? response.data.local.Prepaid.LeadspeekCostperlead : '0';
                    // this.defaultCostCampaign.local.Prepaid.LeadspeekMinCostMonth = (typeof(this.costagency.local.Prepaid !== 'undefined') && response.data.local.Prepaid.LeadspeekMinCostMonth != '') ? response.data.local.Prepaid.LeadspeekMinCostMonth : '0';

                    // this.defaultCostCampaign.local.Prepaid.LeadspeekPlatformFee = (typeof(this.costagency.local.Prepaid !== 'undefined') && response.data.local.Weekly.LeadspeekPlatformFee != '') ? response.data.local.Weekly.LeadspeekPlatformFee : '0';
                    // this.defaultCostCampaign.local.Prepaid.LeadspeekCostperlead = (typeof(this.costagency.local.Prepaid !== 'undefined') && response.data.local.Weekly.LeadspeekCostperlead != '') ? response.data.local.Weekly.LeadspeekCostperlead : '0';
                    // this.defaultCostCampaign.local.Prepaid.LeadspeekMinCostMonth = (typeof(this.costagency.local.Prepaid !== 'undefined') && response.data.local.Weekly.LeadspeekMinCostMonth != '') ? response.data.local.Weekly.LeadspeekMinCostMonth : '0';
                    
                }

            }, error => {

            });
        },
        format_date(valdate,convert = false,toClientTime = false){
            if (valdate) {

                if (convert) {
                    // Set the source and target timezones
                    const sourceTimezone = this.$global.clientTimezone; 
                    const targetTimezone = this.$global.systemTimezone;
                    if (toClientTime) {
                        const sourceTimezone = this.$global.systemTimezone; 
                        const targetTimezone = this.$global.clientTimezone; 
                    }

                    // Parse the input time in the source timezone
                    const sourceMoment = this.$moment.tz(valdate, sourceTimezone);

                    // Convert the time to the target timezone
                    const targetMoment = sourceMoment.clone().tz(targetTimezone);

                    return targetMoment.format('YYYY-MM-DD HH:mm:ss');
                }else{

                    return this.$moment(valdate).format('YYYY-MM-DD HH:mm:ss');
                }
            }
        },
        handleVisibleChange(visible) {            
            this.dropdownVisible = visible;
        },
        applyFilters(event){
            event.stopPropagation();
            this.GetClientList(this.currSortBy, this.currOrderBy)
            this.dropdownVisible = false;
        },
        applyFilter(filter){
            this.filterCampaignStatus = filter.value
            this.GetClientList(this.currSortBy, this.currOrderBy)
            this.dropdownVisible = false;
        },
        validateEmail(email) {
            const errors = [];

            // Check for invalid characters like '(' and ')'
            if (/\(|\)/.test(email)) {
                errors.push('Email contains invalid characters (display name is not allowed)');
            }

            // Check if email contains '@' and domain
            if (!email.includes('@')) {
                errors.push('Missing @');
            } else {
                const parts = email.split('@');
                const localPart = parts[0];
                const domain = parts[1];

                // Check for missing address
                if (!localPart) {
                    errors.push('Missing address');
                }

                // Check for leading dot in address
                if (localPart.startsWith('.')) {
                    errors.push('Leading dot in address');
                }

                // Check for trailing dot in address
                if (localPart.endsWith('.')) {
                    errors.push('Trailing dot in address');
                }

                // Check for multiple dots in address
                if (/\.{2,}/.test(localPart)) {
                    errors.push('Multiple dots in address');
                }

                if (domain) {
                    // Check for leading dash in domain
                    if (domain.startsWith('-')) {
                        errors.push('Leading dash in domain');
                    }

                    // Check for leading dot in domain
                    if (domain.startsWith('.')) {
                        errors.push('Leading dot in domain');
                    }

                    // Check for multiple dots in domain
                    if (/\.{2,}/.test(domain)) {
                        errors.push('Multiple dots in domain');
                    }

                    if (/[^a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]/.test(domain)) {
                        errors.push('Garbage or Unicode characters in address');
                    }

                    // Check for invalid IP format in domain
                    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(domain)) {
                        const octets = domain.split('.').map(Number);
                        if (octets.some(octet => octet < 0 || octet > 255)) {
                            errors.push('Invalid IP format');
                        }
                    }
                } else {
                    errors.push('Domain is missing');
                }

                // Check for garbage or Unicode characters in address
                if (/[^a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]/.test(localPart)) {
                    errors.push('Garbage or Unicode characters in address');
                }
            }

            // Check for two '@' symbols
            if ((email.match(/@/g) || []).length > 1) {
                errors.push('Two @ symbols');
            }

            return errors;
        },
        messageValidationRequired(type){
            this.$notify({
                type: 'danger',
                message: `${type} is required`,
                icon: 'fas fa-exclamation-circle'
            })
        },
        removeSpaces() {
            this.testEmbedCodeEmail = this.testEmbedCodeEmail.replace(/\s+/g, '');
        },
        onTestEmbedCode(){
            const id = this.selectedRowData.id;
            if (!this.testEmbedCodeEmail){
                this.messageValidationRequired('Email')
                return false
            }

            const errors = this.validateEmail(this.testEmbedCodeEmail);
            if (errors.length > 0) {
                this.$notify({
                    type: 'danger',
                    message: `Email invalid: ${errors.join(', ')}`,
                    icon: 'fas fa-exclamation-circle'
                });
                return false;
            }

            if(this.urlActive == ''){
                this.$notify({
                    type: 'danger',
                    message: `Please select url`,
                    icon: 'fas fa-exclamation-circle'
                });
                return false;
            }

            this.$set(this.embedCodeStatus[id], 'isLoadingSendTestEmbedCode', true);


            //check embeded code
            const payload = {
                url_code : this.urlActive,
                leadspeek_api_id : this.selectedRowData.leadspeek_api_id
            }            

            this.$set(this.embedCodeStatus, id, {
                isLoadingSendTestEmbedCode: true,
                isErrorEmbededCode: false,
                isErrorEmbededCodeMessage: '',
                isSuccessEmbededCode: false,
                isSuccessEmbededCodeMessage: '',
                isErrorRunEmbededCode: false,
                isErrorRunEmbededCodeMessage: '',
                isSuccessRunEmbededCode: false,
                isSuccessRunEmbededCodeMessage: '',
                isWarningEmbededCode: false,
                isWarningEmbededCodeMessage: '',
                isIframeActive: false,
            });

            this.$store.dispatch('onSendTestEmbedCode', payload).then(response => {
                if(response.msg_block == ''){
                    this.$set(this.embedCodeStatus[id], 'isIframeActive', true);
                    this.responseTestEmbedCode = {
                        msg_exist: response.msg_exist,
                        msg_notexist: response.msg_notexist,
                        msg_block: response.msg_block,
                    }
                } else {
                    this.$set(this.embedCodeStatus[id], 'isIframeActive', false);
                    this.$set(this.embedCodeStatus[id], 'isWarningEmbededCode', true);
                    this.$set(this.embedCodeStatus[id], 'isWarningEmbededCodeMessage', response.msg_block);
                    this.$set(this.embedCodeStatus[id], 'isLoadingSendTestEmbedCode', false);
                    this.isPopOverCheckEmbedCode = false;
                }

                // if (this.timeoutIframe) {
                //     clearTimeout(this.timeoutIframe);
                // }

                // this.timeoutIframe = setTimeout(() => {
                //     this.$set(this.embedCodeStatus[id], 'isIframeActive', false);
                //     this.onRunTestEmbedCode(payload, id, response.msg_exist, response.msg_notexist, response.msg_block)
                //     this.timeoutId = null;
                // }, 45000)
            }, error => {
                this.$set(this.embedCodeStatus[id], 'isIframeActive', false);
                if(error.result === 'failed from crawl'){
                    this.$set(this.embedCodeStatus[id], 'isWarningEmbededCode', true);
                    this.$set(this.embedCodeStatus[id], 'isWarningEmbededCodeMessage', error.msg_block);
                } else {
                    this.$set(this.embedCodeStatus[id], 'isErrorEmbededCode', true);
                    this.$set(this.embedCodeStatus[id], 'isErrorEmbededCodeMessage', error.message);
                }
                this.$set(this.embedCodeStatus[id], 'isLoadingSendTestEmbedCode', false);
                this.isPopOverCheckEmbedCode = false;
                this.$notify({
                    type: 'danger',
                    message: error.message,
                    icon: 'fas fa-exclamation-circle'
                });
            })  
        },
        onRunTestEmbedCode(payload, id, msg_exist, msg_notexist, msg_block) {
            this.$set(this.embedCodeStatus[id], 'isLoadingSendTestEmbedCode', false);

            if(msg_exist != ''){
                this.$set(this.embedCodeStatus[id], 'isSuccessEmbededCode', true);
                this.$set(this.embedCodeStatus[id], 'isSuccessEmbededCodeMessage', msg_exist);
            }
            if(msg_notexist != ''){
                this.$set(this.embedCodeStatus[id], 'isErrorEmbededCode', true);
                this.$set(this.embedCodeStatus[id], 'isErrorEmbededCodeMessage', msg_notexist);
                this.isPopOverCheckEmbedCode = false;
            }
            if(msg_block != ''){
                this.$set(this.embedCodeStatus[id], 'isWarningEmbededCode', true);
                this.$set(this.embedCodeStatus[id], 'isWarningEmbededCodeMessage', msg_block);
                this.isPopOverCheckEmbedCode = false;
            }

            this.$store.dispatch('runTestEmbedCode', payload).then(res => {
                if(res.msg_exist != ''){
                    this.$set(this.embedCodeStatus[id], 'isSuccessRunEmbededCode', true);
                    this.$set(this.embedCodeStatus[id], 'isSuccessRunEmbededCodeMessage', res.msg_exist);
                }
                if(res.msg_notexist != ''){
                    this.$set(this.embedCodeStatus[id], 'isErrorRunEmbededCode', true);
                    this.$set(this.embedCodeStatus[id], 'isErrorRunEmbededCodeMessage', res.msg_notexist);
                    this.isPopOverCheckEmbedCode = false;
                }
            }, err => {
                this.$set(this.embedCodeStatus[id], 'isErrorRunEmbededCode', true);
                this.$set(this.embedCodeStatus[id], 'isErrorRunEmbededCodeMessage', err.message);
                this.isPopOverCheckEmbedCode = false;
                // this.$set(this.embedCodeStatus[id], 'isLoadingSendTestEmbedCode', false);

                this.$notify({
                    type: 'danger',
                    message: err.message,
                    icon: 'fas fa-exclamation-circle'
                });

            })
        },
        onViewExampleData() {
            window.open(this.basicExampleDataUrl, "_blank");
        },
        onSendTestLead(){
            this.isLoadingSendTestLead = true
            const payload = {
                type: this.selectedIntegration,
                date: this.$moment().format('YYYY-MM-DD'),
                company_id: this.selectedRowData.company_id,
                campaign_id: this.selectedRowData.leadspeek_api_id,
                format: {
                    home_address_enabled: this.selectedRowData.homeaddressenabled,
                    phone_enabled: this.selectedRowData.phoneenabled,
                },
            }

            if (this.selectedIntegration == 'gohighlevel') {
                if(this.ghl_tags.length > 0){
                    const tags_go_high_level = this.ghl_tags.map(item => { return item.includes('|') ? item.split('|')[1] : item });
                    payload.tags_go_high_level = tags_go_high_level
                }
            } else if (this.selectedIntegration == 'sendgrid') {
                if(this.selectedRowData.sendgrid_action.includes('add-to-list')){
                    payload.sendgrid_list = this.selectedRowData.sendgrid_list
                }
            } else if (this.selectedIntegration == 'mailboxpower') {
                if(this.mbp_groups.length > 0){
                    const group_mail_box_power = this.mbp_groups.map(item => item.split("|")[0]).filter(Boolean);
                    const new_group_mail_box_power = this.mbp_groups.filter(item => !item.includes('|'));
                    if(new_group_mail_box_power.length > 0){
                        payload.new_group_mail_box_power = new_group_mail_box_power
                    }
                    payload.group_mail_box_power = group_mail_box_power
                }
            } else if (this.selectedIntegration == 'zapier') {
                payload.webhook_url = this.zapierWebhook
                payload.webhook_tags = this.zapierTags
            } else if (this.selectedIntegration == 'kartra') {
                payload.campaign_id = this.selectedRowData.id;
                payload.kartra_list = this.selectedKartraList;
                payload.kartra_tags = this.selectedKartraTags;
                payload.date = this.$moment().format('YYYY-MM-DD');
            } else if (this.selectedIntegration == 'clickfunnels') {
                const listIdTagsClickFunnelsSelected = this.listTagsClickFunnelsSelected.map((tag) => tag.id)
                payload.clickfunnels_tags = listIdTagsClickFunnelsSelected;
            } else if (this.selectedIntegration == 'agencyzoom') {
                payload.webhook_url = this.agencyZoomWebhook
            } else if (this.selectedIntegration == 'sendjim') {
                // backend derives tags and quicksend settings; nothing extra to send
            }

            this.$store.dispatch('onSendTestLead', payload).then(response => {
                this.$notify({
                    type: 'success',
                    message: 'Sent test lead successfully!',
                    icon: 'far fa-save'
                });
                this.isLoadingSendTestLead = false
            }, err => {
                this.isLoadingSendTestLead = false
                this.$notify({
                    type: 'danger',
                    message: err.message,
                    icon: 'fas fa-exclamation-circle'
                });
            })
        },
        async onSendTestSpreadsheet() { 
            try {
                this.isLoadingSpreedSheetConnection = true
                this.$store.dispatch('onSendTestSpreadsheet', {
                    campaignID : this.selectedRowData.id
                }).then(response => {
                    if (response.data.result == 'success') {
                        this.isLoadingSpreedSheetConnection = false
                        this.$notify({
                            type: response.data.result,
                            message: response.data.message,
                            icon: 'far fa-check'
                        });
                    } else {
                        const status = response.data.status || 'UNKNOWN';

                        swal.fire({
                              title: `<span style='font-size:21px;'><b>Spreadsheet Connection Failed</b><br><br><span style='font-size:16px;'>We couldn’t connect to the spreadsheet. It may belong to a different Google account. <br>Please switch to the correct account in the General Settings, or create a new spreadsheet to begin writing data. <br><br><span style='font-size:13px;'>Reason: ${status}</span></span></span>`,
                              text: '',
                              icon: '',
                              width: '600px',
                              showCancelButton: true,
                              customClass: {
                                confirmButton: 'btn btn-fill mr-3',
                                cancelButton: 'btn btn-danger btn-fill'
                              },
                              confirmButtonText: "Create New Spreadsheet",
                              buttonsStyling: false
                        }).then(result => {
                            if (result.isConfirmed) {
                                this.resetSpreadsheet(this.selectedRowData.id, this.selectedRowData.leadspeek_api_id);
                            }
                                this.isLoadingSpreedSheetConnection = false;
                        });
                    }
                    
                }, err => {
                    this.$notify({
                        type: 'danger',
                        message: `Spreadsheet connection failed. Please ensure your Google account is connected in the General Settings menu.`,
                        icon: 'far fa-warning'
                    });
                    this.isLoadingSpreedSheetConnection = false
                })

            } catch (error) {
                    this.isLoadingSpreedSheetConnection = false
            }

        },
        resetSpreadsheet(id, leadspeek_api_id) {
            // panggil API / dispatch Vuex / logika reset di sini
            this.isLoadingResetSpreadsheet = true;
            this.$store.dispatch('onResetSpreadsheet', {
                campaignID: id
            }).then(response => {
                this.isLoadingResetSpreadsheet = false;
                // getHistorySpreadsheet(leadspeek_api_id);

                if (response.data.result == 'success') {
                    this.$notify({
                        type: 'success',
                        message: 'Reset Spreadsheet successfully',
                        icon: 'far fa-save'
                    });
                } else {
                    this.$notify({
                        type: response.data.result,
                        message: response.data.message,
                        icon: 'far fa-info'
                    });
                }
                
                this.modals.integrations = false;
                this.GetClientList(this.currSortBy,this.currOrderBy)
                
            }, error => {
                console.log('eror : ', error);
                this.isLoadingResetSpreadsheet = false;

                this.$notify({
                    type: 'error',
                    message: 'Reset Spreadsheet Error. Try Again',
                    icon: 'far fa-warning'
                });

                this.modals.integrations = false;
                this.GetClientList(this.currSortBy,this.currOrderBy)
                // getHistorySpreadsheet(leadspeek_api_id);
            });
        },
        getHistorySpreadsheet(leadspeek_api_id) {

            this.$store.dispatch('getHistorySpreadsheet', {
                campaignID: leadspeek_api_id
            }).then(response => {
                this.spreadsheetHistory = response.data; // bisa juga langsung dari state
            });
            
        },
        handleClickMenuClickFunnels(value){
            if(this.menuClickFunnels === value){
                return;
            }

            if(value == 'choose-tag'){
                this.getListTagsClickFunnels();
            }

            this.menuClickFunnels = value;
        },
        onColorClickFunnels(value){
            this.formNewTagClickFunnels.color = value;
            this.$refs.formNewTagClickFunnels.clearValidate(['color']);
        },
        removeTagClickFunnels(tag) {
            this.listTagsClickFunnelsSelected = this.listTagsClickFunnelsSelected.filter(t => t.id !== tag.id);
        },
        getListTagsClickFunnels(){
            this.isLoadingGetTagsClickFunnels = true;
            this.errors.clickfunnels = false;
            const payload = {
                company_id: this.selectedRowData.company_id,
            }
            
            this.$store.dispatch('getListTagsClickFunnels', payload).then(response => {
                this.listTagsClickFunnels = response.data;
                this.isLoadingGetTagsClickFunnels = false;
                this.getCampaignTagsClickFunnels();
            }, error => {
                this.errors.clickfunnels = true;
                this.isLoadingGetTagsClickFunnels = false;
            })
        },
        getCampaignTagsClickFunnels(){
            this.isLoadingGetCampaignTagsClickFunnels = true;
            const payload = {
                campaign_id: this.selectedRowData.id,
            }
            
            this.$store.dispatch('getCampaignTagsClickFunnels', payload).then(response => {
                const tagId = response.data.clickfunnels_tags;
                const filterTags = this.listTagsClickFunnels.filter(tag => tagId.includes(tag.id))
                this.listTagsClickFunnelsSelected = filterTags;
                this.selectedRowData.clickfunnels_is_active = response.data.clickfunnels_is_active === 1;
                this.isLoadingGetCampaignTagsClickFunnels = false;
            }, error => {
                this.errors.clickfunnels = true;
                this.isLoadingGetCampaignTagsClickFunnels = false;
            })
        },
        onCreateTagsClickFunnels(){
            if(!this.formNewTagClickFunnels.name.trim()){
                this.$refs.formNewTagClickFunnels.validateField(['name']);
                return;
            }
            
            if(!this.formNewTagClickFunnels.color.trim()){
                this.$refs.formNewTagClickFunnels.validateField(['color']);
                return;
            }

            this.isLoadingCreateTagsClickFunnels = true;
            const payload = {
                company_id: this.selectedRowData.company_id,
                name: this.formNewTagClickFunnels.name,
                color: this.formNewTagClickFunnels.color,
            }

            this.$store.dispatch('createTagsClickFunnels', payload).then(response => {
                this.isLoadingCreateTagsClickFunnels = false;
                this.$notify({
                    type: 'success',
                    message: `${response.message} ${response.data.name}`,
                    icon: 'tim-icons icon-bell-55'
                });
                this.$refs.formNewTagClickFunnels.resetFields();
                this.formNewTagClickFunnels.name = '';
                this.formNewTagClickFunnels.color = '';
            }, error => {
                this.$notify({
                    type: 'danger',
                    message: error.message,
                    icon: 'tim-icons icon-bell-55'
                });
                this.isLoadingCreateTagsClickFunnels = false;
            })
        },
        getTextColor(backgroundColor) {
            const rgb = this.hexToRgb(backgroundColor);
            const luminance = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
            return luminance > 0.5 ? '#000' : '#fff';
        },
        hexToRgb(hex) {
            const match = hex.match(/^#([0-9a-fA-F]{6})$/);
            if (match) {
                const r = parseInt(match[1].substring(0, 2), 16);
                const g = parseInt(match[1].substring(2, 4), 16);
                const b = parseInt(match[1].substring(4, 6), 16);
                return { r, g, b };
            }
            return { r: 255, g: 255, b: 255 };  // Default to white if the color is invalid
        },
        handleWindowResize(){
            this.isCollapseMenuClickFunnels = window.innerWidth < 768;
            this.windowWidth = window.innerWidth;
        },
        isValidUrl(input) {
            const regex = /^(?!\s*$).{1,254}$/;
            return regex.test(input);
        },
        addUrl() {
            const lastIndex = this.formUrlCodes.length - 1;
            const lastInput = this.formUrlCodes[lastIndex];

            if (lastInput && this.isValidUrl(lastInput.trim()) && this.formUrlCodes.length < 5) {
                this.formUrlCodes.push("");
                this.$nextTick(() => {
                    this.$el.querySelectorAll("input")[this.formUrlCodes.length - 1].focus();
                });
            }
        },
        removeUrl(index) {
            if (this.formUrlCodes.length > 1) {
                this.formUrlCodes.splice(index, 1);
            }
        },
        onActiveUrl(url){
            this.urlActive = url;
        },
        onLoadIframe(){
            setTimeout(() => {
                const id = this.selectedRowData.id;
                const payload = {
                    url_code : this.urlActive,
                    leadspeek_api_id : this.selectedRowData.leadspeek_api_id
                }            
    
                this.$set(this.embedCodeStatus[id], 'isIframeActive', false);
                this.onRunTestEmbedCode(payload, id, this.responseTestEmbedCode.msg_exist, this.responseTestEmbedCode.msg_notexist, this.responseTestEmbedCode.msg_block)
                this.isPopOverCheckEmbedCode = false;
            }, 20000)
        },
        GetListAdvanceInformation() {
            this.isLoadingAdvancedInformation = true;
            this.isErrorAdvancedInformation = false;
            const payload = {
                type: 'local_adv',
            }
            this.$store.dispatch('GetListAdvanceInformationByType',payload)
                .then(response => {
                    this.listAdvancedInformation = response.listAdvanceInformation;

                    this.listAdvancedInformation.forEach((item, index) => {
                        if(item.type == 'contactInformation') {
                            this.listAdvancedInformation[index].description.unshift("Phone1", "Phone2");
                        }
                    });
                    
                    this.isLoadingAdvancedInformation = false;
                })
                .catch(error => {
                    this.isLoadingAdvancedInformation = false;
                    this.isErrorAdvancedInformation = true
                });
        },
        GetListAdvanceInformationB2b() {
            this.isLoadingAdvancedInformationB2b = true;
            this.isErrorAdvancedInformationB2b = false;
            const payload = {
                type: 'local_b2b',
            }
            this.$store.dispatch('GetListAdvanceInformationByType',payload)
                .then(response => {
                    this.listAdvancedInformationB2b = response.listAdvanceInformation;

                    this.listAdvancedInformationB2b.forEach((item, index) => {
                        if(item.type == 'contactInformation') {
                            this.listAdvancedInformationB2b[index].description.unshift("Phone1", "Phone2");
                        }
                    });
                    
                    this.isLoadingAdvancedInformationB2b = false;
                })
                .catch(error => {
                    this.isLoadingAdvancedInformationB2b = false;
                    this.isErrorAdvancedInformationB2b = true
                });
        },
        onCheckItemBasicInformation(type){
            if(type == 'add'){
                const {
                    phoneenabled,
                    homeaddressenabled,
                    requireemailaddress,
                    gtm
                } = this.checkboxes;
    
                if (phoneenabled && homeaddressenabled && requireemailaddress && gtm) {
                    this.checkAllBasic = true;
                } else {
                    this.checkAllBasic = false;
                }
            } else {
                const {
                    phoneenabled,
                    homeaddressenabled,
                    require_email,
                    gtm
                } = this.rowCheckboxes;
    
                if (phoneenabled && homeaddressenabled && require_email && gtm) {
                    this.rowCheckAllBasic = true;
                } else {
                    this.rowCheckAllBasic = false;
                }
            }
        },
        onCheckItemAdvancedInformation(){
            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            const isAllAdvancedSelected = this.idAdvancedInformation.length === listAllIdAdvanced.length;

            if (isAllAdvancedSelected) {
                this.checkAllAdvanced = true;
            } else {
                this.checkAllAdvanced = false;
            }
        },
        onRowCheckItemAdvancedInformation(){
            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            const isAllAdvancedSelected = this.rowIdAdvancedInformation.length === listAllIdAdvanced.length;

            if (isAllAdvancedSelected) {
                this.rowCheckAllAdvanced = true;
            } else {
                this.rowCheckAllAdvanced = false;
            }
        },
        onRowCheckItemAdvancedInformationB2b(){
            const listAllIdAdvanced = this.listAdvancedInformationB2b.map((item) => item.id)
            const isAllAdvancedSelected = this.rowIdAdvancedInformationB2b.length === listAllIdAdvanced.length;

            if (isAllAdvancedSelected) {
                this.rowCheckAllAdvancedB2b = true;
            } else {
                this.rowCheckAllAdvancedB2b = false;
            }
        },
        onCheckItemAdvancedInformationB2b(){
            const listAllIdAdvancedB2b = this.listAdvancedInformationB2b.map((item) => item.id)
            const isAllAdvancedSelectedB2b = this.idAdvancedInformationB2b.length === listAllIdAdvancedB2b.length;

            if (isAllAdvancedSelectedB2b) {
                this.checkAllAdvancedB2b = true;
            } else {
                this.checkAllAdvancedB2b = false;
            }
        },
        onCheckAllBasicInformation(value, type){
            if(type == 'add'){
                if(value == true && this.checkboxes.phoneenabled == false) {
                    this.openPhoneConfirmationModal('checkboxes', 'checkboxes');
                } else {
                    this.checkboxes.phoneenabled = value;
                }
                this.checkboxes.homeaddressenabled = value;
                this.checkboxes.requireemailaddress = value;
                this.checkboxes.gtm = value;
            } else {
                if(value == true && this.rowCheckboxes.phoneenabled == false) {
                    this.openPhoneConfirmationModal('rowCheckboxes', 'selectedRowData');
                } else {
                    this.rowCheckboxes.phoneenabled = value;
                }
                this.rowCheckboxes.homeaddressenabled = value;
                this.rowCheckboxes.require_email = value;
                this.rowCheckboxes.gtm = value;
            }
        },
        onCheckAllAdvancedInformation(value){
            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            this.idAdvancedInformation = value ? listAllIdAdvanced : [];
        },
        onRowCheckAllAdvancedInformation(value){
            const listAllIdAdvanced = this.listAdvancedInformation.map((item) => item.id)
            this.rowIdAdvancedInformation = value ? listAllIdAdvanced : [];
        },
        onRowCheckAllAdvancedInformationB2b(value){
            const listAllIdAdvanced = this.listAdvancedInformationB2b.map((item) => item.id)
            this.rowIdAdvancedInformationB2b = value ? listAllIdAdvanced : [];
        },
        onCheckAllAdvancedInformationB2b(value){
            const listAllIdAdvancedB2b = this.listAdvancedInformationB2b.map((item) => item.id)
            this.idAdvancedInformationB2b = value ? listAllIdAdvancedB2b : [];
        },
        onChangeCampaignInformationData(type) {
            // validation if user change basic infomation
            if(type == 'basic') {
                this.$notify({
                    type: 'danger',
                    message: 'You Cannot Change Basic Information',
                    icon: 'fa fa-bug'
                });
                return;
            }
            // validation if user change basic infomation

            const index = this.campaignInformationData.indexOf(type);
            if (index > -1) {
                this.campaignInformationData.splice(index, 1);
            } else {
                this.campaignInformationData.push(type);
            }
        },
        async onChangeRowCampaignInformationData(type) {
            // validation if user change basic infomation
            if(type == 'basic') {
                this.$notify({
                    type: 'danger',
                    message: 'You Cannot Change Basic Information',
                    icon: 'fa fa-bug'
                });
                return;
            }
            // validation if user change basic infomation

            // validation disabled campaign information
            if(type == 'advanced' && this.selectedRowData.paymentterm != 'Prepaid' && this.cardAdvanceInformationReadOnly) {
                this.$notify({
                    type: 'danger',
                    message: 'You Cannot Change Advanced Information',
                    icon: 'fa fa-bug'
                });
                return;    
            }
            // validation disabled campaign information
            
            const index = this.selectedRowData.campaign_information_type_local.indexOf(type);
            const paymentTerm = this.selectedRowData.paymentterm;

            const hasCurrentTopup = this.current_topup && Object.keys(this.current_topup).length > 0;
            const campaignInformationTypeLocalTopupIncludesBasic = this.current_topup ?
                                                                   this.current_topup.campaign_information_type_local.includes('basic') :
                                                                   false;
            const campaignInformationTypeLocalTopupIncludesAdvanced = this.current_topup ? 
                                                                      this.current_topup.campaign_information_type_local.includes('advanced') :
                                                                      false;

            if (index > -1) { // untuk hapus atau cancel card
                if(
                    type == 'advanced' && 
                    paymentTerm == 'Prepaid' && 
                    hasCurrentTopup &&
                    campaignInformationTypeLocalTopupIncludesBasic &&
                    campaignInformationTypeLocalTopupIncludesAdvanced
                ) {
                    try {
                        await MessageBox.confirm('Your Previous Top Up Prepaid Includes Both Basic Information And Advanced Information. Your Select To Only Basic Information Will Take Effect After The Next Top Up.', {
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                        });
                    } catch (error) {
                        return;
                    }
                }
                this.selectedRowData.campaign_information_type_local.splice(index, 1);
            } else { // untuk tambah atau klik card
                if(
                    type == 'advanced' && 
                    paymentTerm == 'Prepaid' && 
                    hasCurrentTopup &&
                    campaignInformationTypeLocalTopupIncludesBasic &&
                    !campaignInformationTypeLocalTopupIncludesAdvanced
                ) {
                    try {
                        await MessageBox.confirm('Your Previous Top Up Prepaid Included Basic Information Only. Your Select To Basic Information And Advanced Information Will Take Effect After The Next Top Up.', {
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                        });
                    } catch (error) {
                        return;
                    }
                }
                this.selectedRowData.campaign_information_type_local.push(type);
            }
        },
        onValidateInformationData(){
            if(!this.campaignInformationData.includes('advanced')){
                this.idAdvancedInformation = [];
            }

            if(!this.campaignInformationData.includes('b2b')){
                this.idAdvancedInformationB2b = [];
            }
        },
        onRowValidateInformationData(){
            if(!this.selectedRowData.campaign_information_type_local.includes('advanced')){
                this.rowIdAdvancedInformation = [];
            }

            if(!this.selectedRowData.campaign_information_type_local.includes('b2b')){
                this.rowIdAdvancedInformationB2b = [];
            }
        },
        onChangeTopUpType(value){
            const blockTopupTypeContact = ((this.selectedRowData.campaign_information_type_local.includes('advanced') || this.selectedRowData.campaign_information_type_local.includes('b2b')) && value == 'contact');
            const blockTopupTypeMoney = (!this.selectedRowData.campaign_information_type_local.includes('advanced') && !this.selectedRowData.campaign_information_type_local.includes('b2b') && value == 'money')
            
            if(blockTopupTypeContact || blockTopupTypeMoney) {
                let message = "";
                if(blockTopupTypeContact) {
                    message = 'You cannot select the topup type contact because advanced information has been selected.';
                } else if(blockTopupTypeMoney) {
                    message = 'You cannot select the topup type money because advanced information has not been provided.';
                }

                this.$notify({
                    type: 'danger',
                    message: message,
                    icon: 'fas fa-bug'
                })
                
                return false;
            }

            this.topUpType = value;
        },
        onOpenModalConvert(){
            this.modals.convert = true;
        },
        onCloseModalConvert(){
            this.modals.convert = false;
        },
    },

    mounted() {
        this.GetCompanyGroup();
        if(this.$global.settingMenuShow && !this.$global.systemUser && this.$global.creditcardsetup && this.$global.stripeaccountconnected){
            this.steps.splice(2,0,   {
                target: '.client-filter-anchor',  // We're using document.querySelector() under the hood
                content: 'Filter to view only specific clients',
                params: {
                    enableScrolling: false,
                },
            },)
        }
        const userData = this.$store.getters.userData;
        if (userData.user_type == 'client') {
            localStorage.setItem('companyGroupSelected',userData.id);
            this.companyID = userData.company_parent;
        } else {
            this.companyID = userData.company_id;
        }

        const protectAccessMenu = () => {
            if(!this.$global.stripeaccountconnected) {
                if(userData.user_type == 'client') {
                    this.$router.push({ name: 'Profile Setup' });
                } else if (userData.user_type == 'userdownline' || userData.user_type == 'user')  {
                    this.$router.push({ name: 'General Setting' });
                }
                return;
            }
            
            if(userData.user_type == 'client') {
                const sidebar = this.$global.clientsidebar

                if (!sidebar['local']) {
                    this.$router.push({ name: 'Profile Setup' });
                    return;
                } 
                
            } else if (userData.user_type == 'userdownline' || userData.user_type == 'user') {
                const sidebarAgency = this.$global.agency_side_menu && this.$global.agency_side_menu.find(menu => menu.type == 'local')

                if(sidebarAgency && !sidebarAgency.status) {
                    this.$router.push({ name: 'Profile Setup' });
                    return;
                }
            }
        }
        protectAccessMenu();

        this.selectsPaymentTerm.PaymentTerm = this.$global.rootpaymentterm;

        this.leadlocatorname = userData.leadlocatorname;
        this.leadlocalname = userData.leadlocalname;
        if (this.$global.globalviewmode) {
            this.userTypeOri = userData.user_type_ori;
        }

        this.userType = userData.user_type;
        this.checkGoogleConnect();
        this.GetCompanyList();
        this.GetAdministratorList();
        //this.GetClientList();
        this.initial_default_price();
        this.reset();
        window.addEventListener("resize", this.handleWindowResize);

        CHECK_GROUPCOMPANY = setInterval(() => {
            if ((localStorage.getItem('companyGroupSelected') != null) && this.selectsAdministrator.administratorList.length != 0) {
                clearInterval(CHECK_GROUPCOMPANY);
                this.GetClientList();
            }
        }, 1000);
        this.getStateList()

        this.GetListAdvanceInformation();
        this.GetListAdvanceInformationB2b();
    },

    watch: {
        isPopOverCheckEmbedCode(newValue) {
            const isOpen = newValue === true;
            if(isOpen){
                this.urlActive = this.urlActive ? this.urlActive : this.parsedUrls[0];
            }
        },
        LeadspeekEnableMinimumLeadsPerDayAdd(newValue) {
            this.showInputLeadspeekPerDayAdd = (newValue == true) ? true : false;
        },
        LeadspeekEnableMinimumLeadsPerDay(newValue) {
            this.showInputLeadspeekPerDay = (newValue == true) ? true : false;
        },
        'modals.whitelist': function(newValue) {
            if(!newValue) {
                this.supressionProgress = [];
                clearTimeout(this.supressionTimeout);
                clearInterval(this.supressionInterval);
            }
        },
        'modals.campaignEdit': function(newValue){
            if(!newValue) {
                this.GetClientList(this.currSortBy,this.currOrderBy)
            }
        },

        prepaidType(newValue) {
            if(Number(this.totalLeads.oneTime) < Number(this.minimumLeadPrepaidOneTime)) {
                this.totalLeads.oneTime = this.minimumLeadPrepaidOneTime;
                this.err_totalleads = '';
            }
            if(newValue === 'continual') {
                if(this.selectsAppModule.LeadsLimitSelect == 'month' && Number(this.LeadspeekLimitLead) < Number(this.minimumLeadPrepaidContinualLimitDay)) {
                    this.LeadspeekLimitLead = this.minimumLeadPrepaidContinualLimitDay;
                }
                this.profitcalculation();
            }
        },
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        // searchQuery(value) {
        //     let result = this.tableData;
        //     var temp = Array();
        //     if (value !== '') {
        //         result = this.fuseSearch.search(this.searchQuery);
        //         for (let i = 0; i < result.length; i++) {
        //             temp.push(result[i].item);
        //             //console.log(result[i].item);
        //         }
        //         if (result.length != 0) {
        //             this.searchedData = temp;
        //         } else {

        //             if (this.tableData.length > 0) {
        //                 this.tableDataOri = [];
        //                 this.tableDataOri = this.tableData;
        //             }
        //             this.tableData = [];
        //             this.searchedData = "";

        //         }
        //         this.initialSearchFuse();
        //     } else {
        //         if (this.tableData.length == 0) {
        //             this.tableData = this.tableDataOri;
        //         }
        //         this.searchedData = result;
        //         this.initialSearchFuse();
        //     }

        // }
    },
    beforeDestory(){
        window.removeEventListener("resize", this.handleWindowResize);

        const inputGhlTags = this.$refs.selectGhlTags.$el.querySelector('.select-integration-ghl .el-select__input');
        if (inputGhlTags) {
            inputGhlTags.removeEventListener('keyup', this.keydownInputGhlTags);
        }
    }
}
</script>
<style scoped>
@media (min-width: 768px) {
    .inputCostPerContact {
        margin-top: 23.5px;
    }
    .inputCostPerContactEnableMinimum {
        margin-top: -4px;
    }
    .containerMinimumLeadsPerDay {
        margin-top: -5px;
    }
}

.spinRefund {
  animation: spinRefund 1s linear infinite;
}
@keyframes spinRefund {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<style>
.container-checkbox-item-advanced-information {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 991.98px) {
	.container-checkbox-item-advanced-information {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 575.98px) { 
	.container-checkbox-item-advanced-information {
        grid-template-columns: repeat(1, 1fr);
    }
}

.checkbox-advanced-information .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #686868;
}

.checkbox-advanced-information .el-checkbox__inner {
    border-color: #686868;
    border-radius: 3px;
}

.checkbox-advanced-information .el-checkbox__inner:hover {
    border-color: #686868;
}

.checkbox-advanced-information .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #000000;
}

.checkbox-advanced-information .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #686868;
    background-color: #686868;
    border-radius: 3px;
}

.checkbox-advanced-information .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #686868;
    background-color: #686868;
}

.el-card__body {
  padding: 10px 20px !important;
}
.select-integration-ghl .el-tag.el-tag--info.el-tag--small.el-tag--light.red-tag {
    background-color: red !important;
    color: white !important;
}

.input-contact-per-day .el-input__inner {
    padding: 0 10px 0 10px;
    border-radius: 0px 4px 4px 0px;
    border-left: none;
    color: #222a42 !important;
    font-weight: 600;
}

.input-append-contact-per-month .el-input__inner {
    height: 41.36px !important;
}

.mailboxzipcode .el-textarea__inner {
    line-height: 2;
}

.popProcessing {
    font-weight: bold;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    position: fixed;
    color: gray;
    background-color: white;
    height: 60px;
    width: 320px;
    padding-left: 30px;
    padding-top: 18px;
    border: 1px solid green;
}

.qanswer {
    font-weight: bold;
    font-style: italic;
    padding-bottom: 10px;
}



.clickable-rows td {
    cursor: pointer;
}

/* .clickable-rows .el-table,
.el-table__expanded-cell {
    background-color: #1e1e2f;
} */

.clickable-rows tr .el-table__expanded-cell {
    cursor: default;
}

.select-fullwidth {
    width: 100%;
}

.perleads {
    width: 60px;
    display: inline-block !important;
}

.table .form-check label .form-check-sign::before,
.el-table table .form-check label .form-check-sign::before,
.table .form-check label .form-check-sign::after,
.el-table table .form-check label .form-check-sign::after {
    top: 3px;
    left: 0px;
}

.green {
    color: green;
}

.red {
    color: red;
}

.gray {
    color: #6c757d;
}

.orange {
    color: #fb6340;
}

.cursordefault {
    cursor: default;
}

.cursornodrop {
    cursor: no-drop;
}

.el-table__fixed-right::before,
.el-table__fixed::before {
    background-color: transparent;
}

tr.hover-row>td {
    background-color: transparent !important;
}

.el-table__fixed-body-wrapper .el-table__row>td:not(.is-hidden) {
    border-top: transparent !important;
}

.integratios-list-wrapper {
    gap: 8px;
}

.integrations__modal-item-wrapper {
    position: relative;
    min-height: 100px;
    max-height: 100px;
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 16px;
}

.integrations__modal-item {
    width: 96px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
}

/* .integrations__modal-item.--active{
    
} */
.integrations__modal-item-wrapper:hover {
    background-color: #5e72e4 !important;
    color: #f4f5f7 !important;
}

.integrarion-brand-name {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400px;
}

.integrations-modal-footer-wrapper {
    padding: 12px 24px;
    width: 100%;
}

.integrations-modal-footer-wrapper .d-flex {
    gap: 16px;
}

.warning-banner {
    padding: 8px 16px;
    /* background-color: #ecf8ff; */
    background-color: #ffecec;
    border-radius: 4px;
    /* border-left: 5px solid #50bfff; */
    border-left: 5px solid #ff5050;
    margin: 20px 0;
    font-size: 14px;
    color: #5e6d82;
    line-height: 1.5em;
}

.warning-banner p {
    margin: 0;
}

.add-new-integration-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    border: 1px dotted rgb(155, 155, 155);
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 16px;
    transition: all 0.5s ease-in-out;
}

.add-new-integration-wrapper i {
    transition: all 0.5s ease-in-out;
    user-select: none;
}

.add-new-integration-wrapper:hover i {
    transform: rotate(180deg);
}

.add-new-integration-wrapper:hover {
    border-color: rgb(120, 120, 120);
}
.client-payment-modal-form-label{
    color:#222a42 !important;
    font-size:16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 8px;
    display: block;
}
.client-payment-modal-form-helper-text-error {
    color:#942434 !important;
    font-size:12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: 4px;
    display: block;
}
.client-payment-modal-form-helper-text{
    color:#6b7280 !important;
    font-size:12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: 4px;
    display: block;
}
.client-payment-setup-form-wrapper{
    display: flex;
    flex-direction: column;
    gap: 24px;

}

.alert-li{
color:initial !important;
}
.el-tabs__nav {
    width: 100%;
}
.el-tabs__item{
    width: 50%;
}
.el-badge__content{
    height: 20px;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
    color: #222a42 !important;
    font-weight: 600 !important;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
    color: #222a42 !important;
}
.el-badge__content--info{
    background-color:#409EFF;
}

.container__input__campaign__management {
    /* padding-inline: 16px; */
}

.input__campaign__management {
    width: 22vw;
}

.container__filter__campaign__management {
    /* padding-inline: 16px; */
    margin-top: -2px;
}

.button_add__client__campaign__management {
    margin-inline: 16px;
}

.dropdown-hidden {
  display: none !important;
}


.input__campaign__management .el-input__inner {
    padding-left: 30px;
    padding-right: 30px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}
.el-form--label-top .el-form-item__label {
    padding: 0;
}

.el-form-item {
    margin-bottom: 16px;
}

.click-funnels-tag-select .el-select__tags {
  display: none;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-item {
  display: flex;
  align-items: center;
  padding: 6px 10px; 
  border-radius: 6px;
  border: 1px solid;
  word-wrap: break-word; 
  word-break: break-word;
  white-space: normal;
}

.tag-text {
  flex: 1;
  overflow-wrap: break-word;
  font-size: 12px;
}

.close-icon {
  margin-left: 6px;
  cursor: pointer;
}

.skeleton-tag {
  width: 80px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 6px;
  margin-right: 8px;
  margin-bottom: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}

.grid-container-campaign-information-local {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.tooltip-content {
  max-width: 300px;
  white-space: normal;
  word-break: break-word;
}


@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 991.98px) {
    
    .input__campaign__management {
        width: 100%;
    }
    .container__input__campaign__management {
        width: 100%;
    }
}

@media (max-width: 991px) { 
    .small-width-full{
        width: 100%;
    }
    .container__filter__campaign__management {
        width: 100%;
    }
    .dropdown__filter__campaign__management {
        width: 100%;
    }
    .button__filter__campaign__management {
        width: 100%;
    }
    .button_add__client__campaign__management {
        margin-inline: 0px;
    }
    .input__campaign__management{
        margin-bottom: 4px;
    }
}

@media (max-width: 768px) { 
    .grid-container-campaign-information-local {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 575.98px) { 
    .grid-container-campaign-information-local {
        grid-template-columns: repeat(1, 1fr);
    }
}

.add-webhook-url{
    height: 40px;
    width: 40px;
    background: gray;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    color: white;
}
.webhook-url-wrapper{
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
}

.el-alert .el-alert__description {
    margin: 0px;
}

.error-banner {
    padding: 8px 16px;
    background-color: #ffe6e6; /* Light red background for error */
    border-radius: 4px;
    border-left: 5px solid #dc3545; /* Red border for error */
    margin: 20px 0;
    font-size: 14px;
    color: #721c24; /* Darker red text for readability */
    line-height: 1.5em;
}

.error-banner p {
    margin: 0;
}

.success-banner {
    padding: 8px 16px;
    background-color: #e6ffed; /* Light green background */
    border-radius: 4px;
    border-left: 5px solid #28a745; /* Green border */
    margin: 20px 0;
    font-size: 14px;
    color: #2f4f4f; /* Darker green text for readability */
    line-height: 1.5em;
}

.success-banner p {
    margin: 0;
}

.info-banner {
    padding: 8px 16px;
    background-color: #e6f7ff; /* Light blue background for info */
    border-radius: 4px;
    border-left: 5px solid #17a2b8; /* Blue border for info */
    margin: 20px 0;
    font-size: 14px;
    color: #3c8dbc; /* Darker blue text for readability */
    line-height: 1.5em;
}

.info-banner p {
    margin: 0;
}

.warning-banner {
    padding: 8px 16px;
    background-color: #ffb;
    border-radius: 4px;
    border-left: 5px solid #e68a00; 
    margin: 20px 0;
    font-size: 14px;
    color: #3c8dbc;
    line-height: 1.5em;
}

.warning-banner p {
    margin: 0;
} 

.select__form__client .el-input__inner {
    border-radius: 0.4285rem;
}

.gsheet-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  /* grid-template-columns: repeat(auto-fit, minmax(120px, auto)); */
  gap: 10px;
}

.gsheet-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f7f7;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: background-color 0.2s;
}

.gsheet-item:hover {
  background-color: #e0e0e0;
  transition: background-color 0.2s ease;
}

.history-grid {
  display: grid;
  /* grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); */
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.history-label {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f7f7;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: background-color 0.2s;
}

.history-item:hover {
  background-color: #e0e0e0;
  transition: background-color 0.2s ease;
}

.campaign-information-active-local {
  border: 1px solid #409EFF;
}

.campaign-information-disabled-local {
    opacity: 0.5;
    cursor: default !important;
}

.input-total-amount-topup {
    opacity: 1 !important;
    background-color: transparent !important;
    color: black !important;
}

.form-converter {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}

.form-converter > div {
    flex: 1;
    min-width: 0;
}

.icon-converter {
    display: flex;
    background-color: #222a42;
    padding: 10px;
    margin-top: 16px;
    border-radius: 16px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.3);
    align-items: center;
}

.icon-converter i {
    font-size: 20px;
    color: white;
}

.select__balance .el-input__inner {
    color: #409EFF !important;
}

.check-icon {
    position: absolute;
    top: 6px;
    right: 6px;
    background-color: #22c55e;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    animation: popIn 0.25s ease-out;
}

@media (max-width: 568px) {
    .form-converter {
        flex-direction: column;
        gap: 0px !important;
    }
    .form-converter > div {
        flex: 1;
        min-width: 0;
        width: 100%;
    }
    .icon-converter {
        margin-top: 16px;
    }
}
</style>